export default {
  "messages": {
    "payment_terms": "Condiciones de pago:",
    "primary_contact": "Contacto principal:",
    "outstanding_invoices": "Facturas pendientes",
    "invoice": "N.º de factura",
    "bill_date": "Fecha de factura del proveedor",
    "due_date": "Fecha de vencimiento",
    "days_past_due": "Días de retraso",
    "balance_due": "Saldo pendiente",
    "status": "Estado",
    "actions": "Acciones",
    "draft": "Borrador",
    "view": "Ver",
    "no_outstanding_posted_bills_for_this_supplier": "Este proveedor no tiene facturas contabilizadas pendientes.",
    "close": "Cerrar",
    "pay_selected_bills": "Pagar las facturas seleccionadas",
    "payment_date": "Fecha de pago",
    "payment_method": "Forma de pago",
    "select_method": "Selecciona una forma de pago",
    "bank_account": "Cuenta bancaria",
    "select_bank_account": "Selecciona una cuenta bancaria",
    "bank_account_required_for_bank_payments": "Se requiere una cuenta bancaria para los pagos bancarios.",
    "reference_memo": "Referencia / Concepto",
    "pay_full_balances": "Pagar los saldos completos",
    "supplier": "Proveedor",
    "amount_to_pay": "Importe a pagar",
    "no_bills_selected": "No hay facturas de proveedor seleccionadas.",
    "total_to_pay": "Total a pagar",
    "cancel": "Cancelar",
    "bill_details": "Detalles de la factura del proveedor",
    "loading_bill_details": "Cargando los detalles de la factura del proveedor…",
    "description": "Descripción",
    "qty": "Cant.",
    "unit_price": "Precio unitario",
    "amount": "Importe",
    "no_line_items_recorded": "No hay líneas registradas.",
    "reference": "Referencia",
    "method": "Método",
    "allocated": "Aplicado",
    "no_allocations_recorded": "No hay aplicaciones registradas.",
    "no_bill_found": "No se encontró la factura del proveedor.",
    "vendor": "Proveedor",
    "search_suppliers": "Buscar proveedores…",
    "loading_suppliers": "Cargando proveedores…",
    "no_suppliers_found": "No se encontraron proveedores.",
    "vendor_is_required": "El proveedor es obligatorio.",
    "vendor_invoice": "N.º de factura del proveedor",
    "invoice_number_is_required": "El número de factura es obligatorio.",
    "show_all_account_types": "Mostrar todos los tipos de cuenta",
    "loading_accounts": "Cargando cuentas…",
    "loading_dimensions": "Cargando dimensiones…",
    "loading_tax_codes": "Cargando códigos fiscales…",
    "tax_codes_failed_to_load_defaulting_to_no_tax": "No se pudieron cargar los códigos fiscales. Se utilizará «Sin impuestos».",
    "tax_code": "Código fiscal",
    "gl_account": "Cuenta del libro mayor",
    "dimension": "Dimensión",
    "no_tax": "Sin impuestos",
    "tax": "Impuestos",
    "select_account": "Selecciona una cuenta",
    "no_dimension": "Sin dimensión",
    "add_at_least_one_line_with_an_amount": "Añade al menos una línea con un importe.",
    "add_line": "Añadir línea",
    "total": "Total",
    "notes": "Notas",
    "optional_notes": "Notas opcionales",
    "saving": "Guardando...",
    "record_ap_payment": "Registrar pago a proveedores",
    "payment_amount": "Importe del pago",
    "paid_date": "Fecha de pago",
    "apply": "Aplicar",
    "allocate": "Aplicar",
    "draft_2": "Borrador",
    "allocated_total": "Total aplicado",
    "unapplied_amount": "Importe sin aplicar",
    "recording": "Registrando…",
    "record_payment": "Registrar pago",
    "from": "Desde",
    "to": "Hasta",
    "generate": "Generar",
    "opening_balance": "Saldo de apertura",
    "closing_balance": "Saldo de cierre",
    "bill": "Factura del proveedor",
    "no_bills_found_for_this_period": "No se encontraron facturas de proveedor para este período.",
    "no_payments_found_for_this_period": "No se encontraron pagos para este período.",
    "select_a_date_range_to_generate_a_statement": "Selecciona un intervalo de fechas para generar un extracto.",
    "employee": "Empleado",
    "unassigned": "Sin asignar",
    "retry": "Reintentar",
    "generating": "Generando…",
    "generated": "Generado",
    "sending": "Enviando…",
    "privana_assist": "Privana Assist",
    "warning": "Advertencia",
    "employees": "Empleados",
    "rate": "Tasa",
    "calendar": "Calendario",
    "team_member": "Miembro del equipo",
    "creating": "Creando…",
    "saving_2": "Guardando…",
    "cancel_close": "Cancelar / Cerrar",
    "save_changes": "Guardar cambios",
    "profile": "Perfil",
    "pending": "pendiente",
    "currency": "Moneda",
    "tax_code_2": "Código fiscal",
    "audit_trail": "Historial de auditoría",
    "system": "Sistema",
    "account": "Cuenta",
    "debit": "Debe",
    "credit": "Haber",
    "preview": "Vista previa",
    "status_filter": "Filtro de estado",
    "all_statuses": "Todos los estados",
    "submit": "Enviar",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "save_draft": "Guardar borrador",
    "loading": "Cargando…",
    "adjustments": "Ajustes",
    "working": "Procesando…",
    "posted": "Contabilizada",
    "next_step": "Siguiente paso",
    "publishing": "Publicando…",
    "hide": "Ocultar",
    "audit_trail_2": "Historial de auditoría",
    "needs_review": "Requiere revisión",
    "configured": "Configurado",
    "default": "Predeterminado",
    "edit": "Editar",
    "active": "activo",
    "archived": "Archivado",
    "manual": "Manual",
    "priority": "Prioridad:",
    "review": "Revisar",
    "suppliers": "Proveedores",
    "payroll": "Nóminas",
    "statement": "Declaración",
    "void": "Anulada",
    "date": "Fecha",
    "manage": "Gestionar",
    "payment_amount_2": "Importe del pago",
    "select_gl_account": "Selecciona una cuenta del libro mayor",
    "set_as_default": "Establecer como predeterminada",
    "name": "Nombre",
    "save": "Guardar",
    "bank_reconciliation": "Conciliación bancaria",
    "refresh": "Actualizar",
    "all_status": "Todos los estados",
    "unmatched": "Sin conciliar",
    "reviewed_unmatched": "Revisada (sin conciliar)",
    "matched": "Conciliada",
    "disputed": "En disputa",
    "all": "Todo",
    "reviewed": "Revisada",
    "unreviewed": "Sin revisar",
    "bank_reconciliation_settings": "Configuración de conciliación bancaria",
    "edit_bank_accounts": "Editar cuentas bancarias",
    "upload_statement_csv": "Subir extracto (CSV)",
    "matched_transactions": "Transacciones conciliadas",
    "automatch_rate": "Porcentaje de conciliación automática",
    "reconciliation_session": "Sesión de conciliación",
    "not_ready": "No está listo",
    "reviewed_unmatched_2": "Revisada, sin conciliar",
    "statement_period": "Período del extracto",
    "staff": "Personal",
    "bank_transactions": "Transacciones bancarias",
    "mark_reviewed": "Marcar como revisada",
    "mark_unreviewed": "Marcar como no revisada",
    "select_all_transactions": "Seleccionar todas las transacciones",
    "match_confidence": "Confianza de la conciliación",
    "find_match": "Buscar coincidencia",
    "upload_statement_csv_2": "Subir extracto CSV",
    "choose_csv_file": "Elige un archivo CSV",
    "first_row_is_header": "La primera fila contiene encabezados",
    "strip_currency_symbols": "Eliminar símbolos de moneda",
    "parsing_csv": "Procesando CSV…",
    "date_column": "Columna de fecha *",
    "select_column": "Selecciona una columna",
    "description_column": "Columna de descripción *",
    "amount_signed": "Importe (con signo)",
    "debit_column": "Columna del debe",
    "credit_column": "Columna del haber",
    "reference_column": "Columna de referencia",
    "date_format": "Formato de fecha",
    "select_format": "Selecciona un formato",
    "running_balance_column": "Columna de saldo acumulado",
    "direction": "Dirección",
    "date_range": "Intervalo de fechas",
    "total_inflows": "Total de entradas",
    "total_outflows": "Total de salidas",
    "force_import_duplicates": "Forzar la importación de duplicados",
    "continue": "Continuar",
    "import": "Importar",
    "view_details": "Ver detalles",
    "actual": "Real",
    "budget": "Presupuesto",
    "difference": "Diferencia",
    "department": "Departamento",
    "variance": "Variación",
    "chart_of_accounts": "Plan de cuentas",
    "manage_account_codes_used_in_the_general_ledger": "Gestiona los códigos de cuenta utilizados en el libro mayor.",
    "back_to_general_ledger": "Volver al libro mayor",
    "new_account": "Nueva cuenta",
    "search_by_code_or_name": "Buscar por código o nombre",
    "code": "Código",
    "type": "Tipo",
    "no_accounts_found": "No se encontraron cuentas.",
    "activate": "Activar",
    "deactivate": "Desactivar",
    "define_the_account_code_and_defaults_for_this_gl_account": "Define el código y los valores predeterminados de esta cuenta del libro mayor.",
    "account_code": "Código de cuenta",
    "account_name": "Nombre de cuenta",
    "subtype": "Subtipo",
    "optional": "Opcional",
    "inactive_accounts_are_hidden_by_default": "Las cuentas inactivas se ocultan de forma predeterminada.",
    "manager": "Responsable",
    "create": "Crear",
    "update": "Actualizar",
    "credit_amount": "Importe del abono",
    "reason": "Motivo",
    "refund": "Reembolso",
    "billing_adjustment": "Ajuste de facturación",
    "courtesy_credit": "Abono de cortesía",
    "billing_error": "Error de facturación",
    "promotional_credit": "Abono promocional",
    "detailed_description_of_the_credit": "Descripción detallada del abono…",
    "issue_credit": "Emitir abono",
    "dimensions": "Dimensiones",
    "manage_reporting_dimensions_for_revenue_and_expenses": "Gestiona las dimensiones de los informes de ingresos y gastos.",
    "new_dimension": "Nueva dimensión",
    "no_dimensions_found": "No se encontraron dimensiones.",
    "define_the_code_and_name_used_for_reporting_dimensions": "Define el código y el nombre de las dimensiones de los informes.",
    "type_optional": "Tipo (opcional)",
    "inactive_dimensions_are_hidden_by_default": "Las dimensiones inactivas se ocultan de forma predeterminada.",
    "create_report": "Crear informe",
    "report_name": "Nombre del informe",
    "report_type": "Tipo de informe",
    "profit_loss": "Pérdidas y ganancias",
    "balance_sheet": "Balance de situación",
    "trial_balance": "Balance de sumas y saldos",
    "ap_aging": "Antigüedad de cuentas a pagar",
    "ar_aging": "Antigüedad de cuentas a cobrar",
    "budget_vs_actual": "Presupuesto frente a real",
    "format": "Formato",
    "select_budget": "Selecciona un presupuesto",
    "budget_version": "Versión del presupuesto",
    "select_version": "Selecciona una versión",
    "date_range_2": "Intervalo de fechas",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha de fin",
    "granularity": "Nivel de detalle",
    "category": "Categoría",
    "schedule_this_report": "Programar este informe",
    "frequency": "Frecuencia",
    "daily": "Diariamente",
    "weekly": "Semanalmente",
    "quarterly": "Trimestral",
    "delivery": "Entrega",
    "privana_inbox": "Bandeja de entrada de Privana",
    "email": "Correo electrónico",
    "save_report": "Guardar informe",
    "saved_scheduled_reports": "Informes guardados y programados",
    "next_run": "Próxima ejecución",
    "run_now": "Ejecutar ahora",
    "download": "Descargar",
    "no_data_available_for_the_selected_range": "No hay datos disponibles para el intervalo seleccionado.",
    "no_rows_returned_for_this_report_scope": "No se devolvieron filas para el ámbito de este informe.",
    "no_eligible_allocations_found": "No se encontraron aplicaciones elegibles.",
    "select": "Seleccionar",
    "counterparty": "Contraparte",
    "match": "Partido",
    "match_full": "Conciliar el importe completo",
    "over_allocated": "Importe aplicado en exceso",
    "recommended": "Recomendado",
    "member": "Socio",
    "no_match_items_selected": "No hay elementos seleccionados para conciliar.",
    "clear_match": "Eliminar conciliación",
    "save_match": "Guardar conciliación",
    "close_checklist": "Lista de comprobación del cierre",
    "no_tasks_configured": "No hay tareas configuradas.",
    "staff_2": "miembros del personal",
    "save_notes": "Guardar notas",
    "view_period_events": "Ver eventos del período",
    "no_events_recorded_for_this_period_yet": "Todavía no hay eventos registrados para este período.",
    "period_actions": "Acciones del período",
    "this_period_cannot_be_closed_yet": "Este período todavía no se puede cerrar.",
    "close_reason_optional": "Motivo del cierre (opcional)",
    "close_month": "Cerrar mes",
    "lock_reason_optional": "Motivo del bloqueo (opcional)",
    "required_tasks_incomplete": "Tareas obligatorias incompletas",
    "complete_required_tasks_or_provide_an_override_reason_to_lock": "Completa las tareas obligatorias o indica un motivo de excepción para bloquear este período.",
    "override_reason_required_to_lock": "Motivo de excepción (obligatorio para bloquear)",
    "override_lock": "Aplicar excepción y bloquear",
    "unlock_reason_required": "Motivo del desbloqueo (obligatorio)",
    "reopen_reason_required": "Motivo de la reapertura (obligatorio)",
    "close_pack_snapshot": "Instantánea del expediente de cierre",
    "no_snapshots_have_been_run": "No se han generado instantáneas.",
    "view_report": "Ver informe",
    "no_activity_recorded_for_this_period": "No hay actividad registrada para este período.",
    "this_trial_balance_contains_no_posted_journal_activity_for_the": "Este balance de sumas y saldos no contiene asientos contabilizados para el período seleccionado.",
    "total_debits": "Total del debe",
    "total_credits": "Total del haber",
    "periods": "Períodos",
    "monitor_closelock_status_by_fiscal_period": "Supervisa el estado de cierre y bloqueo de cada período contable.",
    "checklist": "Lista",
    "closed": "Cerrado",
    "locked": "Bloqueado",
    "loading_periods": "Cargando períodos…",
    "no_periods_exist_for_this_year": "No hay períodos para este ejercicio.",
    "blocked_by_earlier_periods": "Bloqueado por períodos anteriores",
    "general_ledger_settings": "Configuración del libro mayor",
    "monthend_configuration": "Configuración del cierre mensual",
    "general_ledger": "Libro mayor",
    "search_by_account_memo": "Buscar por cuenta o concepto…",
    "close_periods_permission_required": "Se requiere permiso para cerrar períodos",
    "memo": "Concepto",
    "loading_entries": "Cargando asientos…",
    "no_general_ledger_entries_found": "No se encontraron asientos en el libro mayor.",
    "view_periods": "Ver períodos",
    "loading_invoice": "Cargando factura…",
    "revenue_was_posted_by_the_operational_source_transactions_before_invoicing": "Los ingresos se contabilizaron mediante las transacciones operativas de origen antes de la facturación.",
    "gl_posted_via_source_transactions": "Contabilizado en el libro mayor mediante las transacciones de origen",
    "posted_to_gl": "Contabilizada en el libro mayor",
    "post_to_gl": "Contabilizar en el libro mayor",
    "message": "—",
    "billed_to": "Facturado a:",
    "issue_date": "Fecha de emisión:",
    "due_date_2": "Fecha de vencimiento:",
    "quantity": "Cantidad",
    "search_gl_accounts": "Buscar cuentas del libro mayor…",
    "no_gl_account": "Sin cuenta del libro mayor",
    "select_dimension": "Selecciona una dimensión",
    "search_dimensions": "Buscar dimensiones…",
    "loading_chart_of_accounts": "Cargando el plan de cuentas…",
    "subtotal": "Subtotal:",
    "tax_2": "Impuestos:",
    "total_2": "Total:",
    "payments": "Pagos:",
    "balance_due_2": "Saldo pendiente:",
    "tax_codes_required": "Se requieren códigos fiscales",
    "these_taxable_invoice_lines_do_not_have_a_tax_code": "Estas líneas de factura sujetas a impuestos no tienen un código fiscal seleccionado.",
    "invoice_line": "Línea de factura",
    "one_or_more_taxable_invoice_lines_need_a_tax_code": "Una o más líneas de factura sujetas a impuestos necesitan un código fiscal antes de contabilizarse.",
    "review_invoice_lines": "Revisar las líneas de la factura",
    "tax_code_gl_mapping_required": "Se requiere la asignación contable del código fiscal",
    "this_invoice_cannot_be_posted_to_the_general_ledger_because": "Esta factura no se puede contabilizar en el libro mayor porque estos códigos fiscales no tienen una cuenta de IVA repercutido. Ve a Configuración del club → Contabilidad → Códigos fiscales para establecerla.",
    "line": "línea",
    "lines": "líneas",
    "one_or_more_taxable_invoice_lines_use_tax_codes_without": "Una o más líneas de factura sujetas a impuestos utilizan códigos fiscales sin cuenta de IVA repercutido.",
    "fix_tax_code_mappings": "Corregir las asignaciones de códigos fiscales",
    "accounting_settings_required": "Se requiere configurar la contabilidad",
    "to_post_this_invoice_complete_the_missing_accounting_defaults": "Para contabilizar esta factura, completa los valores contables predeterminados que faltan.",
    "accounting_settings_are_incomplete": "La configuración contable está incompleta.",
    "not_now": "Ahora no",
    "configure_accounting_settings": "Configurar la contabilidad",
    "accounting_settings": "Configuración contable",
    "set_the_default_gl_accounts_used_when_posting_invoices": "Establece las cuentas del libro mayor predeterminadas para contabilizar facturas.",
    "ar_control_account": "Cuenta de control de cuentas a cobrar",
    "select_an_account": "Selecciona una cuenta",
    "required_to_post_invoices": "Obligatoria para contabilizar facturas.",
    "default_revenue_account": "Cuenta de ingresos predeterminada",
    "required_when_invoice_lines_are_missing_gl_accounts": "Obligatoria cuando las líneas de factura no tienen cuentas del libro mayor.",
    "vat_control_account_optional": "Cuenta de control del IVA (opcional)",
    "required_when_vat_is_applied": "Obligatoria cuando se aplica IVA.",
    "create_manual_invoice": "Crear factura manual",
    "search_member_name_or": "Buscar por nombre o número de socio",
    "issue_date_2": "Fecha de emisión",
    "amounts_are": "Los importes son",
    "exclusive_of_tax": "Sin impuestos incluidos",
    "inclusive_of_tax": "Con impuestos incluidos",
    "choose_how_unit_prices_are_entered_on_this_invoice": "Elige cómo se introducen los precios unitarios en esta factura.",
    "line_items": "Líneas de factura",
    "loading_categories": "Cargando categorías…",
    "price": "Precio",
    "select_tax_code": "Selecciona un código fiscal",
    "tax_exempt": "Exento de impuestos",
    "tax_codes_ignored_when_no_tax_is_selected": "Los códigos fiscales no se aplican al seleccionar «Sin impuestos».",
    "not_effective_for_issue_date": "No está vigente en la fecha de emisión.",
    "select_category": "Selecciona una categoría",
    "no_category": "Sin categoría",
    "add_item": "Añadir artículo",
    "internal_notes_or_comments_for_the_member": "Notas internas o comentarios para el socio…",
    "save_draft_invoice": "Guardar factura en borrador",
    "club_name": "Nombre del club",
    "club_address": "Dirección del club",
    "invoice_2": "Factura",
    "bill_to": "Facturar a",
    "subtotal_2": "Subtotal",
    "amount_due": "Importe pendiente",
    "invoice_preview": "Vista previa de la factura",
    "member_invoicing": "Facturación a socios",
    "search_member_or_invoice": "Buscar por socio o número de factura",
    "paid_credited": "Pagado / Abonado",
    "no_invoices_found_for_this_club": "No se encontraron facturas para este club.",
    "transactions": "Transacciones",
    "payment": "Pago",
    "pos_sale": "Venta POS",
    "issued": "Emitida",
    "refunded": "Reembolsado",
    "auto_allocate": "Aplicar automáticamente",
    "status_2": "Estado:",
    "reason_2": "Motivo:",
    "yes": "Sí",
    "no": "No",
    "record_member_payment": "Registrar pago de un socio",
    "unable_to_resolve_a_member_account": "No se pudo obtener la cuenta del socio.",
    "resolving_member_account": "Obteniendo la cuenta del socio…",
    "received_date": "Fecha de recepción",
    "use_pos_cash_float": "Usar el fondo de caja del TPV",
    "apply_to_invoices": "Aplicar a facturas",
    "less_allocated": "Menos importe aplicado",
    "remaining_unapplied": "Importe restante sin aplicar",
    "allocate_later_leave_as_credit": "Aplicar más adelante (dejar como saldo a favor)",
    "open_balance": "Saldo pendiente",
    "allocation": "Aplicación",
    "no_open_invoices_to_allocate": "No hay facturas pendientes a las que aplicar el pago.",
    "club_logo": "Logotipo del club",
    "unit": "Unidad",
    "loading_events": "Cargando eventos...",
    "search_staff": "Buscar personal…",
    "type_at_least_2_characters_to_search": "Escribe al menos 2 caracteres para buscar.",
    "searching": "Buscando...",
    "no_staff_found": "No se encontró personal.",
    "order": "Pedir",
    "any": "cualquiera",
    "location": "Ubicación",
    "new": "Nuevo",
    "credit_card": "Tarjeta de crédito",
    "cash": "Efectivo",
    "tax_rate": "Tipo impositivo (%)",
    "date_2": "Fecha:",
    "other": "Otro",
    "bank_transfer": "Transferencia bancaria",
    "check": "Cheque",
    "autopay": "Pago automático",
    "reference_number": "Número de referencia",
    "check_number_transaction_id_etc": "Número de cheque, identificador de transacción, etc.",
    "additional_payment_notes": "Notas adicionales del pago…",
    "pending_2": "Pendiente",
    "member_name": "Nombre del socio",
    "net": "Neto",
    "record_receivable_payment": "Registrar pago de una cuenta a cobrar",
    "debtor": "Deudor:",
    "unlabelled_debtor": "Deudor sin nombre",
    "description_2": "Descripción:",
    "outstanding": "Pendiente:",
    "previous": "Anterior",
    "next": "Siguiente",
    "outstanding_2": "Pendiente",
    "paid": "Pagada",
    "source": "Fuente:",
    "confirm": "Confirmar",
    "recipient": "Destinatario",
    "pause": "Pausar",
    "resume": "Reanudar",
    "membership_type": "Tipo de membresía",
    "member_2": "miembro",
    "group": "Grupo",
    "groups": "Grupos",
    "item": "Artículo",
    "items": "elementos",
    "scheduled": "programadas",
    "card": "Tarjeta",
    "open": "abierto",
    "year": "Año",
    "select_member": "Seleccionar socio",
    "loading_members": "Cargando socios…",
    "annual": "Anual",
    "payment_terms_2": "Condiciones de pago",
    "label": "Etiqueta",
    "effective_from": "Vigente desde",
    "select_tax_code_2": "Seleccionar código fiscal",
    "no_tax_code": "Sin código fiscal",
    "yearend_assistant": "Asistente de cierre anual",
    "payroll_trend": "Evolución de nóminas",
    "payroll_sections": "Secciones de nóminas",
    "loading_payroll_data": "Cargando los datos de nóminas…",
    "payroll_data_could_not_be_loaded": "No se pudieron cargar los datos de nóminas.",
    "no_payroll_records_yet_defaults_are_ready_for_configuration": "Todavía no hay registros de nóminas. Los valores predeterminados están listos para configurar.",
    "payroll_documents": "Documentos de nóminas",
    "payroll_setup_wizard": "Asistente de configuración de nóminas",
    "current_payroll_cycle": "Ciclo de nómina actual",
    "journal_preview": "Vista previa del asiento",
    "current_payroll_run": "Proceso de nómina actual",
    "review_payroll": "Revisar nóminas",
    "payroll_command_centre": "Centro de gestión de nóminas",
    "no_current_payroll_run": "No hay un proceso de nómina actual",
    "create_the_next_payroll_run_to_review_employees_timesheets_blockers": "Crea el próximo proceso de nómina para revisar empleados, partes de horas, bloqueos, aprobaciones, datos legales y contabilidad en un espacio guiado.",
    "create_next_payroll_run": "Crear el próximo proceso de nómina",
    "payroll_progress": "Progreso de nóminas",
    "payroll_readiness": "Preparación de nóminas",
    "ready": "Preparado",
    "open_details_and_actions": "Abrir detalles y acciones",
    "privana_assist_will_show_next_actions_when_backend_readiness_checks": "Privana Assist mostrará las próximas acciones cuando las comprobaciones del servidor detecten algo que revisar.",
    "no_payroll_trend_data_yet": "Todavía no hay datos de evolución de nóminas",
    "department_split_by_gross_pay": "Distribución departamental del salario bruto",
    "no_department_weighting_yet": "Todavía no hay distribución por departamentos",
    "payroll_blockers": "Bloqueos de nóminas",
    "open_payroll_run": "Abrir proceso de nómina",
    "no_blockers_found_this_readiness_tile_is_clear": "No se encontraron bloqueos. Esta comprobación está resuelta.",
    "manage_staff_pay_readiness_with_employeefirst_cards": "Gestiona la preparación del pago al personal mediante fichas de empleados.",
    "search_employees": "Buscar empleados",
    "add_employee": "Añadir empleado",
    "payroll_employee_actions": "Acciones de nómina del empleado",
    "departments": "Departamentos",
    "bank": "✓ Banco",
    "tax_3": "✓ Impuestos",
    "pension": "✓ Pensión",
    "no_employees_found": "No se encontraron empleados",
    "archive": "Archivar",
    "drop_employees_here": "Suelta los empleados aquí",
    "done": "Listo",
    "people_operations": "Gestión de personal",
    "organise_payroll_by_department": "Organizar las nóminas por departamento",
    "drag_employee_cards_into_teams_or_use_accessible_move_selectors": "Arrastra las fichas de empleados a los equipos o utiliza los selectores accesibles para moverlas.",
    "loading_departments": "Cargando departamentos…",
    "search_department_employees": "Buscar empleados del departamento",
    "search_people_role_department": "Buscar por persona, puesto o departamento",
    "new_department_name": "Nombre del nuevo departamento",
    "new_department": "Nuevo departamento",
    "department_colour": "Color del departamento",
    "staff_link": "Vínculo con el personal",
    "staff_member": "Miembro del personal",
    "search_staff_2": "Buscar personal",
    "search_by_name_email_job_title_or_department": "Buscar por nombre, correo, puesto o departamento",
    "clear": "Borrar",
    "employment_details": "Datos laborales",
    "pay_setup": "Configuración salarial",
    "payroll_calculation_rules_for_contractors_will_be_configured_later_this": "Las reglas de cálculo de nómina de contratistas se configurarán más adelante; esta configuración solo guarda la tarifa predeterminada.",
    "readiness_setup": "Configuración de preparación",
    "payment_details": "Datos de pago",
    "save_payment_details_first_then_mark_them_verified_once_checked": "Guarda primero los datos de pago y márcalos como verificados después de comprobarlos.",
    "update_verification": "Actualizar verificación",
    "no_active_payment_details_saved": "No hay datos de pago activos guardados.",
    "enter_full_details_once_existing_sensitive_values_are_never_prefilled": "Introduce los datos completos una vez. Al sustituirlos, los valores sensibles existentes nunca se rellenan automáticamente.",
    "cancel_payment_edit": "Cancelar edición del pago",
    "discard_edits": "Descartar cambios",
    "edit_profile": "Editar perfil",
    "mark_on_hold": "Marcar en espera",
    "mark_active": "Marcar como activo",
    "payroll_profile_review": "Revisión del perfil de nómina",
    "edit_mode": "Modo de edición",
    "view_mode": "Modo de consulta",
    "loading_profile_detail": "Cargando los detalles del perfil…",
    "pay_rate_details": "Datos salariales y tarifas",
    "effective_from_2": "Vigente desde",
    "effective_to": "Vigente hasta",
    "active_rate": "Tarifa activa",
    "tax_ni_readiness": "Preparación fiscal / NI",
    "ni_number_last4_only": "Solo los 4 últimos caracteres del número NI",
    "privana_stores_ni_reference_last4_only_full_ni_numbers_are": "Privana solo guarda los 4 últimos caracteres de la referencia NI. Aquí no se guardan números NI completos.",
    "pension_2": "Pensión",
    "provider": "Proveedor",
    "scheme_reference": "Referencia del plan",
    "employee_contribution_rate": "Porcentaje de aportación del empleado",
    "employer_contribution_rate": "Porcentaje de aportación de la empresa",
    "employer_cost_setup": "Configuración del coste empresarial",
    "employer_pension_rate": "Porcentaje de pensión de la empresa",
    "fixed_employer_contribution_override": "Aportación fija de la empresa personalizada",
    "manual_employer_adjustment_override": "Ajuste manual de la empresa personalizado",
    "manual_adjustment_reason": "Motivo del ajuste manual",
    "no_audit_history_yet": "Todavía no hay historial de auditoría.",
    "close_modal": "Cerrar ventana",
    "finance_preview": "Vista previa contable",
    "finance_preview_ready": "Vista previa contable preparada",
    "this_payroll_stays_approved_until_it_is_posted_to_accounting": "Esta nómina permanece aprobada hasta que se contabilice.",
    "posting_this_payroll_will": "Al contabilizar esta nómina se realizarán estas acciones:",
    "link_this_payroll_run_to_a_general_ledger_journal": "Vincular este proceso de nómina con un asiento del libro mayor",
    "create_outstanding_payroll_hmrc_pension_and_other_payable_obligations": "Crear obligaciones pendientes de nóminas, HMRC, pensiones y otras cuentas a pagar",
    "hmrc_payroll_liability_components": "Componentes de la obligación de nómina con HMRC",
    "memo_mapping_key": "Concepto / Clave de asignación",
    "prepare_finance_preview_after_approval": "Prepara la vista previa contable después de la aprobación.",
    "payroll_calendar_filter": "Filtro de calendario de nóminas",
    "all_calendars": "Todos los calendarios",
    "department_filter": "Filtro de departamento",
    "department_id": "Identificador del departamento",
    "period_filter": "Filtro de período",
    "all_payroll_periods": "Todos los períodos de nómina",
    "search_timesheets": "Buscar partes de horas",
    "search_employee": "Buscar empleado",
    "new_timesheet": "Nuevo parte de horas",
    "import_timesheets": "Importar partes de horas",
    "timesheets": "Partes de horas",
    "loading_timesheets": "Cargando partes de horas…",
    "open_2": "Abierto",
    "reopen": "Reabrir",
    "timesheet_lines": "Líneas del parte de horas",
    "remove_line": "Eliminar línea",
    "create_timesheet": "Crear parte de horas",
    "timesheets_are_created_against_payroll_periods_generated_from_payroll_calendar": "Los partes de horas se crean para los períodos de nómina generados según las reglas del calendario de nóminas.",
    "no_open_payroll_periods_exist_for_this_calendar_go_to": "No hay períodos de nómina abiertos en este calendario. Ve a Configuración de nóminas → Calendarios de nóminas y pulsa Generar períodos.",
    "import_drafts": "Importar borradores",
    "all_periods": "Todos los períodos",
    "search_run_name": "Buscar por nombre del proceso",
    "new_payroll_run": "Nuevo proceso de nómina",
    "loading_payroll_runs": "Cargando procesos de nómina…",
    "resolve_blockers_before_approval": "Resuelve los bloqueos antes de aprobar",
    "no_payroll_runs_yet": "Todavía no hay procesos de nómina",
    "statutory_source": "Fuente de los datos legales",
    "statutory_payroll_inputs": "Datos legales de nómina",
    "enter_the_providersupplied_statutory_values_for_each_employee_in_this": "Introduce los valores legales suministrados por el proveedor para cada empleado de este proceso de nómina.",
    "privana_uses_these_employeelevel_values_to_calculate_net_pay_hmrc": "Privana utiliza estos valores por empleado para calcular el salario neto, las obligaciones con HMRC, la cuenta transitoria de nóminas, los documentos y las futuras nóminas individuales.",
    "pension_values_come_from_privana_pension_settings_only_paye_employee": "Los valores de pensiones proceden de la configuración de Privana. Aquí solo se introducen PAYE, NI del empleado y NI de la empresa.",
    "payroll_was_recalculated_after_statutory_inputs_were_saved_review_and": "La nómina se recalculó después de guardar los datos legales. Revisa y vuelve a introducir los valores legales.",
    "previous_statutory_values_are_stale_and_are_not_being_used": "Los valores legales anteriores están desactualizados y no se utilizan.",
    "optional_sourcereference": "Fuente o referencia opcional",
    "optional_reference_eg_payroll_provider_report_name_or_accountant_email": "Referencia opcional, por ejemplo, el nombre del informe del proveedor de nóminas o el correo del contable.",
    "import_csv_coming_soon": "Importar CSV — Próximamente",
    "review_required": "Requiere revisión",
    "postedlocked_state_statutory_inputs_are_readonly_postedlocked_runs_show_readonly": "Estado contabilizado o bloqueado: los datos legales son de solo lectura. Los procesos contabilizados o bloqueados muestran filas de solo lectura.",
    "save_statutory_inputs": "Guardar datos legales",
    "reset_unsaved_changes": "Restablecer los cambios sin guardar",
    "create_payroll_run": "Crear proceso de nómina",
    "payroll_runs_collect_fixed_salary_profiles_approved_timesheets_and_hybrid": "Los procesos de nómina reúnen los perfiles de salario fijo, los partes de horas aprobados y los ajustes híbridos del período seleccionado.",
    "include_fixed_salary_profiles": "Incluir perfiles de salario fijo",
    "include_timesheetdriven_employees": "Incluir empleados con partes de horas",
    "include_hybrid_profiles": "Incluir perfiles híbridos",
    "roll_back_stage": "Retroceder etapa",
    "recalculate_payroll": "Recalcular nómina",
    "posted_to_accounting": "Contabilizada",
    "fix_mappings": "Corregir asignaciones",
    "multiple_payroll_journals_were_detected_for_this_payroll_run_review": "Se detectaron varios asientos de nómina para este proceso. Revísalos antes de pagar.",
    "approval_blockers": "Aprobación y bloqueos",
    "opencreate_timesheet": "Abrir o crear parte de horas",
    "no_blockers_found_payroll_can_move_to_the_next_available": "No se encontraron bloqueos. La nómina puede avanzar al siguiente paso disponible.",
    "publish_payslips_to_staff_portal": "¿Publicar las nóminas individuales en el portal del personal?",
    "this_will_make_individual_payslips_available_only_to_staff_included": "Las nóminas individuales estarán disponibles únicamente para el personal incluido en este proceso.",
    "each_staff_member_will_only_be_able_to_view_and": "Cada miembro del personal solo podrá consultar y descargar su propia nómina.",
    "employee_breakdown": "Desglose por empleado",
    "no_employee_lines_have_been_calculated_yet": "Todavía no se han calculado líneas de empleados.",
    "payroll_liabilities": "Obligaciones de nómina",
    "approvals_pending": "Aprobaciones pendientes",
    "timesheets_waiting": "Partes de horas pendientes",
    "payroll_runs_waiting": "Procesos de nómina pendientes",
    "this_item_needs_a_backendlinked_action_before_it_can_be": "Este elemento requiere una acción vinculada al servidor antes de poder abrirse aquí.",
    "approvals_clear": "Sin aprobaciones pendientes",
    "payroll_liabilities_and_payment_obligations_created_from_payroll_are_shown": "Aquí se muestran los pasivos y las obligaciones de pago derivados de las nóminas. Los elementos de vista previa no han creado pagos ni movido dinero.",
    "no_payroll_liabilities_yet": "Todavía no hay obligaciones de nómina",
    "loading_payroll_settings": "Cargando la configuración de nóminas…",
    "payroll_calendars": "Calendarios de nóminas",
    "please_retry": "Inténtalo de nuevo.",
    "add_calendar": "Añadir calendario",
    "payroll_calendars_generate_payroll_periods_timesheets_and_payroll_runs_then": "Los calendarios de nóminas generan períodos que después utilizan los partes de horas y los procesos de nómina.",
    "loading_payroll_calendars": "Cargando calendarios de nóminas…",
    "unable_to_load_payroll_calendars": "No se pudieron cargar los calendarios de nóminas.",
    "no_payroll_calendars_yet_create_one_to_define_pay_cycles": "Todavía no hay calendarios de nóminas. Crea uno para definir los ciclos de pago.",
    "generate_periods": "Generar períodos",
    "set_default": "Establecer como predeterminado",
    "weekly_2": "semanal",
    "fortnightly": "quincenal",
    "monthly": "mensual",
    "quarterly_2": "trimestral",
    "paused": "en pausa",
    "is_default": "Es el predeterminado",
    "next_payroll_periods": "Próximos períodos de nómina",
    "save_calendar_to_preview_generated_periods": "Guarda el calendario para ver los períodos que se generarán.",
    "pay_rules": "Reglas salariales",
    "timesheet_rules": "Reglas de los partes de horas",
    "payroll_setup_policy_centre": "Centro de configuración y políticas de nóminas",
    "payroll_jurisdiction": "Jurisdicción de nóminas",
    "unable_to_determine_payroll_jurisdiction_automatically_please_check_your_club": "⚠ No se pudo determinar automáticamente la jurisdicción de nóminas. Comprueba la dirección del club en Configuración del club.",
    "refresh_detection": "Actualizar detección",
    "open_club_settings": "Abrir configuración del club",
    "advanced_payroll_settings": "Configuración avanzada de nóminas",
    "for_payroll_specialists_accountants_and_privana_support_these_fields_expose": "Para especialistas en nóminas, contables y soporte de Privana. Estos campos muestran modos de cálculo, umbrales, porcentajes, claves de asignación, jurisdicción y ajustes avanzados del coste empresarial.",
    "auto_enrolment_enabled": "Inscripción automática habilitada",
    "overtime_enabled": "Horas extra habilitadas",
    "custom": "Personalizado",
    "standard_hourly_rate": "Tarifa horaria estándar",
    "time_and_a_half_15x": "Tarifa y media (1,5×)",
    "double_time_20x": "Tarifa doble (2,0×)",
    "reset_to_suggested_setting": "Restablecer el valor sugerido",
    "advanced_employer_cost_adjustments": "Ajustes avanzados del coste empresarial",
    "accountantlevel_employer_cost_overrides_collapsed_inside_advanced_payroll_settings_for": "Personalizaciones del coste empresarial para contables. Se muestran contraídas en la configuración avanzada para los usuarios habituales del club.",
    "per_run": "Por proceso",
    "monthly_2": "Mensual",
    "annual_prorated": "Anual prorrateado",
    "save_payroll_policies": "Guardar políticas de nóminas",
    "privana_assist_controls": "Controles de Privana Assist",
    "permissions_preview": "Vista previa de permisos",
    "role_assignment_will_use_privana_module_permissions_this_preview_does": "La asignación de roles utilizará los permisos de módulos de Privana. Esta vista previa todavía no modifica permisos.",
    "loading_todays_accounting_queue": "Cargando la cola contable de hoy…",
    "today_workspace": "Espacio de trabajo de hoy",
    "accounting_today": "Contabilidad — Hoy",
    "financial_operations_overview_for_today": "Resumen de las operaciones financieras de hoy.",
    "no_urgent_financial_actions_today": "Hoy no hay acciones financieras urgentes.",
    "search_payee_source_or_description": "Buscar por beneficiario, origen o descripción…",
    "pay_selected": "Pagar seleccionados",
    "add_bill": "Añadir factura de proveedor",
    "all_payables": "Todas las cuentas a pagar",
    "tax_pension": "Impuestos y pensiones",
    "refunds": "Reembolsos",
    "other_liabilities": "Otros pasivos",
    "ap_ageing": "Antigüedad de cuentas a pagar",
    "unified_payable_ledger": "Registro unificado de cuentas a pagar",
    "source_type": "Tipo de origen",
    "payee": "Beneficiario",
    "module": "Módulo",
    "gl_mapping": "Asignación contable",
    "original_amount": "Importe original",
    "outstanding_amount": "Importe pendiente",
    "due_date_run": "Vencimiento / Proceso",
    "payment_status": "Estado del pago",
    "loading_payables": "Cargando cuentas a pagar…",
    "no_payables_found": "No se encontraron cuentas a pagar.",
    "view_source": "Ver origen",
    "recent_ap_payments": "Pagos recientes a proveedores",
    "unapplied": "Sin aplicar",
    "loading_payments": "Cargando pagos…",
    "no_payments_recorded": "No hay pagos registrados.",
    "current": "No vencido",
    "totals": "Totales",
    "no_ageing_balances_to_display": "No hay saldos por antigüedad que mostrar.",
    "manage_payment_allocations": "Gestionar aplicaciones del pago",
    "current_allocations": "Aplicaciones actuales",
    "unapply_selected": "Desaplicar seleccionadas",
    "unapply_all": "Desaplicar todas",
    "reallocate_across_bills": "Redistribuir entre facturas de proveedor",
    "no_open_bills_available_for_reallocation": "No hay facturas de proveedor pendientes para redistribuir el pago.",
    "reallocation_total": "Total redistribuido",
    "apply_reallocation": "Aplicar redistribución",
    "refund_payment": "Reembolsar pago",
    "refund_amount": "Importe del reembolso",
    "refund_method": "Forma de reembolso",
    "refund_date": "Fecha del reembolso",
    "bank_account_required_for_bank_refunds": "Se requiere una cuenta bancaria para los reembolsos bancarios.",
    "issue_refund": "Emitir reembolso",
    "add_bank_account": "Añadir cuenta bancaria",
    "bank_name": "Nombre del banco",
    "eg_harbor_credit_union": "p. ej., Harbor Credit Union",
    "account_name_friendly_label": "Nombre descriptivo de la cuenta",
    "eg_operating_checking": "p. ej., Cuenta corriente operativa",
    "account_number": "Número de cuenta",
    "enter_account_number": "Introduce el número de cuenta",
    "eg_usd": "p. ej., USD",
    "linked_gl_account_required": "Cuenta del libro mayor vinculada (obligatoria)",
    "no_gl_accounts_available": "No hay cuentas del libro mayor disponibles.",
    "bank_accounts": "Cuentas bancarias",
    "bank_2": "Banco",
    "linked_gl_account": "Cuenta del libro mayor vinculada",
    "no_bank_accounts_available": "No hay cuentas bancarias disponibles.",
    "loading_bank_accounts": "Cargando cuentas bancarias…",
    "search_transactions": "Buscar transacciones…",
    "income_vs_budget": "Ingresos frente a presupuesto",
    "actual_vs_budget": "Real frente a presupuesto",
    "expenses_vs_budget": "Gastos frente a presupuesto",
    "income_trend": "Evolución de ingresos",
    "expense_trend": "Evolución de gastos",
    "monthly_performance": "Resultados mensuales",
    "period": "Período",
    "of_budget": "% del presupuesto",
    "department_breakdown": "Desglose por departamento",
    "variance_2": "Desviación %",
    "gl_accounts": "Cuentas del libro mayor",
    "no_gl_detail_available": "No hay detalles del libro mayor disponibles.",
    "inactive": "Inactiva",
    "eg_4000": "p. ej., 4000",
    "eg_membership_dues": "p. ej., Cuotas de socios",
    "cost_centers_departmental_accounting": "Centros de coste y contabilidad departamental",
    "track_spending_and_budgets_by_department_and_cost_center": "Supervisa los gastos y presupuestos por departamento y centro de coste",
    "new_cost_center": "Nuevo centro de coste",
    "total_cost_centers": "Total de centros de coste",
    "annual_budget": "Presupuesto anual",
    "ytd_spending": "Gasto acumulado del ejercicio",
    "budget_variance": "Desviación presupuestaria",
    "department_spending_vs_budget": "Gasto departamental frente a presupuesto",
    "budget_utilization_by_department": "Uso del presupuesto por departamento",
    "cost_centers": "Centros de coste",
    "all_departments": "Todos los departamentos",
    "budget_utilization": "Uso del presupuesto",
    "cost_center_name": "Nombre del centro de coste",
    "eg_fb001": "p. ej., FB001",
    "manager_name": "Nombre del responsable",
    "eg_department": "p. ej., Departamento",
    "eg_fnb": "p. ej., FNB",
    "eg_food_beverage": "p. ej., Alimentos y bebidas",
    "fiscal_year": "Ejercicio contable",
    "customize_invoice": "Personalizar factura",
    "edit_invoicespecific_presentation_settings_only": "Edita únicamente la presentación de esta factura.",
    "billing_email_optional": "Correo de facturación (opcional)",
    "leave_blank_to_use_club_default_in_preview": "Déjalo vacío para usar el valor predeterminado del club en la vista previa",
    "billing_phone_optional": "Teléfono de facturación (opcional)",
    "accent_hex_color": "Color de acento HEX",
    "footer_note": "Nota al pie",
    "eg_thank_you_for_your_business": "p. ej., ¡Gracias por su confianza!",
    "download_test_pdf": "Descargar PDF de prueba",
    "paid_via_direct_payment": "Pagado mediante pago directo",
    "unbilled": "Sin facturar",
    "apply_credit": "Aplicar saldo a favor",
    "refund_credit": "Reembolsar saldo a favor",
    "available_credit_notes": "Notas de abono disponibles",
    "available_credit": "Saldo a favor disponible",
    "current_balance": "Saldo actual",
    "open_invoices": "Facturas pendientes",
    "last_payment": "Último pago",
    "statements": "Extractos",
    "loading_transactions": "Cargando transacciones…",
    "billing_run": "Proceso de facturación",
    "balance": "Saldo",
    "details": "Detalles",
    "no_transactions_recorded": "No hay transacciones registradas.",
    "view_audit_trail": "Ver historial de auditoría",
    "reallocate": "Redistribuir",
    "refund_payment_2": "Reembolsar pago",
    "view_credit_note": "Ver nota de abono",
    "view_invoice": "Ver factura",
    "create_credit_note": "Crear nota de abono",
    "no_open_invoices": "No hay facturas pendientes.",
    "no_invoices_in_this_range": "No hay facturas en este intervalo.",
    "no_payments_in_this_range": "No hay pagos en este intervalo.",
    "select_a_date_range_to_view_a_statement": "Selecciona un intervalo de fechas para consultar un extracto.",
    "credit_payment": "Pago con saldo a favor",
    "select_a_payment": "Selecciona un pago",
    "no_open_invoices_available": "No hay facturas pendientes disponibles.",
    "remaining_credit": "Saldo a favor restante",
    "use_refund_payment_to_reverse_a_receipt_or_payment_allocation": "Utiliza Reembolsar pago para revertir un cobro o una aplicación de pago. Utiliza Nota de abono para reducir el importe de una factura.",
    "select_invoice": "Selecciona una factura",
    "credit_note_detail": "Detalles de la nota de abono",
    "total_ar": "Total de cuentas a cobrar",
    "inactive_accounts": "Cuentas inactivas",
    "active_accounts": "Cuentas activas",
    "accounts_in_credit": "Cuentas con saldo a favor",
    "search_members": "Buscar socios…",
    "filter_by_status": "Filtrar por estado",
    "all_statuses_2": "Todos los estados",
    "member_accounts": "Cuentas de socios",
    "credit_limit": "Límite de crédito",
    "credit_balance": "Saldo a favor",
    "loading_member_accounts": "Cargando cuentas de socios…",
    "no_member_accounts_found": "No se encontraron cuentas de socios.",
    "your_logo": "Tu logotipo",
    "billed_to_2": "Facturado a",
    "loading_current_period": "Cargando el período actual…",
    "no_periods_exist_for_this_fiscal_year_yet_generate_periods": "Todavía no hay períodos para este ejercicio. Genera los períodos para iniciar el cierre mensual.",
    "go_to_periods": "Ir a períodos",
    "no_completed_months_to_close_yet": "Todavía no hay meses finalizados que cerrar.",
    "select_a_period_to_continue_the_month_close_workflow": "Selecciona un período para continuar el proceso de cierre mensual.",
    "loading_checklist": "Cargando la lista de comprobación…",
    "action_blocked": "Acción bloqueada",
    "override_reason_required_to_closelock": "Motivo de excepción (obligatorio para cerrar o bloquear)",
    "clear_staff_selection": "Borrar selección de personal",
    "configure_monthend_checklist_templates_exception_policies_and_locking_rules": "Configura las plantillas de comprobación del cierre mensual, las políticas de excepciones y las reglas de bloqueo.",
    "you_have_viewonly_access_editing_is_disabled_for_this_configuration": "Tienes acceso de solo lectura. No puedes editar esta configuración.",
    "task_templates": "Plantillas de tareas",
    "define_the_checklist_items_required_to_close_a_period": "Define las comprobaciones necesarias para cerrar un período.",
    "add_task": "Añadir tarea",
    "task": "Tarea",
    "no_task_templates_configured": "No hay plantillas de tareas configuradas.",
    "task_name": "Nombre de la tarea",
    "exception_policies": "Políticas de excepciones",
    "define_who_can_post_or_delete_entries_during_locked_periods": "Define quién puede contabilizar o eliminar asientos en períodos bloqueados.",
    "add_policy": "Añadir política",
    "source_module": "Módulo de origen",
    "optional_limit_this_exception_to_entries_created_by_a_specific": "Opcional: limita esta excepción a los asientos creados por un módulo concreto. Deja Cualquiera para aplicarla a todos los módulos.",
    "entry_class": "Clase de asiento",
    "entry_class_describes_what_type_of_journal_entry_this_exception": "La clase de asiento indica el tipo al que se aplica esta excepción (normal, adjusting, reversal, year_end, accrual). Deja Cualquiera para aplicarla a todos.",
    "allow_post": "Permitir contabilización",
    "allow_delete": "Permitir eliminación",
    "no_exception_policies_configured": "No hay políticas de excepciones configuradas.",
    "locking_rules": "Reglas de bloqueo",
    "locking_rules_configuration_coming_soon": "La configuración de reglas de bloqueo estará disponible próximamente.",
    "todays_sales": "Ventas de hoy",
    "transactions_today": "Transacciones de hoy",
    "avg_transaction": "Importe medio por transacción",
    "refunds_today": "Reembolsos de hoy",
    "all_locations": "Todas las ubicaciones",
    "new_sale": "Nueva venta",
    "point_of_sale_transactions": "Transacciones del punto de venta",
    "transaction_id": "Identificador de transacción",
    "datetime": "Fecha y hora",
    "refunds_returns": "Reembolsos y devoluciones",
    "refund_id": "Identificador del reembolso",
    "original_transaction": "Transacción original",
    "member_optional": "Socio (opcional)",
    "select_member_or_leave_blank_for_walkin": "Selecciona un socio o déjalo vacío para un cliente sin reserva",
    "debit_card": "Tarjeta de débito",
    "gift_card": "Tarjeta regalo",
    "comp": "Invitación",
    "items_2": "Artículos",
    "item_name": "Nombre del artículo",
    "tip_amount": "Importe de la propina",
    "transaction_notes": "Notas de la transacción…",
    "process_refund": "Procesar reembolso",
    "refund_amount_2": "Importe del reembolso",
    "refund_method_2": "Forma de reembolso",
    "account_credit": "Saldo a favor en cuenta",
    "reason_for_refund": "Motivo del reembolso",
    "customer_request": "Solicitud del cliente",
    "service_issue": "Problema de servicio",
    "cancellation": "Cancelación",
    "error_correction": "Corrección de error",
    "refund_reason_or_notes": "Motivo o notas del reembolso…",
    "total_processed": "Total procesado",
    "failed": "Fallido",
    "processing_fees": "Comisiones de procesamiento",
    "search_payments": "Buscar pagos…",
    "completed": "Completado",
    "invoice_optional": "Factura (opcional)",
    "select_invoice_to_pay": "Selecciona la factura a pagar",
    "additional_notes": "Notas adicionales…",
    "recent_payments": "Pagos recientes",
    "payment_id": "Identificador del pago",
    "fee": "Comisión",
    "no_payments_found": "No se encontraron pagos",
    "total_receivables": "Total de cuentas a cobrar",
    "outstanding_receivables": "Cuentas a cobrar pendientes",
    "nonmember_debtors": "Deudores no socios",
    "all_receivables": "Todas las cuentas a cobrar",
    "charges": "Cargos",
    "billing_status": "Estado de facturación",
    "no_charges_found": "No se encontraron cargos.",
    "receivable_detail": "Detalles de la cuenta a cobrar",
    "debtor_2": "Deudor",
    "original": "Original",
    "source_invoice": "Origen y factura",
    "accounting_metadata": "Metadatos contables",
    "settlement_pos_gl_audit": "Auditoría de liquidación, TPV y libro mayor",
    "payment_records": "Registros de pagos",
    "payment_allocations": "Aplicaciones de pagos",
    "taxvat_breakdown": "Desglose de impuestos / IVA",
    "gl_journal_lines": "Líneas del asiento del libro mayor",
    "invoice_line_items": "Líneas de la factura",
    "go_to_source": "Ir al origen",
    "clear_search": "Borrar búsqueda",
    "search_by_invoice_or_memberdebtor_name": "Buscar por número de factura o nombre de socio o deudor…",
    "no_matching_invoices": "No hay facturas que coincidan.",
    "use_a_credit_note_to_reduce_the_invoice_value_after": "Utiliza una nota de abono para reducir el importe de la factura tras su emisión. Utiliza Reembolsar pago únicamente para devolver un pago sin modificar el importe de la factura.",
    "billing_adjustment_2": "Ajuste de facturación",
    "goodwillservice_issue": "Cortesía / Problema de servicio",
    "event_cancellation": "Cancelación de evento",
    "membership_adjustment": "Ajuste de afiliación",
    "gross_amount": "Importe bruto",
    "post_credit_note_immediately": "Contabilizar la nota de abono de inmediato",
    "enrolment_list": "Lista de inscripciones",
    "billing_runs": "Procesos de facturación",
    "recurring_billing_settings": "Configuración de facturación recurrente",
    "billing_cutoff_day_of_month": "Día de corte mensual de facturación",
    "billing_runs_include_eligible_unbilled_items_up_to_and_including": "Los procesos de facturación incluyen los elementos elegibles sin facturar hasta el día de corte seleccionado, inclusive.",
    "autoemail_recurring_invoices": "Enviar facturas recurrentes por correo automáticamente",
    "invoices_generated_from_recurring_billing_are_emailed_to_members_at": "Las facturas de la facturación recurrente se envían a los socios a las 9:00 en la zona horaria del club.",
    "generate_invoices": "Generar facturas",
    "send_invoice": "Enviar factura",
    "statement_total": "Total del extracto",
    "current_period": "Período actual",
    "this_will_generate_the_members_invoice_and_email_it_immediately": "Se generará la factura del socio y se enviará por correo de inmediato.",
    "the_invoice_will_then_appear_in_invoicing_for": "La factura aparecerá en Facturación para:",
    "payment_tracking": "seguimiento de pagos",
    "overdue_management": "gestión de vencimientos",
    "future_account_administration": "gestión futura de la cuenta",
    "some_items_are_not_mapped_to_accounts": "Algunos elementos no tienen asignación contable",
    "unmapped_items_will_not_be_included_in_invoices_unless_you": "Los elementos sin asignación no se incluirán en las facturas hasta que corrijas sus asignaciones contables.",
    "go_to_gl_mapping": "Ir a asignaciones contables",
    "continue_anyway": "Continuar de todos modos",
    "membership_dues_enrollment": "Inscripción en cuotas de socios",
    "accountingonly_enrollment_and_operations_for_recurring_membership_dues": "Inscripción y gestión exclusivamente contables de las cuotas recurrentes de socios.",
    "enroll_member": "Inscribir socio",
    "active_recurring_dues_enrollments": "Inscripciones activas en cuotas recurrentes",
    "enrollment": "Inscripción",
    "enrolled": "Inscrito",
    "not_enrolled": "No inscrito",
    "membership_type_2": "Tipo de socio",
    "enroll_selected": "Inscribir seleccionados",
    "generate_invoices_for_selected": "Generar facturas de los seleccionados",
    "next_run_date": "Fecha del próximo proceso",
    "latest_invoice": "Última factura",
    "recurring_status": "Estado de recurrencia",
    "generate_invoice_now": "Generar factura ahora",
    "run_date": "Fecha del proceso",
    "invoices": "Facturas",
    "total_billed": "Total facturado",
    "skipped_warnings": "Omitidos / Advertencias",
    "view_preview": "Ver vista previa",
    "generate_run": "Generar proceso",
    "view_invoices": "Ver facturas",
    "record_payments": "Registrar pagos",
    "loading_billing_runs": "Cargando procesos de facturación…",
    "no_billing_runs_yet": "Todavía no hay procesos de facturación.",
    "billing_run_detail": "Detalles del proceso de facturación",
    "charge": "Cargo",
    "generate_billing_run": "¿Generar proceso de facturación?",
    "this_will_create_draft_invoices_for_the_selected_recurring_billing": "Se crearán facturas en borrador para el período de facturación recurrente seleccionado. Los borradores no se contabilizan en el libro mayor hasta que se finalicen o contabilicen.",
    "statement_preview": "Vista previa del extracto",
    "loading_statement_preview": "Cargando la vista previa del extracto…",
    "dues": "Cuotas",
    "billing_email": "Correo de facturación",
    "ready_to_bill": "✓ Listo para facturar",
    "nothing_to_bill": "Nada que facturar",
    "current_statement": "Extracto actual",
    "future_billing": "Facturación futura",
    "billing_history": "Historial de facturación",
    "preview_invoice": "Vista previa de factura",
    "coming_soon": "Próximamente",
    "autopay_coming_soon": "Pago automático: próximamente",
    "statement_preview_summary": "Resumen de la vista previa del extracto",
    "only_billable_outstanding_items_that_would_be_included_if_generated": "Solo los elementos facturables pendientes que se incluirían si se generase ahora.",
    "no_charges_are_currently_scheduled_for_the_next_statement": "No hay cargos programados para el próximo extracto.",
    "charges_included": "Cargos incluidos",
    "paid_settled_voided_and_directly_settled_sales_are_excluded": "Se excluyen las ventas pagadas, liquidadas, anuladas y liquidadas directamente.",
    "projected": "Previsto",
    "charge_actions": "Acciones del cargo",
    "edit_charge_coming_soon": "Editar cargo — Próximamente",
    "exclude_this_run": "Excluir de este proceso",
    "move_to_future_billing_run": "Mover a un proceso de facturación futuro",
    "make_complimentary_coming_soon": "Convertir en cortesía — Próximamente",
    "split_billing_coming_soon": "Dividir facturación — Próximamente",
    "add_note_coming_soon": "Añadir nota — Próximamente",
    "scheduled_2": "Programado",
    "future_charge_actions": "Acciones del cargo futuro",
    "change_billing_run": "Cambiar proceso de facturación",
    "no_future_scheduled_charges_found": "No se encontraron cargos futuros programados.",
    "source_2": "Origen",
    "no_previous_billing_periods_found": "No se encontraron períodos de facturación anteriores.",
    "loading_invoice_preview": "Cargando la vista previa de la factura…",
    "direct_debit": "Adeudo directo",
    "charge_source": "Origen del cargo",
    "source_type_2": "Tipo de origen",
    "sale_number": "Número de venta",
    "choose_which_billing_run_this_charge_should_appear_in": "Elige el proceso de facturación en el que debe aparecer este cargo.",
    "current_billing_run": "Proceso de facturación actual",
    "billing_runs_2": "Procesos de facturación",
    "custom_2": "Personalizado…",
    "choose_a_later_billing_run": "Elige un proceso de facturación posterior",
    "month": "Mes",
    "custom_billing_month": "Mes de facturación personalizado",
    "custom_billing_year": "Ejercicio de facturación personalizado",
    "enroll_member_in_membership_dues": "Inscribir al socio en cuotas",
    "dues_start_date": "Fecha de inicio de las cuotas",
    "dues_amount": "Importe de las cuotas",
    "choose_frequency": "Elige la frecuencia",
    "recurring_state": "Estado de recurrencia",
    "paused_2": "En pausa",
    "autoemail_invoices": "Enviar facturas por correo automáticamente",
    "enroll": "Inscribir",
    "manage_revenue_payroll_and_future_accounting_mappings_used_by_privana": "Gestiona las asignaciones de ingresos, nóminas y futuras operaciones contables de Privana. Configura cómo se refleja la actividad operativa en el libro mayor.",
    "show_historical_mappings": "Mostrar asignaciones históricas",
    "add_mapping": "Añadir asignación",
    "revenue_mappings": "Asignaciones de ingresos",
    "existing_revenue_mapping_rules_used_by_invoice_and_receivables_posting": "Reglas de asignación de ingresos utilizadas al contabilizar facturas y cuentas a cobrar.",
    "loading_gl_mappings": "Cargando asignaciones contables…",
    "key": "Clave",
    "no_revenue_mappings_yet": "Todavía no hay asignaciones de ingresos.",
    "payroll_journal_mappings": "Asignaciones de asientos de nóminas",
    "payroll_posting_rules_used_when_payroll_journals_are_generated": "Reglas contables utilizadas al generar los asientos de nóminas.",
    "mapping_key": "Clave de asignación",
    "debit_account": "Cuenta del debe",
    "credit_account": "Cuenta del haber",
    "effective_to_2": "Vigente hasta",
    "no_payroll_journal_mappings_yet_use_accounting_refresh_defaults_to": "Todavía no hay asignaciones de asientos de nóminas. Utiliza Actualizar valores contables predeterminados para restablecerlos.",
    "payroll_control_accounts": "Cuentas de control de nóminas",
    "payroll_liability_and_clearing_accounts_used_by_payroll_posting_and": "Cuentas de pasivo y transitorias utilizadas al contabilizar nóminas y transferir obligaciones a cuentas a pagar.",
    "account_purpose": "Finalidad de la cuenta",
    "no_payroll_control_accounts_yet_use_accounting_refresh_defaults_to": "Todavía no hay cuentas de control de nóminas. Utiliza Actualizar valores contables predeterminados para restablecerlas.",
    "refresh_accounting_defaults": "¿Actualizar los valores contables predeterminados?",
    "this_creates_any_missing_default_accounts_tax_codes_dimensions_revenue": "Se crearán las cuentas, los códigos fiscales, las dimensiones y las asignaciones de ingresos y nóminas predeterminados que falten, solo para transacciones futuras. Las facturas y los asientos históricos no se modifican.",
    "preparing_your_clubs_accounting_defaults": "Preparando los valores contables predeterminados del club",
    "were_checking_the_chart_of_accounts_tax_codes_dimensions_revenue": "Estamos comprobando el plan de cuentas, los códigos fiscales, las dimensiones y las asignaciones de ingresos y nóminas para contabilizar correctamente los cargos futuros. Las facturas y los asientos históricos se mantienen intactos.",
    "search_tax_codes": "Buscar códigos fiscales…",
    "no_tax_codes_found": "No se encontraron códigos fiscales.",
    "no_fiscal_years_are_available_yet": "Todavía no hay ejercicios contables disponibles.",
    "select_fiscal_year": "Selecciona un ejercicio contable",
    "select_a_fiscal_year_to_review_yearend_status": "Selecciona un ejercicio para revisar el estado del cierre anual.",
    "loading_yearend_status": "Cargando el estado del cierre anual…",
    "some_modulespecific_checks_were_skipped_because_those_modules_are_not": "Se omitieron algunas comprobaciones específicas de módulos porque no están habilitados o no tienen actividad en este club.",
    "close_fiscal_year": "Cerrar ejercicio contable",
    "confirm_close": "Confirmar cierre",
    "processing": "Procesando…",
    "submit_payment": "Registrar pago",
    "draft_bill": "Factura de proveedor en borrador",
    "edit_bill": "Editar factura de proveedor",
    "create_bill": "Crear factura de proveedor",
    "save_bill": "Guardar factura de proveedor",
    "people": "Personal",
    "share": "Proporción",
    "payroll_number": "Número de nómina",
    "employment_type": "Tipo de relación laboral",
    "job_title": "Puesto",
    "start_year": "Año de inicio",
    "start_month": "Mes de inicio",
    "start_day": "Día de inicio",
    "pay_type": "Tipo de remuneración",
    "payroll_method": "Método de nómina",
    "payroll_calendar": "Calendario de nóminas",
    "bank_readiness": "Preparación bancaria",
    "taxni_readiness": "Preparación fiscal / NI",
    "pension_status": "Estado de pensión",
    "payment_details_2": "Datos de pago",
    "account_type": "Tipo de cuenta",
    "scheme": "Plan",
    "account_holder": "Titular de la cuenta",
    "sort_code": "Código bancario (sort code)",
    "reference_last4": "Últimos 4 caracteres de la referencia",
    "verification_status": "Estado de verificación",
    "last_updated": "Última actualización",
    "set_verification_status": "Establecer estado de verificación",
    "current_rate": "Tarifa actual",
    "payroll_status": "Estado de nómina",
    "readiness_status": "Estado de preparación",
    "tax_status": "Estado fiscal",
    "pension_status_2": "Estado de pensión",
    "last_paid": "Último pago",
    "rate_wording": "Descripción de la tarifa",
    "active_rate_status": "Estado de la tarifa activa",
    "tax_and_ni_details": "Datos fiscales y de NI",
    "tax_status_2": "Estado fiscal",
    "ni_last4": "Últimos 4 caracteres de NI",
    "employee_contribution": "Aportación del empleado",
    "employer_contribution": "Aportación de la empresa",
    "pension_enrolled_status": "Estado de inscripción en pensiones",
    "gb_employer_ni_status": "Estado de NI de la empresa en GB",
    "gross_pay": "Salario bruto",
    "net_pay": "Salario neto",
    "employer_costs": "Costes empresariales",
    "total_payroll_cost": "Coste total de nóminas",
    "total_debits_2": "Total del debe",
    "total_credits_2": "Total del haber",
    "payroll_period": "Período de nómina",
    "sourcereference": "Origen o referencia",
    "saved_at": "Fecha de guardado",
    "saved_by": "Guardado por",
    "hmrc_total": "Total HMRC",
    "employee_ni": "NI del empleado",
    "employer_ni": "NI de la empresa",
    "source_reference": "Origen / Referencia",
    "net_staff_payments": "Pagos netos al personal",
    "total_cost_to_club": "Coste total para el club",
    "payroll_calendar_2": "Calendario de nóminas",
    "run_name": "Nombre del proceso",
    "period_rule": "Regla de período",
    "generation_horizon_months": "Horizonte de generación en meses",
    "pay_date_rule": "Regla de fecha de pago",
    "day_of_month": "Día del mes",
    "days_after_period_end": "Días después del fin del período",
    "approval_deadline_days": "Días hasta la fecha límite de aprobación",
    "timesheet_cutoff_rule": "Regla de corte de partes de horas",
    "cutoff_days": "Días de corte",
    "overtime_multiplier": "Multiplicador de horas extra",
    "default_currency": "Moneda predeterminada",
    "timesheet_rounding_mode": "Modo de redondeo de los partes de horas",
    "calculation_source": "Fuente del cálculo",
    "pension_provider": "Proveedor de pensiones",
    "employee_contribution_2": "Aportación del empleado %",
    "employer_contribution_2": "Aportación de la empresa %",
    "handled_by": "Gestionado por",
    "internal_calculation_mode": "Modo de cálculo interno",
    "liability_mapping_key": "Clave de asignación del pasivo",
    "expense_mapping_key": "Clave de asignación del gasto",
    "jurisdiction_key": "Clave de jurisdicción",
    "frequency_basis": "Base de frecuencia",
    "variance_threshold_percent": "Porcentaje umbral de desviación",
    "post": "Contabilizar",
    "debit_gl_account": "Cuenta del debe del libro mayor",
    "credit_gl_account": "Cuenta del haber del libro mayor",
    "balance_due_3": "Saldo pendiente:",
    "issue_credit_memo": "Emitir nota de abono —",
    "save_gl_coding": "Guardar la imputación contable",
    "tax_amount": "Importe de impuestos",
    "account_2": "Cuenta:",
    "applied": "Aplicado:",
    "record_payment_2": "Registrar pago —",
    "wire": "Transferencia electrónica",
    "partially_paid": "Pagada parcialmente",
    "overdue": "Vencida",
    "posting_blocked": "Contabilización bloqueada",
    "this_date_falls_in_a_locked_or_closed_period_change": "Esta fecha pertenece a un período bloqueado o cerrado. Cambia la fecha o solicita su desbloqueo.",
    "posting_failed": "Error de contabilización",
    "failed_to_post_invoice_to_the_general_ledger": "No se pudo contabilizar la factura en el libro mayor.",
    "failed_to_load_accounting_settings": "No se pudo cargar la configuración contable.",
    "unable_to_save_accounting_settings_check_the_account_selections_and": "No se pudo guardar la configuración contable. Comprueba las cuentas seleccionadas e inténtalo de nuevo.",
    "ar_control_account_not_set": "No se ha establecido la cuenta de control de cuentas a cobrar",
    "default_revenue_account_not_set": "No se ha establecido la cuenta de ingresos predeterminada",
    "vat_control_account_not_set": "No se ha establecido la cuenta de control del IVA",
    "unable_to_save_line_gl_coding_please_try_again": "No se pudo guardar la imputación contable de la línea. Inténtalo de nuevo.",
    "one_or_more_selected_tax_codes_arent_effective_for_the": "Uno o más códigos fiscales seleccionados no están vigentes en la fecha de emisión de la factura. Actualiza la fecha de emisión o elige otro código fiscal.",
    "some_tax_codes_were_not_effective_for_the_selected_issue": "Se han eliminado algunos códigos fiscales porque no estaban vigentes en la fecha de emisión seleccionada.",
    "cannot_save_no_club_context": "No se puede guardar: no se ha seleccionado un club.",
    "failed_to_save_invoice": "No se pudo guardar la factura.",
    "unable_to_record_payment": "No se pudo registrar el pago.",
    "finalized": "Finalizada",
    "finalize_reconciliation": "Finalizar conciliación",
    "detected_format": "Formato detectado:",
    "save_account": "Guardar cuenta",
    "save_dimension": "Guardar dimensión",
    "report": "Informe",
    "as_of": "A fecha de",
    "confidence": "Confianza",
    "remaining_to_match": "Pendiente de conciliar:",
    "required_tasks": "Tareas obligatorias",
    "required": "obligatorio",
    "optional_2": "opcional",
    "paye_income_tax": "Impuesto sobre la renta PAYE:",
    "employee_national_insurance": "National Insurance del empleado:",
    "employer_national_insurance": "National Insurance de la empresa:",
    "hmrc_total_2": "Total HMRC:",
    "add_adjustment_scaffold_is_ready_for_a_later_payroll_calculation": "La estructura de Añadir ajuste está preparada para una futura fase de cálculo de nómina.",
    "finance_details": "detalles contables",
    "enabled": "habilitado",
    "cost_center": "Centro de coste",
    "we_hit_a_snag_rendering_this_report_preview": "Se produjo un problema al mostrar la vista previa del informe.",
    "try_running_the_report_again_or_adjust_the_date_range": "Vuelve a ejecutar el informe o ajusta el intervalo de fechas. Si el problema persiste, contacta con soporte.",
    "fiscal_month": "Mes del ejercicio",
    "direct_payment_via_member_portal": "Pago directo desde el portal de socios",
    "month_close": "Cierre mensual",
    "pos_transaction": "Transacción del TPV",
    "transaction": "Transacción",
    "billable": "Facturable",
    "recurring_billing_only_activates_when_a_positive_dues_amount_and": "La facturación recurrente solo se activa al indicar un importe de cuota positivo y una frecuencia. El servidor utiliza los valores predeterminados del tipo de socio cuando están disponibles; en caso contrario, se requieren los valores introducidos aquí.",
    "accounting_refresh_defaults": "Actualizar valores contables predeterminados",
    "save_mapping": "Guardar asignación",
    "all_types": "Todos los tipos",
    "asset": "Activo",
    "liability": "Pasivo",
    "equity": "Patrimonio neto",
    "revenue": "Ingresos",
    "expense": "Gastos",
    "active_only": "Solo activas",
    "active_inactive": "Activas e inactivas",
    "selected_vendor": "Proveedor seleccionado",
    "select_a_vendor": "Selecciona un proveedor",
    "supplier_statement": "Extracto del proveedor",
    "collect": "Cobrar",
    "outstanding_revenue_requiring_attention": "Ingresos pendientes que requieren atención",
    "overdue_member_balances": "Saldos vencidos de socios",
    "review_balances": "Revisar saldos",
    "due_this_week": "Vence esta semana",
    "open_receivables": "Abrir cuentas a cobrar",
    "credit_balances_unapplied_cash": "Saldos a favor y cobros sin aplicar",
    "view_accounts": "Ver cuentas",
    "items_that_need_to_be_posted_into_the_books": "Elementos pendientes de contabilizar",
    "awaiting_posting": "Pendiente de contabilización",
    "open_queue": "Abrir cola",
    "invoices_awaiting_posting": "Facturas pendientes de contabilizar",
    "review_invoices": "Revisar facturas",
    "ap_bills_awaiting_posting": "Facturas de proveedor pendientes de contabilizar",
    "review_bills": "Revisar facturas de proveedor",
    "posting_exceptions": "Incidencias de contabilización",
    "review_exceptions": "Revisar incidencias",
    "pay": "Pagar",
    "supplier_obligations_coming_due": "Obligaciones con proveedores próximas a vencer",
    "overdue_supplier_bills": "Facturas de proveedor vencidas",
    "review_overdue": "Revisar vencidas",
    "due_today": "Vence hoy",
    "open_due_today": "Abrir vencimientos de hoy",
    "review_schedule": "Revisar calendario",
    "reconcile": "Conciliar",
    "bank_and_control_items_needing_review": "Elementos bancarios y de control que requieren revisión",
    "unmatched_transactions": "Transacciones sin conciliar",
    "reviewed_but_unmatched": "Revisadas sin conciliar",
    "continue_review": "Continuar revisión",
    "bank_accounts_unreconciled_this_period": "Cuentas bancarias sin conciliar en este período",
    "close_controls": "Cierre / Controles",
    "periodend_tasks_and_blockers": "Tareas y bloqueos de fin de período",
    "ar_posting_incomplete": "Contabilización de cuentas a cobrar incompleta",
    "ap_posting_incomplete": "Contabilización de cuentas a pagar incompleta",
    "resolve_items": "Resolver elementos",
    "bank_reconciliation_incomplete": "Conciliación bancaria incompleta",
    "open_reconciliation": "Abrir conciliación",
    "monthclose_blockers": "Bloqueos del cierre mensual",
    "view_blockers": "Ver bloqueos",
    "receivables_outstanding": "Cuentas a cobrar pendientes",
    "supplier_bills_due": "Facturas de proveedor por vencer",
    "posting_issues": "Incidencias de contabilización",
    "last_updated_time": "Última actualización: {time}",
    "record_payment_for_member": "Registrar pago de {member}",
    "issue_credit_memo_for_member": "Emitir nota de abono para {member}",
    "invoice_number": "Factura {number}",
    "on_hold": "En espera",
    "any_3": "Cualquiera",
    "all_categories": "Todas las categorías",
    "invoiced": "Facturado",
    "all_departments_2": "Todos los departamentos",
    "awaiting_approval": "Pendiente de aprobación",
    "exceptions": "Excepciones",
    "accommodation": "Alojamiento",
    "normal": "Normal",
    "warning_2": "Aviso",
    "import_failed_2": "Error de importación",
    "submit_for_approval": "Enviar a aprobación",
    "approval_status": "Estado de aprobación",
    "error_2": "Error",
    "events": "Eventos",
    "facilities": "Instalaciones",
    "golf": "Golf",
    "racquet": "Raqueta",
    "please_try_again": "Inténtalo de nuevo.",
    "benefits": "Ventajas",
    "bulk_update_failed": "Error en la actualización en bloque",
    "membership": "Socios",
    "accounting": "Contabilidad",
    "expenses": "Gastos",
    "spa": "Spa",
    "fitness": "Fitness",
    "payables": "Cuentas por pagar",
    "activities": "Actividades",
    "pay_date": "Fecha de pago",
    "front_desk": "Recepción",
    "club": "Club",
    "company": "Empresa",
    "your_changes_have_been_saved": "Tus cambios se han guardado.",
    "display_name": "Nombre visible",
    "spa_wellness": "Spa y bienestar",
    "missing": "Falta",
    "please_refresh_and_try_again": "Actualiza la página e inténtalo de nuevo.",
    "download_pdf": "Descargar PDF",
    "invalid_date": "Fecha no válida",
    "supplier_not_found": "No se encontró el proveedor.",
    "unable_to_load_supplier_ageing_detail": "No se pudo cargar el detalle de antigüedad del proveedor.",
    "cheque": "Cheque",
    "select_a_bank_account_for_bank_payments": "Selecciona una cuenta bancaria para los pagos bancarios.",
    "fix_payment_amounts_before_submitting": "Corrige los importes de pago antes de continuar.",
    "batch_payment_recorded": "Pago por lotes registrado.",
    "missing_accounting_defaults": "Faltan valores contables predeterminados.",
    "set_ap_control_and_payment_accounts_before_posting": "Configura las cuentas de control de proveedores y de pagos antes de contabilizar.",
    "failed_to_pay_selected_bills": "No se pudieron pagar las facturas de proveedor seleccionadas.",
    "failed_to_save_bill": "No se pudo guardar la factura del proveedor.",
    "enter_a_valid_payment_amount": "Introduce un importe de pago válido.",
    "payment_amount_must_cover_allocations": "El importe del pago debe cubrir las aplicaciones.",
    "fix_allocation_amounts_before_submitting": "Corrige los importes aplicados antes de continuar.",
    "failed_to_record_payment": "No se pudo registrar el pago.",
    "no_open_bills_found": "No se encontraron facturas de proveedor pendientes.",
    "select_a_vendor_to_view_open_bills": "Selecciona un proveedor para consultar sus facturas pendientes.",
    "loading_4": "Cargando…",
    "gross_payroll": "Salario bruto de la nómina",
    "latest_payroll_total": "Total de la última nómina",
    "no_payroll_yet": "Todavía no hay nóminas",
    "monthly_variance": "Variación mensual",
    "run_another_month_to_compare": "Procesa otro mes para comparar",
    "higher_than_previous_month": "Superior al mes anterior",
    "lower_than_previous_month": "Inferior al mes anterior",
    "highest_department_weighting": "Departamento con mayor proporción",
    "add_departments_to_compare": "Añade departamentos para comparar",
    "not_required_for_run": "No se requiere en este proceso",
    "employee_did_not_work": "El empleado no trabajó",
    "employee_will_be_paid_base_salary_only": "El empleado percibirá únicamente el salario base.",
    "employee_will_be_included_as_0_pay_only_after_you": "El empleado solo se incluirá con un pago de £0 cuando confirmes que no trabajó.",
    "review_before_payroll_can_proceed": "Revisa este elemento antes de continuar con la nómina.",
    "dashboard": "Panel",
    "payroll_runs": "Procesos de nómina",
    "approvals": "Aprobaciones",
    "liabilities": "Pasivos",
    "settings": "Configuración",
    "annual_salary": "Salario anual",
    "gross_annual_salary_before_deductions": "Salario bruto anual antes de deducciones.",
    "hourly_rate": "Tarifa horaria",
    "standard_hourly_rate_before_overtime": "Tarifa horaria estándar antes de horas extra.",
    "casual_hourly_rate": "Tarifa horaria eventual",
    "default_casual_hourly_rate": "Tarifa horaria eventual predeterminada.",
    "contractor_rate": "Tarifa de contratista",
    "default_contractor_rate_confirm_whether_this_is_hourly_or_dayrate": "Tarifa de contratista predeterminada. Confirma si es horaria o diaria antes de habilitar el cálculo de nómina.",
    "awaiting_approval_2": "Pendiente de aprobación",
    "approved_2": "Aprobada",
    "bacs_payment_file": "Archivo de pagos BACS",
    "nacha_payment_file": "Archivo de pagos NACHA",
    "sepa_payment_file": "Archivo de pagos SEPA",
    "bank_payment_file_csv": "Archivo CSV de pagos bancarios",
    "download_csv": "Descargar CSV",
    "blocked_statutory_values_stale": "Bloqueado: los valores legales están desactualizados",
    "blocked_employeelevel_statutory_values_required": "Bloqueado: se requieren valores legales por empleado",
    "regenerate_pdf_required": "Es necesario regenerar el PDF",
    "ready_to_generate": "Listo para generar",
    "payroll_summary_report": "Informe de resumen de nómina",
    "grosstonet_summary_report": "Informe de resumen del bruto al neto",
    "employee_breakdown_summary": "Resumen por empleado",
    "pension_contributions_summary": "Resumen de aportaciones a pensiones",
    "hmrc_summary_report": "Informe de resumen de HMRC",
    "final_payslips": "Nóminas individuales definitivas",
    "csv_summary_exports_and_printable_final_payslips_the_bank_payment": "Exportaciones de resumen CSV y nóminas individuales definitivas imprimibles. El archivo bancario solo sirve para exportar y validar; nunca mueve dinero.",
    "generate_payroll_documents": "Generar documentos de nómina",
    "blocked": "Bloqueado",
    "not_generated_yet": "Todavía no se ha generado",
    "generate_employeespecific_final_payslip_snapshots_before_publishing": "Genera las instantáneas definitivas por empleado antes de publicarlas.",
    "send_via_portal": "Enviar mediante el portal",
    "complete_once_to_make_payroll_clubready": "Complétalo una vez para preparar las nóminas del club.",
    "confirm_country": "Confirmar país",
    "choose_payroll_provider": "Elegir proveedor de nóminas",
    "confirm_pension_provider": "Confirmar proveedor de pensiones",
    "verify_payroll_calendar": "Verificar calendario de nóminas",
    "backenddriven_finance_control_workspace_for_the_active_payroll_run": "Espacio de control financiero basado en los datos del servidor del proceso de nómina activo.",
    "current_run_name": "Nombre del proceso actual",
    "pay_period": "Período de nómina",
    "approval_deadline": "Fecha límite de aprobación",
    "target_payment_date": "Fecha de pago prevista",
    "posting_readiness": "Preparación para contabilizar",
    "recommendation_create_or_calculate_the_current_payroll_run_before_approval": "Recomendación: crea o calcula el proceso de nómina actual antes de aprobarlo.",
    "insight_employee_readiness_timesheet_approvals_blockers_and_journal_preview_are": "Información: la preparación de empleados, las aprobaciones de partes de horas, los bloqueos y la vista previa del asiento proceden de los datos de nóminas del servidor.",
    "plainenglish_checks_based_on_actual_payroll_data": "Comprobaciones claras basadas en los datos reales de nómina.",
    "payroll_mapping": "Asignación contable de nóminas",
    "preview_only_balanced_journal_lines_appear_after_payroll_approvalpost_preview": "Solo vista previa. Las líneas equilibradas del asiento aparecen después de aprobar la nómina o preparar la vista previa contable.",
    "no_journal_preview_yet": "Todavía no hay vista previa del asiento",
    "create_or_calculate_a_payroll_run": "Crea o calcula un proceso de nómina",
    "employees_ready": "Empleados preparados",
    "bank_details": "Datos bancarios",
    "tax_details": "Datos fiscales",
    "approved_timesheets": "Partes de horas aprobados",
    "blockers": "Bloqueos",
    "current_payroll": "Nómina actual",
    "period_not_set": "Período sin establecer",
    "gross_pay_2": "Salario bruto",
    "net_preview": "Vista previa del neto",
    "employer_costs_2": "Costes empresariales",
    "total_payroll_cost_2": "Coste total de nóminas",
    "where_this_run_is_and_what_happens_next": "Estado de este proceso y próximos pasos.",
    "backend_checks_that_determine_whether_payroll_can_move_forward": "Comprobaciones del servidor que determinan si la nómina puede avanzar.",
    "needs_attention_2": "Requiere atención",
    "no_payroll_trend_data_yet_complete_your_first_payroll_run": "Todavía no hay datos de evolución. Completa el primer proceso de nómina para empezar a obtener información.",
    "latest_payroll_weighting_by_employee_department_employer_costs_are_not": "Distribución de la última nómina por departamento del empleado. En V1 los costes empresariales no se distribuyen entre departamentos.",
    "calculate_payroll_with_employee_departments_to_unlock_department_weighting": "Calcula la nómina con departamentos de empleados para ver su distribución.",
    "open_payroll_settings": "Abrir configuración de nóminas",
    "open_statutory_payroll_inputs": "Abrir datos legales de nómina",
    "open_employee_payroll_profile": "Abrir perfil de nómina del empleado",
    "readiness_details": "Detalles de preparación",
    "review_this_payroll_readiness_item": "Revisa este elemento de preparación de nómina.",
    "payroll_run": "Proceso de nómina",
    "fixed_salary": "Salario fijo",
    "timesheet_required": "Requiere parte de horas",
    "salary_timesheet_adjustments": "Salario y ajustes de partes de horas",
    "paid_from_the_profile_rate_without_requiring_a_timesheet": "Se paga según la tarifa del perfil sin requerir parte de horas.",
    "paid_from_approved_timesheet_hours_for_each_payroll_period": "Se paga según las horas aprobadas de cada período de nómina.",
    "base_salary_comes_from_the_profile_rate_timesheets_capture_overtimeadjustments": "El salario base procede de la tarifa del perfil; los partes registran horas extra y ajustes.",
    "fixed_day_of_month": "Día fijo del mes",
    "last_day_of_month": "Último día del mes",
    "last_working_day_of_month": "Último día laborable del mes",
    "last_monday_of_month": "Último lunes del mes",
    "last_tuesday_of_month": "Último martes del mes",
    "last_wednesday_of_month": "Último miércoles del mes",
    "last_thursday_of_month": "Último jueves del mes",
    "last_friday_of_month": "Último viernes del mes",
    "missing_bank": "Faltan datos bancarios",
    "missing_tax": "Faltan datos fiscales",
    "missing_pension": "Faltan datos de pensión",
    "unnamed_employee": "Empleado sin nombre",
    "view_employee": "Ver empleado",
    "fix_details": "Corregir datos",
    "add_an_employee_or_adjust_the_filters": "Añade un empleado o ajusta los filtros.",
    "could_not_load_departments": "No se pudieron cargar los departamentos",
    "could_not_move_employees_the_change_was_reverted": "No se pudieron mover los empleados. Se revirtió el cambio.",
    "enter_a_department_name_first": "Introduce primero el nombre del departamento.",
    "could_not_create_department": "No se pudo crear el departamento",
    "move_people_here_to_remove_assignment": "Mueve personal aquí para eliminar su asignación.",
    "drag_people_here_or_use_the_selector": "Arrastra personal aquí o utiliza el selector.",
    "could_not_archive_department": "No se pudo archivar el departamento",
    "visual_payroll_team_management_avatarled_draganddrop_friendly_no_hierarchy": "Gestión visual del equipo de nóminas mediante avatares y arrastrar y soltar, sin jerarquías.",
    "create_department": "Crear departamento",
    "select_a_staff_member_before_creating_the_employee_setup": "Selecciona un miembro del personal antes de crear la configuración del empleado.",
    "choose_a_pay_type": "Elige un tipo de remuneración.",
    "choose_a_payroll_status": "Elige un estado de nómina.",
    "we_could_not_create_this_employee_payroll_setup_please_check": "No se pudo crear la configuración de nómina del empleado. Comprueba los datos e inténtalo de nuevo.",
    "create_employee": "Crear empleado",
    "start_with_a_staff_record_then_configure_pay_and_readiness": "Selecciona un registro de personal y configura la remuneración y los datos básicos de preparación.",
    "no_calendar": "Sin calendario",
    "bank_payment_details_are_not_configured_for_this_club_jurisdiction": "Todavía no se han configurado los datos de pagos bancarios para la jurisdicción del club.",
    "account_holder_name": "Nombre del titular de la cuenta",
    "payment_reference_optional": "Referencia del pago (opcional)",
    "routing_number": "Número de ruta bancaria",
    "checking": "Cuenta corriente",
    "savings": "Cuenta de ahorro",
    "privana_stores_payroll_payment_details_encrypted_full_details_are_never": "Privana guarda cifrados los datos de pago de nóminas. Los datos completos no vuelven a mostrarse después de guardarlos.",
    "replacement_reason": "Motivo de sustitución",
    "replace_payment_details": "Sustituir datos de pago",
    "add_payment_details": "Añadir datos de pago",
    "profile_detail_could_not_be_loaded": "No se pudieron cargar los detalles del perfil.",
    "replacement_reason_is_required_when_replacing_payment_details": "Se requiere un motivo al sustituir los datos de pago.",
    "payment_details_saved_review_the_refreshed_details_then_mark_them": "Datos de pago guardados. Revisa los datos actualizados y márcalos como verificados después de comprobarlos.",
    "payroll_profile_changes_saved": "Cambios del perfil de nómina guardados.",
    "payment_verification_status_updated": "Estado de verificación del pago actualizado.",
    "payment_verification_status_could_not_be_updated": "No se pudo actualizar el estado de verificación del pago.",
    "status_could_not_be_updated": "No se pudo actualizar el estado.",
    "payroll_number_pending": "Número de nómina pendiente",
    "no_active_rate": "Sin tarifa activa",
    "not_paid_yet": "Todavía no se ha pagado",
    "no_amount_configured": "Sin importe configurado",
    "active_3": "Activo",
    "not_active": "No activo",
    "amount_paid_according_to_the_selected_pay_type": "Importe pagado según el tipo de remuneración seleccionado.",
    "no_full_ni_number_stored": "No se guarda el número NI completo.",
    "employeespecific_employer_cost_overrides_are_stored_in_pension_metadata": "Los ajustes de coste empresarial por empleado se guardan en los metadatos de pensiones.",
    "audit_event_recorded": "Evento de auditoría registrado.",
    "no_records_yet": "Todavía no hay registros.",
    "hmrcpaye_liability": "Obligación con HMRC/PAYE",
    "hmrc_payroll_liability": "Obligación de nómina con HMRC",
    "journal_balanced": "Asiento equilibrado",
    "journal_not_balanced": "Asiento descuadrado",
    "employer_costs_currently_000": "Costes empresariales actuales: £0.00",
    "mapping_needed": "Se requiere asignación contable",
    "could_not_load_timesheets": "No se pudieron cargar los partes de horas",
    "timesheet_action_failed": "No se pudo realizar la acción del parte de horas",
    "submitted_hours": "Horas presentadas",
    "approved_hours": "Horas aprobadas",
    "overtime_hours": "Horas extra",
    "missing_timesheets": "Partes de horas pendientes",
    "pending_approvals": "Aprobaciones pendientes",
    "approved_timesheets_are_the_operational_input_layer_for_timesheetdriven_and": "Los partes aprobados son la fuente operativa de horas de los empleados con partes de horas y de modalidad híbrida.",
    "regular_hours": "Horas ordinarias",
    "overtime": "Horas extra",
    "holiday": "Vacaciones",
    "sick": "Baja por enfermedad",
    "total_hours": "Total de horas",
    "none": "Ninguno",
    "could_not_load_timesheet": "No se pudo cargar el parte de horas",
    "could_not_save_draft": "No se pudo guardar el borrador",
    "action_failed_2": "No se pudo realizar la acción",
    "timesheet": "Parte de horas",
    "regular": "Ordinarias",
    "no_adjustments_yet": "Todavía no hay ajustes.",
    "could_not_create_timesheet": "No se pudo crear el parte de horas",
    "this_timesheet_records_overtime_holiday_sick_training_or_extra_payable": "Este parte registra horas extra, vacaciones, bajas por enfermedad, formación u otras horas pagaderas. El salario fijo sigue definido por la configuración salarial del empleado.",
    "this_timesheet_records_payable_hours_for_the_selected_payroll_period": "Este parte registra las horas pagaderas del período de nómina seleccionado.",
    "create_a_draft_timesheet_for_a_generated_payroll_period": "Crea un parte de horas en borrador para un período de nómina generado.",
    "choose_employee": "Elige un empleado",
    "choose_payroll_period": "Elige un período de nómina",
    "import_support_is_ready_for_csvtimeclock_integrations_this_pass_creates": "La importación está preparada para integraciones CSV y de control horario. Este proceso solo crea partes de horas en borrador.",
    "approve_payroll": "Aprobar nómina",
    "prepare_finance_preview": "Preparar vista previa contable",
    "view_payroll": "Ver nómina",
    "open_payroll": "Abrir nómina",
    "could_not_load_payroll_runs": "No se pudieron cargar los procesos de nómina",
    "gross": "Bruto",
    "net_preview_2": "Vista previa del neto",
    "ready_4": "✓ Preparado",
    "create_a_run_from_an_open_payroll_period_to_start": "Crea un proceso a partir de un período de nómina abierto para iniciar la revisión guiada.",
    "not_supplied": "No facilitado",
    "recorded_user": "Usuario registrado",
    "employeelevel_statutory_values_are_ready_for_payroll_documents_and_future": "Los valores legales por empleado están preparados para los documentos y las futuras nóminas individuales.",
    "legacy_providersupplied_statutory_values_are_held_at_run_level_and": "Los valores legales anteriores facilitados por el proveedor están a nivel de proceso y no son nóminas individuales.",
    "missing_paye": "Falta PAYE",
    "missing_employee_ni": "Falta NI del empleado",
    "missing_employer_ni": "Falta NI de la empresa",
    "net_pay_below_zero": "Salario neto inferior a cero",
    "unsaved_changes_reset": "Se han restablecido los cambios sin guardar.",
    "postedlocked_payroll_runs_are_readonly": "Los procesos contabilizados o bloqueados son de solo lectura.",
    "complete_paye_employee_ni_and_employer_ni_for_every_employee": "Completa PAYE, NI del empleado y NI de la empresa de cada empleado antes de guardar.",
    "employee_statutory_payroll_inputs_saved": "Datos legales de nómina por empleado guardados.",
    "payroll_rows_changed_refreshing_this_run_please_review_and_save": "Las filas de nómina han cambiado. Se está actualizando el proceso; revísalo y guarda de nuevo.",
    "could_not_save_statutory_payroll_inputs": "No se pudieron guardar los datos legales de nómina.",
    "paye_income_tax_2": "Impuesto sobre la renta PAYE",
    "employee_national_insurance_2": "National Insurance del empleado",
    "employer_national_insurance_2": "National Insurance de la empresa",
    "employee_pension": "Pensión del empleado",
    "other_employee_deductions": "Otras deducciones del empleado",
    "net_pay_2": "Salario neto",
    "total_employer_cost": "Coste empresarial total",
    "invalid": "No válido",
    "missing_inputs": "Faltan datos",
    "complete_3": "Completo",
    "could_not_create_payroll_run": "No se pudo crear el proceso de nómina",
    "create_a_payroll_run_from_a_generated_payroll_period": "Crea un proceso de nómina a partir de un período generado.",
    "choose_calendar": "Elige un calendario",
    "choose_open_generated_period": "Elige un período generado abierto",
    "resolve_blockers": "Resolver bloqueos",
    "fix_payroll_blockers_before_submitting": "Resuelve los bloqueos de nómina antes de presentar.",
    "enter_statutory_payroll_inputs": "Introducir datos legales de nómina",
    "enter_providersupplied_paye_employee_ni_and_employer_ni_for_each": "Introduce los valores de PAYE, NI del empleado y NI de la empresa facilitados por el proveedor para cada empleado antes de aprobar.",
    "calculate_payroll": "Calcular nómina",
    "approve_payroll_2": "Aprobar nómina",
    "resolve_blockers_before_approval_2": "Resuelve los bloqueos antes de aprobar.",
    "prepare_finance_preview_2": "Preparar vista previa contable",
    "post_payroll_to_accounting": "Contabilizar nómina",
    "journal_not_balanced_review_the_finance_preview_before_posting": "El asiento está descuadrado. Revisa la vista previa contable antes de contabilizar.",
    "record_payroll_payment": "Registrar pago de nómina",
    "lock_payroll": "Bloquear nómina",
    "payroll_complete": "Nómina finalizada",
    "this_payroll_run_is_complete": "Este proceso de nómina ha finalizado.",
    "could_not_load_payroll_run": "No se pudo cargar el proceso de nómina",
    "enter_statutory_payroll_inputs_before_continuing": "Introduce los datos legales de nómina antes de continuar.",
    "payroll_has_already_been_posted_and_cannot_be_rolled_back": "La nómina ya se ha contabilizado y no se puede retroceder.",
    "payroll_finance_mappings_need_attention": "Las asignaciones contables de nóminas requieren atención.",
    "post_payroll_to_accounting_before_payment": "Contabiliza la nómina antes de pagar.",
    "complete_finance_posting_payables_and_staff_payment_before_locking_payroll": "Completa la contabilización, las cuentas a pagar y el pago al personal antes de bloquear la nómina.",
    "this_payroll_run_is_not_ready_for_that_step": "Este proceso de nómina no está preparado para ese paso.",
    "payroll_finance_preview_is_not_balanced_yet": "La vista previa contable de nómina todavía está descuadrada.",
    "this_payroll_run_is_locked": "Este proceso de nómina está bloqueado.",
    "payroll_run_updated": "Proceso de nómina actualizado.",
    "payroll_summary_reports_generated": "Informes de resumen de nómina generados.",
    "nowork_exception_recorded": "Excepción de ausencia de trabajo registrada.",
    "timesheetnotrequired_acknowledgement_recorded": "Confirmación de parte de horas no requerido registrada.",
    "load_the_payroll_run_before_generating_reports": "Carga el proceso de nómina antes de generar informes.",
    "payroll_run_2": "Proceso de nómina",
    "follow_the_guided_payroll_lifecycle_from_review_through_accounting_posting": "Sigue el ciclo guiado de nómina desde la revisión hasta la contabilización, las obligaciones pendientes, el pago y el bloqueo.",
    "review_this_item_before_moving_payroll_forward": "Revisa este elemento antes de avanzar con la nómina.",
    "open_payroll_settings_and_fix_finance_mappings": "Abre la configuración de nóminas y corrige las asignaciones contables.",
    "open_the_related_employee_timesheet_or_deduction_totals_and_update": "Abre el empleado, parte de horas o totales de deducciones relacionados y completa la información que falta.",
    "confirm_staff_portal_publishing_for_this_payroll_run": "Confirma la publicación de este proceso de nómina en el portal del personal.",
    "publish_payslips": "Publicar nóminas individuales",
    "employee_breakdown_uses_saved_employeelevel_statutory_inputs_ready_for_payslip": "El desglose por empleado utiliza los datos legales guardados. Listo para nómina individual significa que los valores están registrados; los documentos generados aparecen en Documentos de nóminas.",
    "legacy_runlevel_statutory_values_are_not_employee_payslips_final_payslips": "Los valores legales anteriores a nivel de proceso no son nóminas individuales. Las nóminas definitivas requieren valores legales por empleado.",
    "pay_type_2": "Tipo de remuneración",
    "base_pay": "Salario base",
    "regular_hours_2": "Horas ordinarias",
    "overtime_hours_2": "Horas extra",
    "overtime_pay": "Remuneración de horas extra",
    "deductions": "Deducciones",
    "runlevel_only": "Solo a nivel de proceso",
    "included_in_run_summary": "Incluido en el resumen del proceso",
    "see_run_totals": "Ver totales del proceso",
    "no_work_this_period": "Sin trabajo en este período",
    "runlevel_statutory_values": "Valores legales a nivel de proceso",
    "show": "Mostrar",
    "payable_created": "Obligación de pago creada",
    "no_payment_preview_yet": "Todavía no hay vista previa del pago.",
    "approval": "Aprobación",
    "payroll_approval_required": "Se requiere aprobar la nómina",
    "finance_admin": "Finanzas / Administración",
    "no_due_date": "Sin fecha de vencimiento",
    "no_linked_item_is_available_yet": "Todavía no hay ningún elemento vinculado disponible.",
    "open_the_linked_payroll_item": "Abre el elemento de nómina vinculado.",
    "open_linked_item": "Abrir elemento vinculado",
    "no_action_available": "No hay acciones disponibles",
    "no_payroll_approvals_or_blocker_reviews_are_waiting": "No hay aprobaciones de nómina ni revisiones de bloqueos pendientes.",
    "payroll_clearing": "Cuenta transitoria de nóminas",
    "benefits_and_other": "Prestaciones y otros",
    "payroll_obligation": "Obligación de nómina",
    "create_payment_coming_soon": "Creación de pagos próximamente",
    "preview_only": "Solo vista previa",
    "create_and_calculate_a_payroll_run_to_see_payroll_liability": "Crea y calcula un proceso de nómina para ver la vista previa de sus obligaciones.",
    "no_rounding": "Sin redondeo",
    "round_to_nearest_5_minutes": "Redondear a los 5 minutos más cercanos",
    "round_to_nearest_15_minutes": "Redondear a los 15 minutos más cercanos",
    "round_up_to_nearest_15_minutes": "Redondear hacia arriba a los próximos 15 minutos",
    "settings_saved": "Configuración guardada.",
    "unable_to_save_settings": "No se pudo guardar la configuración.",
    "payroll_policies_saved": "Políticas de nóminas guardadas.",
    "unable_to_save_payroll_policies": "No se pudieron guardar las políticas de nóminas.",
    "unable_to_refresh_payroll_rule_defaults": "No se pudieron actualizar los valores predeterminados de las reglas de nómina.",
    "provider_supplied": "Facilitado por el proveedor",
    "privana_records_statutory_payroll_outputs_supplied_by_your_accountant_payroll": "Privana registra los resultados legales de nómina facilitados por tu contable, gestoría o programa de nóminas.",
    "connected_payroll_engine": "Motor de nóminas conectado",
    "coming_soon_privana_will_receive_statutory_outputs_from_a_connected": "Próximamente: Privana recibirá resultados legales de un motor de nóminas conectado.",
    "checked_manually": "Comprobado manualmente",
    "checked_by_a_person_before_approval": "Comprobado por una persona antes de aprobar.",
    "privana_calculates": "Calculado por Privana",
    "privana_calculates_this_when_configured": "Privana lo calcula cuando está configurado.",
    "handled_outside_privana": "Gestionado fuera de Privana",
    "handled_outside_privana_final_totals_are_entered_manually": "Se gestiona fuera de Privana; los totales finales se introducen manualmente.",
    "not_used": "No utilizado",
    "disabled": "Deshabilitado.",
    "provider_supplied_values_are_entered_during_payroll_run_review": "Facilitado por el proveedor: los valores se introducen durante la revisión del proceso de nómina.",
    "statutory_values_change_every_payroll_run_so_they_are_entered": "Los valores legales cambian en cada proceso de nómina y se introducen en su pantalla de revisión, no en la configuración.",
    "employer_pension_contributions": "Aportaciones de la empresa a pensiones",
    "clubfunded_workplace_pension_cost": "Coste de pensiones de empleo financiado por el club.",
    "set_the_employer_pension_rate_privana_should_calculate_from_eligible": "Establece el porcentaje de pensión empresarial que Privana calculará sobre el salario bruto elegible.",
    "fixed_employer_contributions": "Aportaciones fijas de la empresa",
    "flat_employer_contribution_per_run_when_your_club_uses_one": "Aportación fija de la empresa por proceso, cuando corresponda.",
    "use_only_for_fixed_club_employer_costs_that_should_be": "Utilízalo solo para costes empresariales fijos del club que deban añadirse a cada proceso de nómina.",
    "manual_employer_cost_adjustments": "Ajustes manuales del coste empresarial",
    "auditable_manual_employer_cost_adjustment": "Ajuste manual auditable del coste empresarial.",
    "use_for_reviewed_employer_costs_that_are_not_statutory_deductions": "Utilízalo para costes empresariales revisados que no sean deducciones legales ni pensiones.",
    "workplace_pension_scheme": "Plan de pensiones de empleo",
    "provider_employee_contribution_club_contribution_and_autoenrolment_settings": "Proveedor, aportación del empleado, aportación del club y configuración de inscripción automática.",
    "set_the_provider_and_contribution_percentages_your_club_uses_for": "Establece el proveedor y los porcentajes de aportación utilizados por el club en la inscripción automática.",
    "additional_pay_for_approved_overtime_hours": "Remuneración adicional por horas extra aprobadas.",
    "use_the_multiplier_your_club_applies_when_approved_hours_are": "Utiliza el multiplicador del club para las horas aprobadas que excedan la jornada ordinaria.",
    "holiday_pay": "Remuneración de vacaciones",
    "paid_annual_leave": "Vacaciones anuales retribuidas.",
    "choose_how_holiday_pay_is_handled_for_your_club_staff": "Elige cómo se remunera el período de vacaciones del personal del club.",
    "sick_pay": "Remuneración de bajas por enfermedad",
    "pay_for_approved_sickness_absence": "Remuneración de bajas por enfermedad aprobadas.",
    "choose_statutory_sick_pay_your_club_policy_or_manual_review": "Elige la prestación legal por enfermedad, la política del club o la revisión manual.",
    "private_healthcare_car_allowances_and_other_benefits": "Asistencia sanitaria privada, ayudas de transporte y otras prestaciones.",
    "turn_this_on_only_if_your_club_tracks_employee_benefits": "Actívalo solo si el club gestiona prestaciones de empleados en las nóminas.",
    "statutory_payroll": "Datos legales de nómina",
    "pension_benefits": "Pensiones y prestaciones",
    "pay_policies": "Políticas salariales",
    "customised": "Personalizado",
    "using_defaults": "Valores predeterminados",
    "disabled_2": "Deshabilitado",
    "enabled_2": "Habilitado",
    "united_kingdom": "🇬🇧 Reino Unido",
    "united_states": "🇺🇸 Estados Unidos",
    "european_payroll_region": "🇪🇺 Región de nóminas europea",
    "payroll_jurisdiction_not_set": "Jurisdicción de nóminas sin establecer",
    "united_kingdom_payroll_rules": "Reglas de nóminas del Reino Unido",
    "united_states_payroll_rules": "Reglas de nóminas de Estados Unidos",
    "european_payroll_rules": "Reglas de nóminas europeas",
    "payroll_rules": "Reglas de nóminas",
    "payroll_calendar_saved": "Calendario de nóminas guardado.",
    "unable_to_save_payroll_calendar": "No se pudo guardar el calendario de nóminas.",
    "payroll_periods_generated_open_generated_periods_were_refreshed_locked_paid": "Períodos de nómina generados. Se actualizaron los períodos abiertos y se conservaron los bloqueados, pagados y cerrados.",
    "payroll_calendar_updated": "Calendario de nóminas actualizado.",
    "payroll_calendar_action_failed": "No se pudo realizar la acción del calendario de nóminas.",
    "unable_to_load_payroll_settings": "No se pudo cargar la configuración de nóminas.",
    "payroll_calendars_define_how_privana_creates_payroll_periods_approval_deadlines": "Los calendarios definen cómo crea Privana los períodos de nómina, los plazos de aprobación, los cortes de partes de horas y las fechas de pago.",
    "cycle_anchor_date": "Fecha de referencia del ciclo",
    "first_period_anchor_preview_from": "Referencia del primer período / Inicio de vista previa",
    "period_dates": "Fechas del período",
    "timesheet_cutoff": "Corte de partes de horas",
    "save_calendar": "Guardar calendario",
    "store_clublevel_policy_defaults_for_future_payroll_calculations": "Guarda las políticas predeterminadas del club para cálculos de nómina futuros.",
    "holiday_pay_enabled": "Remuneración de vacaciones habilitada",
    "sick_pay_enabled": "Remuneración de bajas por enfermedad habilitada",
    "sick_pay_requires_manager_review": "La remuneración de bajas requiere revisión del responsable",
    "save_pay_rules": "Guardar reglas salariales",
    "timesheet_rounding_controls_how_clockinout_times_are_normalised_before_payroll": "El redondeo de partes de horas controla cómo se normalizan las horas de entrada y salida antes de revisar la nómina.",
    "save_timesheet_rules": "Guardar reglas de partes de horas",
    "plainenglish_club_payroll_choices_privana_keeps_technical_engine_settings_tucked": "Opciones claras de nómina del club. Privana mantiene oculta la configuración técnica salvo cuando soporte la necesita.",
    "confirm_pension_scheme_defaults_and_staff_benefits_your_club_tracks": "Confirma los valores predeterminados del plan de pensiones y las prestaciones del personal que gestiona el club.",
    "set_how_your_club_handles_overtime_holiday_pay_and_sickness": "Configura cómo gestiona el club las horas extra, las vacaciones y las bajas por enfermedad.",
    "coming_soon_privana_does_not_currently_connect_to_payroll_engines": " (Próximamente. Privana todavía no se conecta a motores de nóminas para cálculos legales.)",
    "benefits_enabled": "Prestaciones habilitadas",
    "included_in_salary": "Incluido en el salario",
    "timesheet_based": "Basado en partes de horas",
    "statutory_sick_pay": "Prestación legal por enfermedad",
    "club_policy": "Política del club",
    "these_controls_determine_which_payroll_checks_privana_assist_will_surface": "Estos controles determinan las comprobaciones que mostrará Privana Assist durante la revisión de nóminas.",
    "variance_alerts": "Alertas de desviación",
    "missing_data_checks": "Comprobaciones de datos incompletos",
    "duplicate_payment_detection": "Detección de pagos duplicados",
    "payroll_readiness_summary": "Resumen de preparación de nómina",
    "save_privana_assist_controls": "Guardar controles de Privana Assist",
    "production_role_model_for_payroll_access": "Modelo de roles de producción para el acceso a nóminas.",
    "payroll_admin": "Administrador de nóminas",
    "manage_payroll_settings": "Gestionar configuración de nóminas",
    "create_payroll_runs": "Crear procesos de nómina",
    "edit_employees": "Editar empleados",
    "payroll_approver": "Aprobador de nóminas",
    "approve_payroll_runs": "Aprobar procesos de nómina",
    "approve_payroll_liabilities": "Aprobar obligaciones de nómina",
    "view_journal_previews": "Ver vistas previas de asientos",
    "department_manager": "Responsable del departamento",
    "approve_timesheets": "Aprobar partes de horas",
    "review_overtime": "Revisar horas extra",
    "view_department_payroll_summaries": "Ver resúmenes departamentales de nómina",
    "read_only_2": "Solo lectura",
    "view_payroll_dashboard": "Ver panel de nóminas",
    "view_payroll_reports": "Ver informes de nóminas",
    "no_editing_rights": "Sin permiso de edición",
    "needs_finance": "Requiere revisión financiera",
    "verified": "Verificado",
    "high": "Alta",
    "medium": "Media",
    "ap_payment_recorded": "Pago a proveedores registrado.",
    "12month_gross_payroll_with_monthly_variance": "Salario bruto de 12 meses con variación mensual.",
    "a_department_with_this_name_already_exists": "Ya existe un departamento con este nombre.",
    "supplier_bill": "Factura del proveedor",
    "part_paid": "Pagada parcialmente",
    "ready_for_payment": "Lista para pagar",
    "club_context_is_missing_select_a_club_to_view_payables": "No se ha seleccionado un club. Selecciona uno para consultar las cuentas a pagar.",
    "unable_to_load_accounts_payable_data": "No se pudieron cargar los datos de cuentas a pagar.",
    "source_navigation_unavailable_for_this_payable": "No se puede acceder al origen de esta obligación de pago.",
    "add_at_least_one_bill_line_before_posting": "Añade al menos una línea a la factura del proveedor antes de contabilizar.",
    "unable_to_post_bill": "No se pudo contabilizar la factura del proveedor.",
    "unable_to_void_bill": "No se pudo anular la factura del proveedor.",
    "allocations_unapplied": "Aplicaciones retiradas.",
    "unable_to_unapply_allocations": "No se pudieron retirar las aplicaciones.",
    "allocations_reallocated": "Aplicaciones redistribuidas.",
    "unable_to_reallocate_payment": "No se pudo redistribuir el pago.",
    "enter_a_valid_refund_amount": "Introduce un importe de reembolso válido.",
    "refund_exceeds_available_amount": "El reembolso supera el importe disponible.",
    "select_a_bank_account_for_bank_refunds": "Selecciona una cuenta bancaria para los reembolsos bancarios.",
    "refund_recorded": "Reembolso registrado.",
    "configure_ap_control_and_payment_accounts_before_refunding": "Configura las cuentas de control de proveedores y de pagos antes de reembolsar.",
    "unable_to_refund_payment": "No se pudo reembolsar el pago.",
    "total_payables": "Total de cuentas a pagar",
    "outstanding_payables": "Cuentas a pagar pendientes",
    "due_this_month": "Vence este mes",
    "supplier_payables": "Cuentas a pagar a proveedores",
    "payroll_liabilities_2": "Obligaciones de nómina",
    "accounts_payable": "Cuentas a pagar",
    "posting": "Contabilizando…",
    "enter": "Introducir",
    "missing_information": "Falta información",
    "please_complete_all_required_fields_before_saving": "Completa todos los campos obligatorios antes de guardar.",
    "bank_account_added": "Cuenta bancaria añadida",
    "the_bank_account_is_ready_for_reconciliation": "La cuenta bancaria está preparada para conciliar.",
    "failed_to_add_bank_account": "No se pudo añadir la cuenta bancaria",
    "please_try_again_or_contact_support": "Inténtalo de nuevo o contacta con soporte.",
    "loading_gl_accounts": "Cargando cuentas del libro mayor…",
    "save_bank_account": "Guardar cuenta bancaria",
    "failed_to_load_bank_accounts": "No se pudieron cargar las cuentas bancarias",
    "bank_account_updated": "Cuenta bancaria actualizada",
    "failed_to_update_bank_account": "No se pudo actualizar la cuenta bancaria",
    "default_account_updated": "Cuenta predeterminada actualizada",
    "this_bank_account_is_now_the_default": "Esta cuenta bancaria es ahora la predeterminada.",
    "failed_to_update_default": "No se pudo actualizar el valor predeterminado",
    "no_gl_accounts": "No hay cuentas del libro mayor",
    "update_failed": "No se pudo actualizar",
    "unable_to_update_review_status": "No se pudo actualizar el estado de revisión.",
    "marked_reviewed": "Marcada como revisada",
    "marked_unreviewed": "Marcada como no revisada",
    "unable_to_update_review_status_for_selected_transactions": "No se pudo actualizar el estado de revisión de las transacciones seleccionadas.",
    "missing_reconciliation_scope": "Falta el ámbito de conciliación",
    "refresh_summary_to_load_statement_scope_before_finalizing": "Actualiza el resumen para cargar el ámbito del extracto antes de finalizar.",
    "reconciliation_finalized": "Conciliación finalizada",
    "this_account_period_is_now_marked_complete": "El período de esta cuenta está ahora marcado como completo.",
    "unable_to_finalize": "No se pudo finalizar",
    "resolve_all_unmatched_queues_before_finalizing": "Resuelve todas las colas sin conciliar antes de finalizar.",
    "ready_to_finalize": "Lista para finalizar",
    "mark_unreviewed_2": "Marcar como no revisada",
    "mark_reviewed_2": "Marcar como revisada",
    "no_transactions_yet_upload_a_statement_to_get_started": "Todavía no hay transacciones. Sube un extracto para empezar.",
    "select_a_bank_account_to_view_transactions": "Selecciona una cuenta bancaria para consultar sus transacciones.",
    "no_bank_accounts_yet_use_the_settings_menu_to_add": "Todavía no hay cuentas bancarias. Añade una desde el menú de configuración.",
    "autodetect": "Detectar automáticamente",
    "date_column_is_required": "La columna de fecha es obligatoria.",
    "description_column_is_required": "La columna de descripción es obligatoria.",
    "provide_either_an_amount_column_or_a_debitcredit_column": "Indica una columna de importe o columnas de debe y haber.",
    "statement_imported": "Extracto importado",
    "unable_to_import_statement": "No se pudo importar el extracto.",
    "back": "Atrás",
    "importing": "Importando…",
    "remaining": "Restante",
    "income": "Ingresos",
    "income_ytd": "Ingresos acumulados del ejercicio",
    "expenses_ytd": "Gastos acumulados del ejercicio",
    "unable_to_load_chart_of_accounts": "No se pudo cargar el plan de cuentas.",
    "account_code_and_name_are_required": "El código y el nombre de cuenta son obligatorios.",
    "unable_to_save_account_changes": "No se pudieron guardar los cambios de la cuenta.",
    "unable_to_update_account_status": "No se pudo actualizar el estado de la cuenta.",
    "edit_account": "Editar cuenta",
    "unable_to_load_dimensions": "No se pudieron cargar las dimensiones.",
    "dimension_code_and_name_are_required": "El código y el nombre de dimensión son obligatorios.",
    "that_dimension_code_already_exists_choose_a_unique_code": "Ya existe ese código de dimensión. Elige un código único.",
    "unable_to_save_dimension_changes": "No se pudieron guardar los cambios de la dimensión.",
    "unable_to_update_dimension_status": "No se pudo actualizar el estado de la dimensión.",
    "edit_dimension": "Editar dimensión",
    "operating": "Operativo",
    "capex": "CapEx",
    "this_fiscal_year": "Este ejercicio contable",
    "custom_range": "Intervalo personalizado",
    "unable_to_load_reports": "No se pudieron cargar los informes",
    "missing_fields": "Faltan campos",
    "please_enter_a_report_name_and_type": "Introduce un nombre y un tipo de informe.",
    "budget_required": "Se requiere un presupuesto",
    "select_a_budget_to_run_budget_vs_actual": "Selecciona un presupuesto para ejecutar Presupuesto frente a real.",
    "budget_version_required": "Se requiere una versión del presupuesto",
    "select_a_budget_version_to_run_budget_vs_actual": "Selecciona una versión del presupuesto para ejecutar Presupuesto frente a real.",
    "unable_to_save_report": "No se pudo guardar el informe",
    "are_you_sure_you_want_to_delete_this_report": "¿Seguro que quieres eliminar este informe?",
    "unable_to_delete_report": "No se pudo eliminar el informe",
    "gl_account_code": "Código de cuenta del libro mayor",
    "gl_account_name": "Nombre de cuenta del libro mayor",
    "ytd_budget": "Presupuesto acumulado del ejercicio",
    "ytd_actual": "Real acumulado del ejercicio",
    "ytd_variance": "Desviación acumulada del ejercicio",
    "ytd_variance_2": "Desviación acumulada del ejercicio %",
    "pdf_export_not_available_yet_use_csv": "La exportación PDF todavía no está disponible. Utiliza CSV.",
    "xlsx_export_coming_soon_for_budget_vs_actual": "Exportación XLSX de Presupuesto frente a real próximamente",
    "unable_to_download_report": "No se pudo descargar el informe",
    "unable_to_run_report": "No se pudo ejecutar el informe",
    "ondemand": "A petición",
    "failed_to_load_matches": "No se pudieron cargar las coincidencias",
    "unable_to_load_matching_candidates_please_try_again": "No se pudieron cargar los candidatos para conciliar. Inténtalo de nuevo.",
    "no_remaining_balance": "No queda saldo pendiente",
    "reduce_another_match_amount_before_selecting_this_allocation": "Reduce el importe de otra coincidencia antes de seleccionar esta aplicación.",
    "match_saved": "Conciliación guardada",
    "bank_transaction_matching_updated": "Conciliación de la transacción bancaria actualizada.",
    "failed_to_save_match": "No se pudo guardar la conciliación",
    "unable_to_update_bank_transaction_match_items": "No se pudieron actualizar los elementos de conciliación de la transacción bancaria.",
    "match_cleared": "Conciliación eliminada",
    "match_items_removed_for_this_transaction": "Se han eliminado los elementos de conciliación de esta transacción.",
    "failed_to_clear_match": "No se pudo eliminar la conciliación",
    "unable_to_clear_match_items_for_this_transaction": "No se pudieron eliminar los elementos de conciliación de esta transacción.",
    "bank_transaction": "Transacción bancaria",
    "unknown_period": "Período desconocido",
    "trial_balance_snapshot": "Instantánea del balance de sumas y saldos",
    "snapshot": "Instantánea",
    "unknown": "Desconocido",
    "unassigned_account": "Cuenta sin asignar",
    "unable_to_update_task": "No se pudo actualizar la tarea",
    "notes_saved": "Notas guardadas",
    "unable_to_save_notes": "No se pudieron guardar las notas",
    "period_closed": "Período cerrado",
    "close_blocked_by_earlier_periods": "Cierre bloqueado por períodos anteriores",
    "close_failed": "No se pudo cerrar",
    "unable_to_close_the_period_please_try_again": "No se pudo cerrar el período. Inténtalo de nuevo.",
    "period_locked": "Período bloqueado",
    "complete_required_tasks_or_add_an_override_reason": "Completa las tareas obligatorias o añade un motivo de excepción.",
    "lock_failed": "No se pudo bloquear",
    "unable_to_lock_the_period_please_try_again": "No se pudo bloquear el período. Inténtalo de nuevo.",
    "period_unlocked": "Período desbloqueado",
    "unlock_failed": "No se pudo desbloquear",
    "unable_to_unlock_the_period_please_try_again": "No se pudo desbloquear el período. Inténtalo de nuevo.",
    "period_reopened": "Período reabierto",
    "reopen_failed": "No se pudo reabrir",
    "unable_to_reopen_the_period_please_try_again": "No se pudo reabrir el período. Inténtalo de nuevo.",
    "snapshot_queued": "Instantánea en cola",
    "close_pack_snapshot_is_running": "Se está generando la instantánea del expediente de cierre.",
    "snapshot_failed": "No se pudo generar la instantánea",
    "optional_tasks": "Tareas opcionales",
    "no_updates_yet": "Todavía no hay actualizaciones",
    "lock_month": "Bloquear mes",
    "unlock_period": "Desbloquear período",
    "reopen_period": "Reabrir período",
    "run_snapshot": "Generar instantánea",
    "balanced": "Equilibrado",
    "out_of_balance": "Descuadrado",
    "periods_generated": "Períodos generados",
    "unable_to_generate_periods": "No se pudieron generar los períodos.",
    "unable_to_generate_periods_2": "No se pudieron generar los períodos",
    "unable_to_load_snapshot": "No se pudo cargar la instantánea",
    "current_period_is_locked_unlock_to_continue_closing": "El período actual está bloqueado. Desbloquéalo para continuar con el cierre.",
    "loading_years": "Cargando ejercicios…",
    "generate_periods_for_selected_year": "Generar períodos del ejercicio seleccionado",
    "unable_to_load_periods": "No se pudieron cargar los períodos",
    "please_refresh_to_try_again": "Actualiza la página para intentarlo de nuevo.",
    "created": "Creado",
    "edit_invoice": "Editar factura",
    "failed_to_load_layout_settings": "No se pudo cargar la configuración del diseño.",
    "billing_email_must_be_blank_or_a_valid_email_address": "El correo de facturación debe estar vacío o ser una dirección válida.",
    "accent_color_must_be_a_valid_hex_color": "El color de acento debe ser un valor HEX válido.",
    "footer_note_must_be_1000_characters_or_fewer": "La nota al pie no puede superar los 1000 caracteres.",
    "layout_saved_successfully": "Diseño guardado correctamente.",
    "failed_to_save_layout": "No se pudo guardar el diseño.",
    "save_layout": "Guardar diseño",
    "received": "Recibido",
    "paid_via_direct_payment_2": "Pagado mediante pago directo",
    "included_in_billing_run": "Incluido en un proceso de facturación",
    "fully_applied": "Aplicado por completo",
    "partially_applied": "Aplicado parcialmente",
    "enter_allocation_amounts": "Introduce los importes que aplicar.",
    "allocations_exceed_available_credit": "Las aplicaciones superan el saldo a favor disponible.",
    "credit_allocated": "Saldo a favor aplicado.",
    "unable_to_allocate_credit": "No se pudo aplicar el saldo a favor.",
    "credit_refund_recorded": "Reembolso del saldo a favor registrado.",
    "refund_payment_recorded": "Reembolso del pago registrado.",
    "configure_ar_control_and_payment_accounts_before_refunding": "Configura las cuentas de control de cuentas a cobrar y de pagos antes de reembolsar.",
    "credit_refund_not_allowed": "No se permite reembolsar el saldo a favor.",
    "refund_not_allowed": "No se permite el reembolso.",
    "cannot_refund_a_refund_payment": "No se puede reembolsar un pago de reembolso.",
    "unable_to_record_refund": "No se pudo registrar el reembolso.",
    "source_navigation_unavailable": "No se puede acceder al origen",
    "enter_a_valid_credit_amount": "Introduce un importe de abono válido.",
    "credit_applied": "Abono aplicado.",
    "unable_to_apply_credit": "No se pudo aplicar el abono.",
    "credit_note": "Nota de abono",
    "on_account": "A cuenta",
    "allocated_payment": "Pago aplicado",
    "linked_pos_sale": "Venta de TPV vinculada",
    "see_pos_transaction_detail": "Ver detalles de la transacción del TPV",
    "unapplying": "Retirando la aplicación…",
    "unapply": "Retirar aplicación",
    "open_originating_source": "Abrir origen de la operación",
    "source_resolution_unavailable": "No se puede obtener el origen",
    "view_statement": "Ver extracto",
    "reallocate_payment": "Redistribuir pago",
    "refund_credit_2": "Reembolsar saldo a favor",
    "submit_refund_payment": "Registrar reembolso del pago",
    "no_available_credit_to_apply": "No hay saldo a favor disponible para aplicar",
    "no_open_invoices_to_apply_credit_to": "No hay facturas pendientes a las que aplicar el saldo a favor",
    "apply_available_member_credit": "Aplicar el saldo a favor disponible del socio",
    "unable_to_load_current_period": "No se pudo cargar el período actual",
    "unable_to_load_close_checklist": "No se pudo cargar la lista de comprobación del cierre",
    "unable_to_close_period": "No se pudo cerrar el período.",
    "unable_to_close_period_2": "No se pudo cerrar el período",
    "unable_to_lock_period": "No se pudo bloquear el período.",
    "unable_to_lock_period_2": "No se pudo bloquear el período",
    "unable_to_unlock_period": "No se pudo desbloquear el período",
    "unable_to_reopen_period": "No se pudo reabrir el período",
    "select_period": "Selecciona un período",
    "complete_required_tasks_or_provide_an_override_reason": "Completa las tareas obligatorias o indica un motivo de excepción.",
    "required_tasks_must_be_completed_override_not_permitted": "Debes completar las tareas obligatorias; no se permiten excepciones.",
    "close_period": "Cerrar período",
    "lock_period": "Bloquear período",
    "adjusting": "Ajuste",
    "reversal": "Reversión",
    "year_end": "Cierre anual",
    "accrual": "Devengo",
    "member_accounts_receivable": "Cuentas a cobrar a socios",
    "billing_recurring_billing": "Facturación / Facturación recurrente",
    "staff_selected": "Personal seleccionado",
    "you_dont_have_permission_to_perform_this_action": "No tienes permiso para realizar esta acción.",
    "endpoint_not_deployed_route_missing": "Punto de acceso no desplegado o ruta no disponible.",
    "server_error_check_logs": "Error del servidor; consulta los registros.",
    "failed_to_load_monthend_tasks": "No se pudieron cargar las tareas de cierre mensual",
    "unable_to_load_tasks": "No se pudieron cargar las tareas",
    "failed_to_load_monthend_exceptions": "No se pudieron cargar las excepciones del cierre mensual",
    "unable_to_load_exceptions": "No se pudieron cargar las excepciones",
    "delete_this_task_template": "¿Eliminar esta plantilla de tarea?",
    "delete_this_exception_policy": "¿Eliminar esta política de excepciones?",
    "task_name_is_required": "El nombre de la tarea es obligatorio",
    "task_templates_saved": "Plantillas de tareas guardadas",
    "failed_to_save_task_templates": "No se pudieron guardar las plantillas de tareas",
    "unable_to_save_task_templates": "No se pudieron guardar las plantillas de tareas",
    "reason_is_required_for_exceptions": "Las excepciones requieren un motivo",
    "exception_policies_saved": "Políticas de excepciones guardadas",
    "failed_to_save_exception_policies": "No se pudieron guardar las políticas de excepciones",
    "unable_to_save_exception_policies": "No se pudieron guardar las políticas de excepciones",
    "walkin": "Cliente sin reserva",
    "unposted": "Sin contabilizar",
    "review_post": "Revisar y contabilizar",
    "voided": "Anulada",
    "fix_repost": "Corregir y volver a contabilizar",
    "view_issue": "Ver incidencia",
    "this_receivable_is_sourcemanaged_and_must_be_corrected_from_its": "Esta cuenta a cobrar se gestiona desde el origen y debe corregirse en su flujo de origen o proceso de contabilización.",
    "guest": "Invitado",
    "adhoc": "Puntual",
    "unable_to_resolve_this_golf_booking_source": "No se pudo obtener el origen de esta reserva de golf.",
    "unable_to_resolve_this_racquet_booking_source": "No se pudo obtener el origen de esta reserva de deportes de raqueta.",
    "unable_to_resolve_this_spa_booking_source": "No se pudo obtener el origen de esta reserva de spa.",
    "unable_to_resolve_this_fitness_booking_source": "No se pudo obtener el origen de esta reserva de fitness.",
    "unable_to_resolve_this_event_source": "No se pudo obtener el origen de este evento.",
    "unable_to_resolve_this_room_reservation_source": "No se pudo obtener el origen de esta reserva de alojamiento.",
    "source_navigation_is_not_available_for_this_charge_yet": "Todavía no se puede acceder al origen de este cargo.",
    "this_receivable_is_sourcemanaged_and_cannot_be_manually_posted_here": "Esta cuenta a cobrar se gestiona desde el origen y no se puede contabilizar manualmente aquí.",
    "unable_to_post_receivable": "No se pudo contabilizar la cuenta a cobrar.",
    "unable_to_create_credit_note": "No se pudo crear la nota de abono.",
    "debtor_type": "Tipo de deudor",
    "billing_run_2": "Facturación / Proceso",
    "open_invoice_detail": "Abrir detalles de la factura",
    "invoice_not_yet_generated": "Factura todavía no generada",
    "void_allocation": "Aplicación anulada",
    "choose_open_member_invoice": "Elige una factura pendiente de socio…",
    "save_draft_post_credit_note": "Guardar borrador / Contabilizar nota de abono",
    "unable_to_enroll_member": "No se pudo inscribir al socio",
    "golf_green_fees": "Derechos de juego de golf",
    "golf_addons_caddie_hire": "Complementos de golf / Servicio de caddie",
    "unmapped_charge": "Cargo sin asignación contable",
    "member_account": "Cuenta del socio",
    "will_be_generated_during_next_billing_run": "Se generará en el próximo proceso de facturación",
    "deferred_from_earlier_billing": "Aplazado desde una facturación anterior",
    "move_back_to_this_statement": "Devolver a este extracto",
    "next_billing_run": "Próximo proceso de facturación",
    "future_billing_run": "Proceso de facturación futuro",
    "no_billable_items_are_currently_available_for_invoicing": "No hay elementos facturables disponibles en este momento.",
    "unable_to_preview_invoice": "No se pudo mostrar la vista previa de la factura",
    "download_failed": "No se pudo descargar",
    "unable_to_generate_and_download_invoice": "No se pudo generar y descargar la factura",
    "unable_to_generate_and_send_invoice": "No se pudo generar y enviar la factura",
    "invoice_generated_successfully_but_the_email_could_not_be_delivered": "La factura se generó correctamente, pero no se pudo entregar el correo.",
    "the_invoice_is_available_in_invoicing": "La factura está disponible en Facturación.",
    "invoice_generated_and_emailed_successfully": "La factura se generó y envió por correo correctamente.",
    "unable_to_generate_club_run": "No se pudo generar el proceso del club",
    "choose_a_valid_current_or_future_billing_run": "Elige un proceso de facturación actual o futuro válido.",
    "billing_run_updated": "Proceso de facturación actualizado.",
    "unable_to_update_billing_run": "No se pudo actualizar el proceso de facturación",
    "unable_to_update_charge": "No se pudo actualizar el cargo",
    "unable_to_load_dues_enrollments": "No se pudieron cargar las inscripciones en cuotas",
    "billing_run_generated": "Proceso de facturación generado.",
    "unable_to_generate_recurring_billing_run": "No se pudo generar el proceso de facturación recurrente",
    "unable_to_run_bulk_action": "No se pudo ejecutar la acción por lotes",
    "recurring_billing_cannot_be_activated_until_a_dues_amount_greater_2": "La facturación recurrente requiere introducir una cuota mayor que cero.",
    "choose_a_monthly_quarterly_or_annual_frequency_before_enrolling_this": "Elige una frecuencia mensual, trimestral o anual antes de inscribir al socio.",
    "unable_to_generate_invoice": "No se pudo generar la factura",
    "unable_to_load_statement_preview_please_try_again": "No se pudo cargar la vista previa del extracto. Inténtalo de nuevo.",
    "unable_to_record_payments": "No se pudieron registrar los pagos",
    "unable_to_save_settings_2": "No se pudo guardar la configuración",
    "current_period_2": "Período actual",
    "sending_2": "Enviando…",
    "generate_send": "Generar y enviar",
    "generate_club_run": "Generar proceso del club",
    "current_run": "Proceso actual",
    "resolve_gl_mapping_warnings_before_generating_this_run": "Resuelve las advertencias de asignación contable antes de generar este proceso.",
    "membership_dues": "Cuotas de socios",
    "draft_invoice": "Factura en borrador",
    "line_item": "Línea",
    "confirm_generate": "Confirmar generación",
    "generate_download": "Generar y descargar",
    "primary_charge": "Cargo principal",
    "save_billing_run": "Guardar proceso de facturación",
    "chart_of_accounts_verified": "Plan de cuentas verificado",
    "tax_codes_verified": "Códigos fiscales verificados",
    "dimensions_verified": "Dimensiones verificadas",
    "revenue_mappings_verified": "Asignaciones de ingresos verificadas",
    "payroll_mappings_verified": "Asignaciones de nóminas verificadas",
    "label_is_required": "La etiqueta es obligatoria.",
    "label_must_include_letters_or_numbers": "La etiqueta debe incluir letras o números.",
    "that_label_creates_a_duplicate_key_try_a_slightly_different": "La etiqueta genera una clave duplicada. Prueba con una etiqueta diferente.",
    "unable_to_save_the_revenue_mapping": "No se pudo guardar la asignación de ingresos.",
    "unable_to_save_the_payroll_mapping": "No se pudo guardar la asignación de nóminas.",
    "unable_to_apply_regional_accounting_defaults": "No se pudieron aplicar los valores contables regionales predeterminados.",
    "accounting_defaults_refreshed": "Valores contables predeterminados actualizados.",
    "payroll_defaults_refreshed": "Valores predeterminados de nóminas actualizados.",
    "historical": "Histórico",
    "final_checks_are_taking_a_moment": "Las comprobaciones finales están tardando un momento…",
    "finalising_accounting_defaults_and_mappings": "Finalizando los valores contables y las asignaciones predeterminadas…",
    "edit_gl_mapping": "Editar asignación contable",
    "new_gl_mapping": "Nueva asignación contable",
    "unable_to_load_yearend_assistant": "No se pudo cargar el asistente de cierre anual",
    "unable_to_load_fiscal_years_right_now_please_refresh_and": "No se pudieron cargar los ejercicios contables. Actualiza la página e inténtalo de nuevo.",
    "yearend_is_blocked": "El cierre anual está bloqueado",
    "resolve_all_blocker_checks_before_closing_this_fiscal_year": "Resuelve todas las comprobaciones bloqueantes antes de cerrar este ejercicio.",
    "unable_to_close_fiscal_year": "No se pudo cerrar el ejercicio contable",
    "please_review_blockers_and_try_again": "Revisa los bloqueos e inténtalo de nuevo.",
    "billing_period": "Período de facturación",
    "not_billable": "No facturable",
    "recurring": "Recurrente",
    "recurring_billing_run": "Proceso de facturación recurrente",
    "direct_payment": "Pago directo",
    "not_billable_voidedcancelled": "No facturable: anulado o cancelado",
    "need_to_collect": "Pendiente de cobro",
    "blocked_missing_revenue_mapping": "Bloqueado: falta la asignación de ingresos",
    "manual_invoice": "Factura manual",
    "recurring_run": "Proceso recurrente",
    "payroll_method_2": "Método de nómina:",
    "impact": "Efecto:",
    "period_2": "Período:",
    "timesheet_cutoff_2": "Corte de partes de horas:",
    "approval_deadline_2": "Fecha límite de aprobación:",
    "pay_date_2": "Fecha de pago:",
    "employee_2": "Empleado:",
    "method_2": "Forma:",
    "receivable": "Cuenta a cobrar:",
    "payment_2": "Pago:",
    "allocations": "Aplicaciones:",
    "gl_journal": "Asiento del libro mayor:",
    "pos_sale_2": "Venta de TPV:",
    "taxvat": "Impuestos / IVA:",
    "inventory_movement": "Movimiento de inventario:",
    "credit_note_2": "N.º de nota de abono:",
    "amount_2": "Importe:",
    "invoice_3": "Factura:",
    "posted_2": "Contabilizada:",
    "posted_at": "Fecha de contabilización:",
    "created_by": "Creado por:",
    "source_ref": "Referencia de origen:",
    "gl_mapping_2": "Asignación contable:",
    "payment_source": "Origen del pago:",
    "payment_reference": "Referencia del pago:",
    "issued_due": "Emisión / Vencimiento:",
    "revenue_gl_account": "Cuenta de ingresos del libro mayor:",
    "receivables_control": "Control de cuentas a cobrar:",
    "cashbankcard_clearing": "Cuenta transitoria de efectivo / banco / tarjeta:",
    "tax_code_3": "Código fiscal:",
    "tax_rate_2": "Tipo impositivo:",
    "vattax_amount": "Importe de IVA / impuestos:",
    "vat_payable_gl": "Cuenta del libro mayor de IVA a pagar:",
    "dimension_2": "Dimensión:",
    "allocation_status": "Estado de aplicación:",
    "created_posted": "Creación / Contabilización:",
    "gl_journalbatch": "Asiento / Lote del libro mayor:",
    "pos_payment": "Pago del TPV:",
    "voidrefundreversal": "Anulación / Reembolso / Reversión:",
    "skipped_items": "Elementos omitidos:",
    "warnings": "Advertencias:",
    "panel": "Panel",
    "balance_due_value0": "Saldo pendiente: {value0}",
    "value0_avatar": "Avatar de {value0}",
    "value0_employees_value1": "Personal: {value0} • {value1}%",
    "move_this_payroll_run_back_to_value0": "Retroceder este proceso de nómina a {value0}",
    "step_value0": "Paso {value0}",
    "value0_stage_value1_pay_date_value2": "Etapa: {value0} • {value1} • Fecha de pago: {value2}",
    "affected_value0": "Afectados: {value0}",
    "recommended_fix_value0": "Solución recomendada: {value0}",
    "move_value0_department": "Mover al departamento {value0}",
    "warning_value0_active_current_rates_overlap_payroll_runs_use_the": "Advertencia: se solapan {value0} tarifas activas vigentes. Los procesos utilizan la tarifa vigente más reciente; guardar una tarifa activa nueva cerrará los solapamientos anteriores.",
    "user_value0": "Usuario: {value0}",
    "record_payroll_wage_expense_for_value0": "Registrar un gasto salarial de {value0}",
    "create_payroll_clearing_liability_for_net_staff_payments_of_value0": "Crear una obligación en la cuenta transitoria de nóminas por pagos netos al personal de {value0}",
    "paye_income_tax_value0": "Impuesto sobre la renta PAYE: {value0}",
    "employee_national_insurance_value0": "National Insurance del empleado: {value0}",
    "employer_national_insurance_value0": "National Insurance de la empresa: {value0}",
    "hmrc_total_value0": "Total HMRC: {value0}",
    "privana_assist_value0": "Privana Assist: {value0}",
    "value0_adjustment_rows_available": "Filas de ajuste disponibles: {value0}.",
    "value0_pay_date_value1": "{value0} • Fecha de pago: {value1}",
    "value0_of_value1_employees_complete": "Configuraciones de empleados completadas: {value0} de {value1}",
    "value0_pay_value1": "{value0} • Pago: {value1}",
    "journal_count_value0": "Número de asientos: {value0}",
    "primary_journal_value0": "Asiento principal: {value0}",
    "duplicates_value0": "Duplicados: {value0}",
    "value0_new_eligible_employee_is_not_included_yet_recalculate_payroll": "Personal elegible nuevo sin incluir: {value0}. Recalcula la nómina para incluirlo.",
    "fix_action_value0": "Acción correctora: {value0}",
    "owner_value0_due_value1": "Responsable: {value0} • Vencimiento: {value1}",
    "due_value0_source_value1": "Vencimiento: {value0} • Origen: {value1}",
    "value0_detected_automatically_from_your_club_address": "{value0} se detectó automáticamente a partir de la dirección del club.",
    "last_refreshed_value0": "Última actualización: {value0}",
    "value0_enabled": "{value0} habilitado",
    "minimum_earnings_threshold_value0": "Umbral mínimo de ingresos ({value0})",
    "remaining_capacity_value0": "Capacidad restante: {value0}",
    "amount_must_be_between_0_and_value0": "El importe debe estar entre 0 y {value0}.",
    "finalized_value0_by_value1": "Finalizada el {value0} por {value1}.",
    "value0_selected": "Selección: {value0}",
    "select_transaction_value0": "Seleccionar transacción {value0}",
    "ref_value0": "Ref.: {value0}",
    "detected_format_value0": "Formato detectado: {value0}",
    "value0_more": " (+{value0} más)",
    "previewing_value0_of_value1_rows": "Vista previa de {value0} de {value1} filas.",
    "step_value0_of_4": "Paso {value0} de 4",
    "actual_value0": "Real: {value0}",
    "budget_value0": "Presupuesto: {value0}",
    "difference_value0": "Diferencia: {value0}",
    "version_vvalue0": "Versión v{value0}",
    "value0_value1_to_value2": "{value0} · Del {value1} al {value2}",
    "value0_rows": "Filas: {value0}",
    "as_of_value0": "A fecha de {value0}",
    "confidence_value0": "Confianza: {value0}%",
    "status_value0": "Estado: {value0}",
    "remaining_to_match_value0": "Pendiente de conciliar: {value0}",
    "required_tasks_value0value1_complete": "Tareas obligatorias completadas: {value0}/{value1}.",
    "optional_value0value1": "Opcionales: {value0}/{value1}",
    "updated_value0_by_value1": "Actualizado el {value0} por {value1}",
    "staff_value0": "Personal: {value0}",
    "reason_value0": "Motivo: {value0}",
    "by_value0": "Por {value0}",
    "close_value0_first": "Cierra primero {value0}.",
    "manage_value0": "Gestionar {value0}",
    "generated_value0_value1": "Generado: {value0} {value1}",
    "fyvalue0": "Ejercicio {value0}",
    "fiscal_month_value0": "Mes del ejercicio {value0}",
    "value0value1_required": "Obligatorios: {value0}/{value1}",
    "value0value1_optional": "Opcionales: {value0}/{value1}",
    "sort_by_value0": "Ordenar por {value0}",
    "invoice_value0": "Factura n.º {value0}",
    "value0_logo": "Logotipo de {value0}",
    "tax_amount_value0_at_value1": "Importe de impuestos: {value0} al {value1}.",
    "missing_output_vat_gl_account_used_by_value0_invoice_value1": "Falta la cuenta de IVA repercutido; facturas afectadas: {value0} {value1}.",
    "lines_value0": "Líneas: {value0}",
    "direct_payment_via_member_portalvalue0": "Pago directo desde el portal de socios{value0}",
    "account_details_value0": "Detalles de la cuenta: {value0}",
    "unapplied_credit_available_value0": "Saldo a favor sin aplicar disponible: {value0}",
    "unapply_credit_value0_value1": "Retirar aplicación del abono {value0} ({value1})",
    "max_refundable_value0": "Importe máximo reembolsable: {value0}",
    "account_value0": "Cuenta: {value0}",
    "applied_value0": "Aplicado: {value0}",
    "value0_date_value1_due_value2": "N.º {value0} · Fecha {value1} · Vencimiento {value2}",
    "showing_value0value1_of_value2": "Mostrando {value0}–{value1} de {value2}",
    "value0_value1_payment_value2": "{value0} · {value1} · Pago: {value2}",
    "value0_value1_vat_value2_gross_value3": "{value0} · {value1} · IVA: {value2} · Bruto: {value3}",
    "value0_value1_dr_value2_cr_value3": "{value0} · {value1} · Debe: {value2} · Haber: {value3}",
    "generate_issued_invoices_for_value0_selected_members_with_active_recurring": "¿Generar facturas emitidas para la selección de socios ({value0}) con plantillas recurrentes activas? No se contabilizarán en el libro mayor.",
    "will_bill_value0_mapped_items": "Elementos con asignación contable que se facturarán: {value0}.",
    "will_skip_value0_unmapped_items": "Elementos sin asignación contable que se omitirán: {value0}.",
    "key_value0": "(clave: {value0})",
    "club_run_complete_value0_generated_value1_failed": "Proceso del club finalizado. Facturas generadas: {value0}; fallidas: {value1}.",
    "of_value0_members": "de un total de socios de {value0}",
    "period_value0_outstanding_value1": "Período: {value0} · Pendiente: {value1}",
    "value0_lines": "Líneas: {value0}",
    "value0_value1_lines": "{value0} · Líneas: {value1}",
    "statement_preview_value0": "Vista previa del extracto: {value0}",
    "projected_for_value0": "Previsto para {value0}",
    "outstanding_value0": "Pendiente: {value0}",
    "value0_scheduled": "Programado: {value0}",
    "billing_period_value0value1": "Período de facturación: {value0}{value1}",
    "total_billed_value0": "Total facturado: {value0}",
    "paid_value0": "Pagado: {value0}",
    "outstanding_value0_2": "Pendiente: {value0}",
    "invoices_value0": "Facturas: {value0}",
    "this_will_create_payments_for_open_invoices_totalling_value0": "Se crearán pagos para facturas pendientes por un total de {value0}.",
    "sale_value0": "Venta {value0}",
    "membership_type_value0": "Tipo de socio: {value0}. ",
    "key_value0_2": "Clave: {value0}",
    "count_value0": "Recuento: {value0}",
    "blockers_value0": "Bloqueos: {value0}",
    "warnings_value0": "Advertencias: {value0}",
    "passed_value0": "Comprobaciones superadas: {value0}",
    "confidence_value0_2": "Confianza: {value0}",
    "value0_passed_checks": "Comprobaciones superadas: {value0}",
    "value0_skipped_checks": "Comprobaciones omitidas: {value0}",
    "close_fyvalue0": "¿Cerrar el ejercicio {value0}?",
    "receivables": "Cuentas a cobrar",
    "all_fiscal_periods_are_locked": "Todos los períodos del ejercicio están bloqueados",
    "all_accounting_periods_in_the_fiscal_year_must_be_locked": "Todos los períodos contables del ejercicio deben estar bloqueados antes del cierre anual.",
    "period_control": "Control de períodos",
    "no_draft_invoices": "Sin facturas en borrador",
    "draft_or_unposted_invoices_in_the_fiscal_year_must_be": "Las facturas en borrador o sin contabilizar del ejercicio deben contabilizarse o anularse.",
    "transaction_completeness": "Integridad de las transacciones",
    "no_draft_ap_bills": "Sin facturas de proveedor en borrador",
    "draft_ap_bills_in_the_fiscal_year_must_be_posted": "Las facturas de proveedor en borrador del ejercicio deben contabilizarse o anularse.",
    "no_draft_journals": "Sin asientos en borrador",
    "journal_entries_in_draftunposted_status_must_be_posted_before_yearend": "Los asientos en borrador o sin contabilizar deben contabilizarse antes del cierre anual.",
    "journals_are_balanced": "Los asientos están equilibrados",
    "total_debits_and_credits_must_match_for_each_journal_entry": "El total del debe y del haber debe coincidir en cada asiento del ejercicio.",
    "control_accounts_configured": "Cuentas de control configuradas",
    "required_controldefault_accounts_in_accounting_settings_must_be_configured": "Deben configurarse las cuentas de control y predeterminadas obligatorias en la configuración contable.",
    "configuration": "Configuración",
    "applicable_revenue_mappings_configured": "Asignaciones de ingresos aplicables configuradas",
    "applicable_active_revenue_mappings_must_have_required_gl_accounts": "Las asignaciones de ingresos activas aplicables deben tener las cuentas del libro mayor obligatorias.",
    "bank_reconciliations_complete": "Conciliaciones bancarias completadas",
    "active_bank_accounts_should_be_reconciled_through_fiscal_year_end": "Las cuentas bancarias activas deben estar conciliadas hasta el final del ejercicio.",
    "banking_cash": "Bancos y efectivo",
    "receivables_reviewed": "Cuentas a cobrar revisadas",
    "open_receivables_overdue_as_of_fiscal_year_end_should_be": "Deben revisarse las cuentas a cobrar pendientes vencidas al cierre del ejercicio.",
    "review_items": "Elementos que revisar",
    "ap_aging_reviewed": "Antigüedad de cuentas a pagar revisada",
    "overdue_ap_bills_as_of_fiscal_year_end_should_be": "Deben revisarse las facturas de proveedor vencidas al cierre del ejercicio.",
    "unapplied_payments_reviewed": "Pagos sin aplicar revisados",
    "member_payments_with_unapplied_amounts_should_be_reviewed": "Deben revisarse los pagos de socios con importes sin aplicar.",
    "clearing_accounts_reviewed": "Cuentas transitorias revisadas",
    "clearing_account_balances_should_be_zeroed_at_fiscal_year_end": "Los saldos de las cuentas transitorias deben quedar a cero al cierre del ejercicio.",
    "club_operations": "Operaciones del club",
    "not_applicable_for_this_clubmodule_configuration": "No se aplica a esta configuración del club o del módulo.",
    "all_fiscal_year_periods_must_be_locked": "Todos los períodos del ejercicio deben estar bloqueados.",
    "review_periods": "Revisar períodos",
    "all_fiscal_year_periods_are_locked": "Todos los períodos del ejercicio están bloqueados.",
    "no_draft_or_unposted_invoices_remain": "No quedan facturas en borrador ni sin contabilizar.",
    "no_draft_or_unposted_ap_bills_remain": "No quedan facturas de proveedor en borrador ni sin contabilizar.",
    "review_ap": "Revisar cuentas a pagar",
    "no_draft_or_unposted_journals_remain": "No quedan asientos en borrador ni sin contabilizar.",
    "review_gl": "Revisar libro mayor",
    "journals_tables_are_unavailable_in_this_environment": "Las tablas de asientos no están disponibles en este entorno.",
    "value0_journal_entries_are_unbalanced": "Asientos descuadrados: {value0}.",
    "all_journals_are_balanced": "Todos los asientos están equilibrados.",
    "accounting_settings_table_unavailable": "La tabla de configuración contable no está disponible.",
    "missing_control_account_mappings_value0": "Faltan asignaciones de cuentas de control: {value0}.",
    "accounting_settings_2": "Configuración contable",
    "required_control_accounts_are_configured": "Las cuentas de control obligatorias están configuradas.",
    "value0_applicable_revenue_mappings_are_missing_gl_accounts": "Asignaciones de ingresos aplicables sin cuentas del libro mayor: {value0}.",
    "revenue_mappings_2": "Asignaciones de ingresos",
    "applicable_revenue_mappings_are_configured": "Las asignaciones de ingresos aplicables están configuradas.",
    "bank_reconciliation_readiness_source_is_not_implemented_yet": "La fuente de preparación de conciliación bancaria todavía no está implementada.",
    "invoices_table_unavailable": "La tabla de facturas no está disponible.",
    "value0_receivables_are_overdue_as_of_fiscal_year_end": "Cuentas a cobrar vencidas al cierre del ejercicio: {value0}.",
    "no_overdue_receivables_as_of_fiscal_year_end": "No hay cuentas a cobrar vencidas al cierre del ejercicio.",
    "ap_bills_table_unavailable": "La tabla de facturas de proveedor no está disponible.",
    "value0_ap_bills_are_overdue_as_of_fiscal_year_end": "Facturas de proveedor vencidas al cierre del ejercicio: {value0}.",
    "no_overdue_ap_bills_as_of_fiscal_year_end": "No hay facturas de proveedor vencidas al cierre del ejercicio.",
    "payments_table_unavailable": "La tabla de pagos no está disponible.",
    "value0_unapplied_member_payments_remain": "Pagos de socios pendientes de aplicar: {value0}.",
    "no_unapplied_member_payments_remain": "No quedan pagos de socios sin aplicar.",
    "clearing_account_balance_helper_is_not_available": "La utilidad de saldos de cuentas transitorias no está disponible.",
    "value0_readiness_source_is_not_implemented_yet": "La fuente de preparación de {value0} todavía no está implementada.",
    "value0_source_table_is_unavailable": "La tabla de origen {value0} no está disponible.",
    "value0_value1_records_need_posting_or_settlement_review": "Registros de {value1} que requieren revisión contable o de liquidación: {value0}.",
    "open_module": "Abrir módulo",
    "value0_revenue_appears_settled_for_the_fiscal_year": "Los ingresos de {value0} parecen liquidados para el ejercicio.",
    "value0_table_unavailable": "La tabla {value0} no está disponible.",
    "value0_records_are_still_draft_or_unposted": "Registros todavía en borrador o sin contabilizar: {value0}.",
    "check_skipped_because_supporting_tables_are_unavailable_in_this_environment": "Comprobación omitida porque las tablas necesarias no están disponibles en este entorno.",
    "paid_value0_bills_updated_value1": "Pagado: {value0} · Facturas de proveedor actualizadas: {value1}",
    "allocated_value0_unapplied_value1": "Aplicado: {value0} · Sin aplicar: {value1}",
    "value0_must_be_a_positive_number": "{value0} debe ser un número positivo.",
    "value0_transactionvalue1_updated": "Transacciones actualizadas: {value0}.",
    "imported_value0_rows_skipped_value1_duplicates": "Filas importadas: {value0}. Duplicados omitidos: {value1}.",
    "value0_has_been_closed": "Se ha cerrado {value0}.",
    "value0_has_been_locked": "Se ha bloqueado {value0}.",
    "maximum_refundable_amount_is_value0": "El importe máximo reembolsable es {value0}.",
    "unable_to_resolve_this_value0_booking_source": "No se pudo obtener el origen de esta reserva de {value0}.",
    "fiscal_year_value0_closed": "Ejercicio {value0} cerrado",
    "employment_details_could_not_be_saved": "No se pudieron guardar los datos laborales.",
    "pay_and_rate_details_could_not_be_saved": "No se pudieron guardar los datos salariales y de tarifas.",
    "payment_details_could_not_be_saved": "No se pudieron guardar los datos de pago.",
    "tax_ni_readiness_could_not_be_saved": "No se pudo guardar la preparación fiscal / NI.",
    "pension_details_could_not_be_saved": "No se pudieron guardar los datos de pensiones.",
    "action_failed": "La acción ha fallado.",
    "confirmed": "confirmada",
    "loading_2": "cargando",
    "images_must_be_5_mb_or_less": "Las imágenes deben tener 5 MB o menos.",
    "tennis": "Tenis",
    "padel": "Pádel",
    "pickleball": "Pickleball",
    "squash": "Squash",
    "closed_2": "cerrado",
    "club_member": "Socio del club",
    "staff_member_3": "Empleado",
    "created_2": "Creado",
    "units": "unidades",
    "posted_3": "Contabilizada",
    "void_2": "Anulado",
    "error": "Error",
    "queued": "En cola",
    "matched_2": "Coincidencia encontrada",
    "approved": "Aprobado",
    "complete": "Completado",
    "processing_2": "Procesando",
    "ready_2": "Listo",
    "too_large": "Demasiado grande",
    "uncategorized": "Sin categoría",
    "primary_contact_2": "Contacto principal",
    "contract": "Contrato",
    "s": "s",
    "original_2": "original",
    "reset": "restablecidos",
    "unknown_time": "hora desconocida",
    "voicemail": "Buzón de voz",
    "polo": "Polo",
    "facilities_2": "instalaciones",
    "weddings": "Bodas",
    "off": "de descuento",
    "apply_uk_tax_defaults": "Aplicar valores fiscales predeterminados del Reino Unido",
    "unknown_2": "desconocido",
    "edit_2": "editar",
    "view_2": "ver",
    "extension": "Extensión",
    "unable_to_save_business_hours": "No se pudo guardar el horario comercial",
    "unable_to_load_hold_audio": "No se pudo cargar el audio en espera",
    "recording_policy": "Política de grabación",
    "ivr": "IVR",
    "ring_all": "Llamar a todos",
    "untitled_ivr": "IVR sin título",
    "untitled_queue": "Cola sin título",
    "queue": "Cola",
    "value_2": "de valor",
    "answered": "contestada",
    "name_is_required": "El nombre es obligatorio",
    "booked": "reservas",
    "removed": "eliminados",
    "unchanged": "sin cambios",
    "unable_to_resolve_attendee_pricing": "No se pudo calcular el precio del participante.",
    "guest_name_is_required_2": "El nombre del invitado es obligatorio.",
    "guest_email_is_required": "El correo electrónico del invitado es obligatorio.",
    "guest_phone_is_required": "El teléfono del invitado es obligatorio.",
    "for": "Para",
    "weddings_2": "bodas",
    "expires": "Vence",
    "guest_4": "huésped",
    "rooms": "habitaciones",
    "hotel_rooms": "Hotel / Habitaciones",
    "front_desk_checkin_kiosk": "Quiosco de entrada de recepción",
    "selected_room": "habitación seleccionada",
    "gross_payroll_amount": "Nómina bruta: {amount}",
    "variance_vs_previous_month_amount": "Variación respecto al mes anterior: {amount}",
    "department_name": "Departamento: {name}",
    "employee_count_count": "Número de empleados: {count}",
    "percentage_of_payroll_percent": "Porcentaje de la nómina: {percent}%",
    "imported_draft_timesheets_count": "Partes de horas en borrador importados: {count}.",
    "payslips_portal_publish_complete_published_published_existing_already_published_skipped": "Publicación de nóminas en el portal completada: {published} publicadas, {existing} ya publicadas y {skipped} omitidas porque no hay un PDF individual disponible.",
    "move_this_payroll_run_back_to_stage_finance_previews_may": "¿Desea devolver esta ejecución de nómina a {stage}? Las vistas previas contables pueden eliminarse.",
    "payroll_defaults_refreshed_jurisdiction_jurisdiction_created_created_updated_updated_preserved": "Valores predeterminados de nómina actualizados. Jurisdicción: {jurisdiction}. Creados: {created}; actualizados: {updated}; conservados: {preserved}; restablecidos: {reset}. Las personalizaciones se conservan salvo que se restablezca la regla seleccionada.",
    "x_days_after_period_end": "X días después del final del período",
    "resolve_open_blockers_before_posting_to_accounting": "Resuelva los bloqueos pendientes antes de contabilizar.",
    "vat_gl_mappings_verified": "Asignaciones de IVA al libro mayor verificadas",
    "preview_only_2": "solo vista previa",
    "current_period_3": "período actual"
  },
  "paymentMethods": {
    "cash": "Efectivo",
    "card": "Tarjeta",
    "bank_transfer": "Transferencia bancaria",
    "check": "Cheque",
    "ach": "ACH",
    "wire": "Transferencia electrónica",
    "other": "Otro",
    "apple_pay": "Apple Pay",
    "google_pay": "Google Pay"
  },
  "errors": {
    "invalid_amount": "Introduce un importe mayor que cero.",
    "invalid_payment_amount": "Introduce un importe de pago válido mayor que cero.",
    "invalid_payment_method": "Selecciona una forma de pago admitida.",
    "invalid_payload": "Comprueba el club y el registro contable seleccionados e inténtalo de nuevo.",
    "forbidden": "No tienes permiso para realizar esta acción contable.",
    "club_not_found": "No se encontró el club seleccionado. Selecciona el club de nuevo.",
    "receivable_not_found": "Esta cuenta a cobrar no está disponible. Actualiza el historial de la cuenta antes de volver a intentarlo.",
    "usage_charge_not_invoiced": "Este cargo todavía no se ha facturado. Se podrá pagar cuando el proceso de facturación genere una factura.",
    "allocation_exceeds_balance": "La aplicación supera el saldo pendiente. Actualiza el saldo y reduce el importe aplicado.",
    "allocation_exceeds_payment": "Las aplicaciones superan el importe del pago. Reduce las aplicaciones antes de continuar.",
    "allocation_exceeds_credit": "Las aplicaciones superan el saldo a favor disponible. Actualiza el saldo y reduce las aplicaciones.",
    "allocation_exceeds_outstanding": "La aplicación supera el importe pendiente. Actualiza el saldo y reduce el importe aplicado.",
    "request": "Solicitud: {id}",
    "invalid_club_code": "Comprueba el club y el registro contable seleccionados e inténtalo de nuevo.",
    "bank_transactions_import_failed": "No se pudo importar el extracto. Revisa el archivo y la asignación de columnas antes de intentarlo de nuevo.",
    "bank_import_preset_fetch_failed": "La configuración de importación bancaria no está disponible. Inténtalo de nuevo o revisa las columnas manualmente.",
    "bank_import_preset_save_failed": "La configuración de importación bancaria no está disponible. Inténtalo de nuevo o revisa las columnas manualmente.",
    "supplier_not_found": "Selecciona un proveedor disponible antes de continuar.",
    "invalid_supplier": "Selecciona un proveedor disponible antes de continuar.",
    "accounting_ap_payments_fetch_failed": "No se pudieron cargar los pagos a proveedores. Actualiza la lista de pagos.",
    "accounting_supplier_statement_failed": "No se pudo generar el extracto del proveedor. Revisa las fechas e inténtalo de nuevo.",
    "accounting_ap_bills_fetch_failed": "No se pudieron cargar las facturas de proveedor. Actualiza la lista antes de continuar.",
    "accounting_ap_ageing_fetch_failed": "No se pudo cargar la antigüedad de proveedores. Actualiza el informe.",
    "accounting_ap_ageing_detail_failed": "No se pudo cargar la antigüedad de proveedores. Actualiza el informe.",
    "ap_bill_missing_lines": "Añade al menos una línea válida a la factura del proveedor antes de contabilizar.",
    "invalid_bill_lines": "Añade al menos una línea válida a la factura del proveedor antes de contabilizar.",
    "ap_bill_create_failed": "No se pudo crear la factura del proveedor. Revisa los campos y comprueba si ya existe antes de intentarlo de nuevo.",
    "accounting_ap_bill_create_failed": "No se pudo crear la factura del proveedor. Revisa los campos y comprueba si ya existe antes de intentarlo de nuevo.",
    "ap_bill_not_found": "Una o más facturas de proveedor seleccionadas no están disponibles. Actualiza la lista y selecciónalas de nuevo.",
    "ap_bills_not_found": "Una o más facturas de proveedor seleccionadas no están disponibles. Actualiza la lista y selecciónalas de nuevo.",
    "invalid_bill_ids": "Una o más facturas de proveedor seleccionadas no están disponibles. Actualiza la lista y selecciónalas de nuevo.",
    "ap_bill_locked": "Esta factura de proveedor no se puede modificar en su estado actual. Revisa su historial de contabilización y pagos.",
    "invalid_bill_status": "Esta factura de proveedor no se puede modificar en su estado actual. Revisa su historial de contabilización y pagos.",
    "accounting_ap_bill_fetch_failed": "No se pudo cargar la factura del proveedor. Actualiza sus detalles.",
    "ap_bill_void_failed": "No se pudo anular la factura del proveedor. Revisa sus aplicaciones y estado contable.",
    "ap_payment_create_failed": "No se pudo registrar el pago al proveedor. Comprueba los pagos existentes antes de intentarlo de nuevo.",
    "no_outstanding_balance": "No hay saldo pendiente que liquidar. Actualiza los registros seleccionados.",
    "invalid_allocation": "Revisa los destinatarios y los importes de las aplicaciones antes de continuar.",
    "invalid_allocation_target": "Revisa los destinatarios y los importes de las aplicaciones antes de continuar.",
    "ap_payment_not_found": "Este pago no está disponible. Actualiza el historial de pagos.",
    "payment_not_found": "Este pago no está disponible. Actualiza el historial de pagos.",
    "ap_refund_create_failed": "No se pudo registrar el reembolso. Comprueba el historial de pagos antes de intentarlo de nuevo.",
    "refund_payment_create_failed": "No se pudo registrar el reembolso. Comprueba el historial de pagos antes de intentarlo de nuevo.",
    "accounting_settings_fetch_failed": "Revisa la configuración contable y las cuentas de control, ingresos y pagos seleccionadas.",
    "invalid_accounting_settings_value": "Revisa la configuración contable y las cuentas de control, ingresos y pagos seleccionadas.",
    "invalid_accounting_settings_accounts": "Revisa la configuración contable y las cuentas de control, ingresos y pagos seleccionadas.",
    "invalid_fiscal_year_start_month": "Selecciona un mes de inicio del ejercicio entre 1 y 12.",
    "tax_profile_fetch_failed": "No se pudo cargar o guardar la configuración fiscal. Revisa la configuración del club e inténtalo de nuevo.",
    "tax_profile_update_failed": "No se pudo cargar o guardar la configuración fiscal. Revisa la configuración del club e inténtalo de nuevo.",
    "tax_defaults_apply_failed": "No se pudo cargar o guardar la configuración fiscal. Revisa la configuración del club e inténtalo de nuevo.",
    "tax_codes_fetch_failed": "No se pudo completar la operación del código fiscal. Revisa el código y sus referencias antes de intentarlo de nuevo.",
    "tax_codes_create_failed": "No se pudo completar la operación del código fiscal. Revisa el código y sus referencias antes de intentarlo de nuevo.",
    "tax_codes_update_failed": "No se pudo completar la operación del código fiscal. Revisa el código y sus referencias antes de intentarlo de nuevo.",
    "tax_codes_delete_failed": "No se pudo completar la operación del código fiscal. Revisa el código y sus referencias antes de intentarlo de nuevo.",
    "invalid_tax_rate": "Introduce un tipo impositivo válido que corresponda al tratamiento fiscal previsto.",
    "invalid_effective_dates": "La fecha final de vigencia no puede ser anterior a la fecha inicial.",
    "invalid_category": "Selecciona una categoría fiscal disponible.",
    "tax_code_exists": "Este código fiscal ya existe. Elige un código único.",
    "tax_code_not_found": "Este código fiscal no está disponible. Actualiza la lista.",
    "invoice_layout_fetch_failed": "No se pudo cargar o guardar el diseño de factura. Revisa la configuración e inténtalo de nuevo.",
    "invoice_layout_save_failed": "No se pudo cargar o guardar el diseño de factura. Revisa la configuración e inténtalo de nuevo.",
    "invalid_billing_email": "Introduce una dirección de correo de facturación válida o deja el campo vacío.",
    "invalid_accent_hex_color": "Introduce un color de acento HEX válido.",
    "member_not_found": "El socio o su cuenta no están disponibles. Actualiza la selección de socio.",
    "member_account_not_found": "El socio o su cuenta no están disponibles. Actualiza la selección de socio.",
    "member_membership_type_missing": "Establece un tipo de socio antes de inscribirlo.",
    "membership_type_frequency_ambiguous": "Elige una frecuencia de facturación explícita durante la inscripción.",
    "membership_type_dues_required": "Introduce una cuota mayor que cero o configura las cuotas del tipo de socio.",
    "membership_type_frequency_required": "Selecciona una frecuencia mensual, trimestral o anual antes de activar la facturación recurrente.",
    "membership_type_quarterly_dues_unsupported": "Introduce un importe trimestral explícito o utiliza un período mensual o anual.",
    "missing_vat_gl_account": "Configura la cuenta de IVA repercutido de los códigos fiscales afectados antes de contabilizar.",
    "journal_entry_create_failed": "No se pudo crear el asiento. Comprueba el historial y las asignaciones antes de intentarlo de nuevo.",
    "missing_recipient_email": "Establece un correo del destinatario antes de enviar la factura.",
    "missing_resend_api_key": "El envío de correo no está configurado. La factura sigue disponible; contacta con un administrador.",
    "statement_total_zero": "Este extracto no tiene importes pendientes facturables. Revisa el período seleccionado.",
    "invoice_create_failed": "No se pudo generar la factura. Comprueba la lista de facturas antes de intentarlo de nuevo para evitar duplicados.",
    "generate_invoice_failed": "No se pudo generar la factura. Comprueba la lista de facturas antes de intentarlo de nuevo para evitar duplicados.",
    "recurring_billing_settings_fetch_failed": "No se pudo cargar o guardar la configuración de facturación recurrente. Revísala e inténtalo de nuevo.",
    "recurring_billing_settings_update_failed": "No se pudo cargar o guardar la configuración de facturación recurrente. Revísala e inténtalo de nuevo.",
    "recurring_billing_runs_fetch_failed": "No se pudo cargar el proceso de facturación. Actualiza la lista o sus detalles.",
    "recurring_billing_run_detail_failed": "No se pudo cargar el proceso de facturación. Actualiza la lista o sus detalles.",
    "run_not_found": "Este proceso no está disponible. Actualiza la lista.",
    "payroll_run_not_found": "Este proceso no está disponible. Actualiza la lista.",
    "invalid_payment_date": "Introduce una fecha de pago válida.",
    "record_run_payments_failed": "No se pudieron registrar los pagos del proceso. Revisa el historial antes de intentarlo de nuevo.",
    "recurring_billing_templates_fetch_failed": "No se pudieron cargar o actualizar las inscripciones de facturación. Actualiza la selección y reintenta solo los elementos fallidos.",
    "recurring_billing_enrollments_fetch_failed": "No se pudieron cargar o actualizar las inscripciones de facturación. Actualiza la selección y reintenta solo los elementos fallidos.",
    "recurring_billing_enrollments_bulk_failed": "No se pudieron cargar o actualizar las inscripciones de facturación. Actualiza la selección y reintenta solo los elementos fallidos.",
    "invalid_period": "Selecciona un período de facturación válido.",
    "invalid_billing_period": "Selecciona un período de facturación válido.",
    "recurring_billing_member_detail_fetch_failed": "No se pudo cargar la vista previa de facturación del socio. Actualiza el extracto seleccionado.",
    "recurring_billing_invoice_preview_failed": "No se pudo cargar la vista previa de facturación del socio. Actualiza el extracto seleccionado.",
    "recurring_billing_current_run_preview_failed": "No se pudo cargar la vista previa de facturación del socio. Actualiza el extracto seleccionado.",
    "generate_and_send_invoice_failed": "No se pudo generar o entregar la factura. Comprueba Facturación y el estado de envío antes de intentarlo de nuevo.",
    "generate_club_run_failed": "No se pudo finalizar el proceso de facturación del club. Revisa las facturas generadas y los fallos por socio antes de reintentar.",
    "recurring_billing_run_due_failed": "No se pudo finalizar el proceso de facturación del club. Revisa las facturas generadas y los fallos por socio antes de reintentar.",
    "charge_cannot_change_billing_run": "Este cargo no se puede mover a otro proceso de facturación en su estado actual.",
    "charge_not_found": "Este cargo no está disponible. Actualiza el extracto.",
    "charge_billing_run_update_failed": "No se pudo actualizar la ubicación de facturación de este cargo. Actualiza el extracto antes de intentarlo de nuevo.",
    "charge_exclude_failed": "No se pudo actualizar la ubicación de facturación de este cargo. Actualiza el extracto antes de intentarlo de nuevo.",
    "charge_defer_failed": "No se pudo actualizar la ubicación de facturación de este cargo. Actualiza el extracto antes de intentarlo de nuevo.",
    "charge_include_failed": "No se pudo actualizar la ubicación de facturación de este cargo. Actualiza el extracto antes de intentarlo de nuevo.",
    "confirmation_required": "Completa la confirmación obligatoria antes de continuar.",
    "recurring_template_validation_failed": "Revisa la plantilla recurrente, el importe positivo de la cuota, el estado activo y la frecuencia.",
    "template_not_found": "Revisa la plantilla recurrente, el importe positivo de la cuota, el estado activo y la frecuencia.",
    "template_not_active": "Revisa la plantilla recurrente, el importe positivo de la cuota, el estado activo y la frecuencia.",
    "accounting_invoices_fetch_failed": "No se pudo cargar o descargar la factura. Actualiza la lista e inténtalo de nuevo.",
    "accounting_invoice_fetch_failed": "No se pudo cargar o descargar la factura. Actualiza la lista e inténtalo de nuevo.",
    "invoice_download_failed": "No se pudo cargar o descargar la factura. Actualiza la lista e inténtalo de nuevo.",
    "invoice_not_found": "Esta factura no está disponible. Actualiza la lista.",
    "invoice_not_editable": "Esta factura no se puede editar en su estado actual. Utiliza el proceso existente de abono o reversión cuando corresponda.",
    "invalid_invoice_status": "Esta factura no se puede editar en su estado actual. Utiliza el proceso existente de abono o reversión cuando corresponda.",
    "missing_invoice_currency": "La factura no tiene moneda. Revisa su configuración de origen antes de contabilizar.",
    "invoice_missing_lines": "Añade líneas de factura válidas antes de contabilizar.",
    "missing_accounting_settings": "Completa las cuentas de control y las asignaciones de ingresos o nóminas obligatorias antes de contabilizar.",
    "missing_mappings": "Completa las cuentas de control y las asignaciones de ingresos o nóminas obligatorias antes de contabilizar.",
    "missing_tax_code_on_taxable_line": "Selecciona un código fiscal vigente para cada línea sujeta a impuestos antes de contabilizar.",
    "invoice_amount_mismatch": "Los totales de la factura no coinciden con las líneas de origen. Actualiza y revisa las líneas antes de contabilizar.",
    "journal_not_balanced": "El debe y el haber no coinciden. Revisa las líneas del asiento y sus asignaciones antes de contabilizar.",
    "payroll_finance_preview_not_balanced": "El debe y el haber no coinciden. Revisa las líneas del asiento y sus asignaciones antes de contabilizar.",
    "refund_exceeds_allocated_amount": "El reembolso supera el importe reembolsable. Actualiza el pago y revisa sus aplicaciones antes de reducir el reembolso.",
    "refund_exceeds_total_refundable": "El reembolso supera el importe reembolsable. Actualiza el pago y revisa sus aplicaciones antes de reducir el reembolso.",
    "refund_exceeds_invoice_amount": "El reembolso supera el importe reembolsable. Actualiza el pago y revisa sus aplicaciones antes de reducir el reembolso.",
    "refund_exceeds_unapplied_amount": "El reembolso supera el importe reembolsable. Actualiza el pago y revisa sus aplicaciones antes de reducir el reembolso.",
    "invalid_bank_account": "Selecciona una cuenta bancaria disponible con la asignación contable requerida.",
    "payment_create_failed": "No se pudo registrar el pago. Revisa los pagos existentes antes de intentarlo de nuevo.",
    "accounting_member_summary_failed": "No se pudieron cargar las cuentas a cobrar. Actualiza la lista antes de continuar.",
    "receivables_summary_fetch_failed": "No se pudieron cargar las cuentas a cobrar. Actualiza la lista antes de continuar.",
    "receivables_fetch_failed": "No se pudieron cargar las cuentas a cobrar. Actualiza la lista antes de continuar.",
    "receivable_fetch_failed": "No se pudieron cargar las cuentas a cobrar. Actualiza la lista antes de continuar.",
    "member_ar_backfill_failed": "No se pudo cargar la cuenta del socio. Actualízala y comprueba su historial antes de continuar.",
    "member_ar_accounts_fetch_failed": "No se pudo cargar la cuenta del socio. Actualízala y comprueba su historial antes de continuar.",
    "member_ar_summary_fetch_failed": "No se pudo cargar la cuenta del socio. Actualízala y comprueba su historial antes de continuar.",
    "member_ar_account_resolve_failed": "No se pudo cargar la cuenta del socio. Actualízala y comprueba su historial antes de continuar.",
    "member_ar_transactions_fetch_failed": "No se pudo cargar la cuenta del socio. Actualízala y comprueba su historial antes de continuar.",
    "member_ar_open_invoices_fetch_failed": "No se pudo cargar la cuenta del socio. Actualízala y comprueba su historial antes de continuar.",
    "source_not_found": "La transacción de origen no está disponible. Revisa la referencia o contacta con un administrador.",
    "source_resolve_failed": "La transacción de origen no está disponible. Revisa la referencia o contacta con un administrador.",
    "member_statement_fetch_failed": "No se pudo cargar o generar el extracto del socio. Revisa el intervalo de fechas e inténtalo de nuevo.",
    "member_statement_generate_failed": "No se pudo cargar o generar el extracto del socio. Revisa el intervalo de fechas e inténtalo de nuevo.",
    "invoice_not_allocatable": "La factura o cuenta a cobrar seleccionada no admite esta aplicación. Actualiza su saldo pendiente y estado.",
    "receivable_not_allocatable": "La factura o cuenta a cobrar seleccionada no admite esta aplicación. Actualiza su saldo pendiente y estado.",
    "invalid_invoice_ids": "La factura o cuenta a cobrar seleccionada no admite esta aplicación. Actualiza su saldo pendiente y estado.",
    "invoice_not_open": "La factura o cuenta a cobrar seleccionada no admite esta aplicación. Actualiza su saldo pendiente y estado.",
    "invalid_parent_payment": "Selecciona el pago original que admite este reembolso.",
    "invoice_required": "Selecciona la factura correspondiente antes de crear la nota de abono.",
    "credit_note_requires_invoice": "Selecciona la factura correspondiente antes de crear la nota de abono.",
    "credit_note_exceeds_invoice_amount": "El abono supera el importe disponible. Actualiza la factura o el saldo a favor y reduce el importe.",
    "credit_exceeds_available": "El abono supera el importe disponible. Actualiza la factura o el saldo a favor y reduce el importe.",
    "credit_note_missing_lines": "Añade al menos una línea válida a la nota de abono.",
    "credit_note_create_failed": "No se pudo completar la operación de la nota de abono. Actualiza la lista y revisa la factura antes de intentarlo de nuevo.",
    "credit_notes_fetch_failed": "No se pudo completar la operación de la nota de abono. Actualiza la lista y revisa la factura antes de intentarlo de nuevo.",
    "credit_note_fetch_failed": "No se pudo completar la operación de la nota de abono. Actualiza la lista y revisa la factura antes de intentarlo de nuevo.",
    "credit_note_not_found": "La nota de abono o el saldo a favor no están disponibles. Actualiza la cuenta.",
    "credit_not_found": "La nota de abono o el saldo a favor no están disponibles. Actualiza la cuenta.",
    "invalid_credit_note_status": "Esta nota de abono no se puede utilizar en su estado actual. Revisa su historial de contabilización y aplicaciones.",
    "credit_note_void_not_allowed": "Esta nota de abono no se puede utilizar en su estado actual. Revisa su historial de contabilización y aplicaciones.",
    "credit_note_not_posted": "Esta nota de abono no se puede utilizar en su estado actual. Revisa su historial de contabilización y aplicaciones.",
    "credit_note_void_failed": "No se pudo anular la nota de abono. Revisa sus aplicaciones antes de intentarlo de nuevo.",
    "credit_application_create_failed": "No se puede modificar la aplicación del abono de la forma solicitada. Actualiza su estado antes de intentarlo de nuevo.",
    "credit_application_not_found": "No se puede modificar la aplicación del abono de la forma solicitada. Actualiza su estado antes de intentarlo de nuevo.",
    "credit_application_already_void": "No se puede modificar la aplicación del abono de la forma solicitada. Actualiza su estado antes de intentarlo de nuevo.",
    "credit_application_not_applied": "No se puede modificar la aplicación del abono de la forma solicitada. Actualiza su estado antes de intentarlo de nuevo.",
    "period_locked": "La fecha contable pertenece a un período bloqueado o cerrado. Cambia la fecha o solicita un desbloqueo autorizado.",
    "gl_period_locked": "La fecha contable pertenece a un período bloqueado o cerrado. Cambia la fecha o solicita un desbloqueo autorizado.",
    "locked_period": "La fecha contable pertenece a un período bloqueado o cerrado. Cambia la fecha o solicita un desbloqueo autorizado.",
    "period_closed": "La fecha contable pertenece a un período bloqueado o cerrado. Cambia la fecha o solicita un desbloqueo autorizado.",
    "payroll_request_failed": "La solicitud de nómina falló. Actualiza el proceso y revisa su estado antes de intentarlo de nuevo.",
    "invalid_id": "El registro de nómina seleccionado no está disponible. Actualiza la selección.",
    "not_found": "El registro de nómina seleccionado no está disponible. Actualiza la selección.",
    "profile_not_found": "El registro de nómina seleccionado no está disponible. Actualiza la selección.",
    "department_not_found": "El registro de nómina seleccionado no está disponible. Actualiza la selección.",
    "name_required": "Introduce un nombre antes de guardar.",
    "unsupported_payment_jurisdiction": "Los datos de pago no se admiten en la jurisdicción configurada. Revisa la configuración de nóminas.",
    "replacement_reason_required": "Introduce un motivo antes de sustituir los datos de pago.",
    "invalid_rate_type": "Elige un tipo de tarifa o estado admitido antes de guardar.",
    "invalid_status": "Elige un tipo de tarifa o estado admitido antes de guardar.",
    "invalid_verification_status": "Elige un tipo de tarifa o estado admitido antes de guardar.",
    "payment_details_not_found": "Guarda los datos de pago antes de verificarlos.",
    "timesheet_locked": "Este parte de horas está bloqueado. Utiliza el proceso autorizado de reapertura antes de editarlo.",
    "timesheet_lines_required": "Añade líneas válidas al parte o la explicación obligatoria de horas cero.",
    "zero_hours_note_required": "Añade líneas válidas al parte o la explicación obligatoria de horas cero.",
    "run_not_recalculable": "Este proceso de nómina no se puede modificar en su estado actual. Revisa las acciones autorizadas de retroceso o reapertura.",
    "run_not_mutable": "Este proceso de nómina no se puede modificar en su estado actual. Revisa las acciones autorizadas de retroceso o reapertura.",
    "payroll_not_editable": "Este proceso de nómina no se puede modificar en su estado actual. Revisa las acciones autorizadas de retroceso o reapertura.",
    "payroll_locked": "Este proceso de nómina no se puede modificar en su estado actual. Revisa las acciones autorizadas de retroceso o reapertura.",
    "payroll_period_id_required": "Selecciona un período de nómina abierto disponible.",
    "period_not_found": "Selecciona un período de nómina abierto disponible.",
    "period_not_open": "Selecciona un período de nómina abierto disponible.",
    "duplicate_active_run": "Ya existe un proceso activo para este período. Abre el existente para evitar duplicados.",
    "blocker_not_found": "Este bloqueo o decisión ya no está disponible. Actualiza la revisión de nómina.",
    "decision_not_allowed": "Este bloqueo o decisión ya no está disponible. Actualiza la revisión de nómina.",
    "provider_deductions_not_required": "Este modo de nómina no requiere deducciones del proveedor. Revisa la fuente legal configurada.",
    "no_payroll_run_lines": "Actualiza las líneas de empleados calculadas antes de guardar los datos legales.",
    "duplicate_payroll_run_line_id": "Actualiza las líneas de empleados calculadas antes de guardar los datos legales.",
    "unknown_payroll_run_line_id": "Actualiza las líneas de empleados calculadas antes de guardar los datos legales.",
    "legacy_run_level_statutory_totals": "Los totales legales del proceso no son nóminas individuales. Introduce valores por empleado antes de generar las definitivas.",
    "statutory_inputs_stale": "La nómina se recalculó después de guardar los valores legales. Revisa e introduce de nuevo los datos legales por empleado.",
    "payroll_run_not_review_stage": "Lleva el proceso a su etapa de revisión antes de introducir valores legales.",
    "payroll_blockers_unresolved": "Resuelve los bloqueos de nómina antes de avanzar a la siguiente etapa.",
    "run_has_blockers": "Resuelve los bloqueos de nómina antes de avanzar a la siguiente etapa.",
    "employee_statutory_rows_missing": "Completa PAYE, NI del empleado y NI de la empresa de cada empleado incluido antes de continuar.",
    "employee_statutory_row_missing": "Completa PAYE, NI del empleado y NI de la empresa de cada empleado incluido antes de continuar.",
    "payroll_line_incomplete": "Completa PAYE, NI del empleado y NI de la empresa de cada empleado incluido antes de continuar.",
    "employee_statutory_row_incomplete": "Completa PAYE, NI del empleado y NI de la empresa de cada empleado incluido antes de continuar.",
    "payroll_line_final_values_missing": "Completa PAYE, NI del empleado y NI de la empresa de cada empleado incluido antes de continuar.",
    "payslip_totals_do_not_reconcile": "Los totales de las nóminas individuales no cuadran con el proceso. Revisa los valores legales por empleado y los totales.",
    "invalid_status_transition": "Este cambio de etapa no está permitido. Actualiza el proceso y utiliza la siguiente acción disponible.",
    "finance_posting_required": "Contabiliza el asiento de nómina antes de registrar el pago.",
    "gl_post_required": "Contabiliza el asiento de nómina antes de registrar el pago.",
    "payroll_not_ready_to_lock": "Completa la contabilización, las cuentas a pagar y el pago al personal antes de bloquear la nómina.",
    "provider_deductions_required": "Introduce los valores legales obligatorios facilitados por el proveedor antes de continuar.",
    "payroll_already_posted": "La nómina ya está contabilizada. Revisa el asiento existente y utiliza las acciones autorizadas de reversión cuando estén disponibles.",
    "tenant_schema_out_of_date": "La base de datos del club no está preparada para esta operación de nómina. Contacta con soporte e indica la referencia de solicitud.",
    "payslip_snapshot_locked": "Las instantáneas de nóminas emitidas están bloqueadas y no se pueden regenerar sin autorización.",
    "final_payslips_pdf_not_ready": "Genera PDF definitivos individuales válidos antes de publicarlos en el portal del personal.",
    "invalid_calculation_mode": "Revisa el modo de cálculo, la frecuencia y las fechas del calendario de nóminas antes de guardar.",
    "invalid_payroll_frequency": "Revisa el modo de cálculo, la frecuencia y las fechas del calendario de nóminas antes de guardar.",
    "invalid_default_payment_day": "Revisa el modo de cálculo, la frecuencia y las fechas del calendario de nóminas antes de guardar.",
    "invalid_approval_deadline_days": "Revisa el modo de cálculo, la frecuencia y las fechas del calendario de nóminas antes de guardar.",
    "invalid_next_run_date": "Revisa el modo de cálculo, la frecuencia y las fechas del calendario de nóminas antes de guardar.",
    "accounting_reports_fetch_failed": "No se pudo completar la operación del informe. Actualiza los informes guardados y revisa la configuración.",
    "accounting_reports_create_failed": "No se pudo completar la operación del informe. Actualiza los informes guardados y revisa la configuración.",
    "accounting_reports_update_failed": "No se pudo completar la operación del informe. Actualiza los informes guardados y revisa la configuración.",
    "accounting_reports_delete_failed": "No se pudo completar la operación del informe. Actualiza los informes guardados y revisa la configuración.",
    "missing_budget_version": "Selecciona un presupuesto y una versión disponibles antes de ejecutar este informe.",
    "missing_budget_params": "Selecciona un presupuesto y una versión disponibles antes de ejecutar este informe.",
    "budget_not_found": "Selecciona un presupuesto y una versión disponibles antes de ejecutar este informe.",
    "report_not_found": "Este informe no está disponible o su tipo no se admite. Selecciona un informe admitido.",
    "report_type_not_supported": "Este informe no está disponible o su tipo no se admite. Selecciona un informe admitido.",
    "invalid_date_range": "Introduce fechas de inicio y fin válidas y en el orden correcto.",
    "accounting_gl_month_end_tasks_fetch_failed": "No se pudo cargar la lista de comprobación del cierre mensual. Actualiza el período antes de continuar.",
    "invalid_entry_class": "Selecciona una clase de asiento admitida para esta excepción.",
    "member_receivables_balance_unresolved": "No se pudo determinar el saldo de las cuentas a cobrar del socio. Actualice la cuenta del socio antes de aplicar un pago.",
    "payroll_payment_encryption_config_invalid": "No se pueden procesar de forma segura los datos bancarios de nómina. Solicite a un administrador que revise la configuración de cifrado antes de reintentar.",
    "payroll_payment_kms_client_unavailable": "No se pueden procesar de forma segura los datos bancarios de nómina. Solicite a un administrador que revise la configuración de cifrado antes de reintentar.",
    "payroll_payment_kms_key_not_configured": "No se pueden procesar de forma segura los datos bancarios de nómina. Solicite a un administrador que revise la configuración de cifrado antes de reintentar.",
    "payroll_payment_kms_data_key_failed": "No se pueden procesar de forma segura los datos bancarios de nómina. Solicite a un administrador que revise la configuración de cifrado antes de reintentar.",
    "payroll_payment_kms_decrypt_failed": "No se pueden procesar de forma segura los datos bancarios de nómina. Solicite a un administrador que revise la configuración de cifrado antes de reintentar.",
    "account_holder_name_required": "Introduzca el nombre del titular de la cuenta bancaria.",
    "invalid_sort_code": "Introduzca un código bancario británico (sort code) válido de seis dígitos.",
    "invalid_account_number": "Introduzca un número de cuenta bancaria válido para el sistema de pago seleccionado.",
    "invalid_routing_number": "Introduzca un número de ruta bancaria estadounidense válido de nueve dígitos.",
    "account_number_required": "Introduzca el número de cuenta bancaria.",
    "invalid_account_type": "Elija un tipo de cuenta bancaria admitido.",
    "invalid_iban": "Introduzca un IBAN válido.",
    "unsupported_payment_scheme": "Este sistema de pago no se admite en la jurisdicción configurada para el club. Revise la configuración de nómina.",
    "payment_file_decryption_not_wired_until_approved_run_generation": "El descifrado del archivo bancario solo está disponible al generar una ejecución de nómina aprobada. Apruebe la ejecución antes de generar el archivo.",
    "invalid_billable_recurring_receivables_args": "Seleccione un club, un socio y un período de facturación válidos y vuelva a cargar el estado de cuenta.",
    "invalid_current_statement_args": "Seleccione un club, un socio y un período de facturación válidos y vuelva a cargar el estado de cuenta.",
    "tax_code_required": "Seleccione un código de impuesto para cada línea sujeta a impuestos antes de contabilizar.",
    "invalid_tax_code": "Un código de impuesto seleccionado no es válido o no está disponible para la fecha de contabilización. Revise las líneas afectadas y la configuración de impuestos.",
    "unsupported_revenue_source": "Este origen de ingresos no admite la contabilización solicitada. Abra la transacción de origen y revise el flujo admitido.",
    "posting_source_not_found": "No se encontró la transacción de origen de esta contabilización. Actualice el registro de origen antes de reintentar.",
    "original_batch_not_found": "No se encontró el lote de contabilización original. Revise el asiento de origen antes de solicitar una reversión."
  },
  "documents": {
    "invoice": "Factura",
    "date": "Fecha {date}",
    "due": "Vencimiento {date}",
    "billedTo": "Facturado a",
    "member": "Socio",
    "club": "Club",
    "description": "Descripción",
    "quantity": "Cant.",
    "unit": "Precio unit.",
    "total": "Total",
    "charge": "Cargo",
    "subtotal": "Subtotal",
    "tax": "Impuestos",
    "amountDue": "Importe pendiente",
    "thankYou": "¡Gracias por su confianza!",
    "greeting": "Hola, {name}:",
    "attached": "Adjuntamos la última factura de {club}.",
    "ready": "Tu factura de facturación recurrente {number} está disponible.",
    "amount": "Importe: {amount}",
    "dueDate": "Fecha de vencimiento: {date}",
    "contact": "Si tienes alguna pregunta, contacta con {club} en {contact}.",
    "thanks": "Gracias,",
    "subject": "Factura de {club} – {number}",
    "subjectWithoutNumber": "Tu factura de {club}",
    "unavailable": "No disponible",
    "draft": "BORRADOR",
    "payslipPayslip": "Nómina",
    "payslipEmployee": "Empleado",
    "payslipReference": "Referencia",
    "payslipJobtitle": "Puesto",
    "payslipDepartment": "Departamento",
    "payslipPayrollrun": "Ejecución de nómina",
    "payslipPayrollsourcereference": "Origen/referencia de nómina",
    "payslipPayment": "Pago",
    "payslipEarnings": "Devengos",
    "payslipBasepaysalary": "Salario base",
    "payslipOvertimepay": "Horas extraordinarias",
    "payslipHolidaypay": "Vacaciones retribuidas",
    "payslipSickpay": "Baja por enfermedad",
    "payslipGrosspay": "Salario bruto",
    "payslipDeductions": "Deducciones",
    "payslipPAYEIncomeTax": "Impuesto sobre la renta PAYE",
    "payslipEmployeeNationalInsurance": "Cotizaciones del empleado a National Insurance",
    "payslipEmployeePension": "Plan de pensiones del empleado",
    "payslipOtherEmployeeDeductions": "Otras deducciones del empleado",
    "payslipTotalDeductions": "Total de deducciones",
    "payslipNetpay": "Salario neto",
    "payslipEmployercontributions": "Aportaciones de la empresa",
    "payslipEmployerNationalInsurance": "Cotizaciones de la empresa a National Insurance",
    "payslipEmployerPension": "Plan de pensiones de la empresa",
    "payslipOtherEmployerCosts": "Otros costes de la empresa",
    "payslipTotalEmployerContributions": "Total de aportaciones de la empresa",
    "payslipThisisyourpayslipfortheperiodshownabove": "Esta es su nómina del período indicado arriba.",
    "payslipPeriod": "Período de nómina del {start} al {end}",
    "payslipPayDate": "Fecha de pago: {date}",
    "payslipBank": "Transferencia bancaria terminada en {last4}",
    "payslipTitle": "Nómina: {run}"
  },
  "lifecycle": {
    "included": "Incluido en {run}",
    "paidVia": "Pagado mediante {source}",
    "billingRun": "Proceso de facturación: {run}",
    "settledBy": "Liquidado mediante {source}"
  },
  "debtorTypes": {
    "member": "Socio",
    "guest": "Invitado",
    "ad_hoc": "Puntual",
    "supplier": "Proveedor",
    "company": "Empresa"
  },
  "confirmations": {
    "yearEnd": "Esta acción cierra el ejercicio y no se puede duplicar. Escribe {confirmation} para confirmar."
  },
  "batch": {
    "memberResult": "Socio {member}: elementos omitidos: {skipped}; con asignación contable: {mapped}.",
    "failure": "Socio {member}: {reason}",
    "recovery": "Revisa las facturas generadas y los fallos por socio antes de reintentar."
  },
  "csv": {
    "column": "Columna {number}",
    "parse": "No se pudo analizar el CSV. Comprueba las comillas y el número de columnas.",
    "quotes": "El CSV tiene comillas no válidas. Comprueba la fila {row}.",
    "delimiter": "No se pudo determinar el separador del CSV. Revisa el archivo.",
    "fields": "El número de campos no coincide con las columnas en la fila {row}.",
    "read": "No se pudo leer el archivo CSV. Selecciona un archivo válido.",
    "date": "Fila {row}: fecha no válida.",
    "description": "Fila {row}: falta la descripción.",
    "amount": "Fila {row}: importe no válido."
  },
  "enums": {
    "accountType": {
      "asset": "Activo",
      "liability": "Pasivo",
      "equity": "Patrimonio neto",
      "revenue": "Ingresos",
      "expense": "Gastos"
    },
    "period": {
      "open": "Abierto",
      "closed": "Cerrado",
      "locked": "Bloqueado",
      "ready": "Preparado",
      "blocked": "Bloqueado",
      "pass": "Superada",
      "fail": "Fallida",
      "warning": "Advertencia",
      "not_applicable": "No aplicable"
    },
    "payment": {
      "received": "Recibido",
      "paid": "Pagado",
      "pending": "Pendiente",
      "failed": "Fallido",
      "completed": "Completado",
      "refunded": "Reembolsado",
      "partially_refunded": "Reembolsado parcialmente",
      "void": "Anulado",
      "voided": "Anulado",
      "allocated": "Aplicado",
      "unapplied": "Sin aplicar",
      "partially_applied": "Aplicado parcialmente",
      "fully_applied": "Aplicado por completo"
    },
    "source": {
      "membership_dues": "Cuotas de socios",
      "membership": "Socios",
      "pos": "Restauración y bar",
      "dining": "Restauración y bar",
      "bar": "Restauración y bar",
      "events": "Eventos",
      "golf": "Golf",
      "spa": "Spa",
      "fitness": "Fitness",
      "polo": "Polo",
      "marina": "Puerto deportivo",
      "racquet": "Deportes de raqueta",
      "hotel": "Hotel",
      "rooms": "Hotel / Habitaciones",
      "lessons": "Clases",
      "pro_shop": "Tienda / Tienda de golf",
      "retail": "Tienda / Tienda de golf",
      "weddings": "Bodas",
      "member_account": "Cuenta del socio",
      "invoice": "Factura",
      "charge": "Cargo",
      "ad_hoc": "Puntual",
      "supplier": "Proveedor",
      "member": "Socio",
      "guest": "Invitado",
      "payroll": "Nóminas"
    },
    "frequency": {
      "weekly": "Semanal",
      "fortnightly": "Quincenal",
      "monthly": "Mensual",
      "quarterly": "Trimestral",
      "annual": "Anual",
      "annually": "Anualmente",
      "yearly": "Anual"
    },
    "payroll": {
      "draft": "Borrador",
      "review": "Revisión",
      "calculated": "Calculada",
      "awaiting_approval": "Pendiente de aprobación",
      "approved": "Aprobada",
      "posted": "Contabilizada",
      "paid": "Pagada",
      "locked": "Bloqueada",
      "ready": "Preparado",
      "active": "Activo",
      "inactive": "Inactivo",
      "missing_details": "Datos incompletos",
      "on_hold": "En espera",
      "leaver": "Baja",
      "verified": "Verificado",
      "unverified": "Sin verificar",
      "pending": "Pendiente",
      "missing": "Falta información",
      "not_ready": "No preparado",
      "preview_ready": "Vista previa preparada",
      "not_required": "No requerido",
      "enrolled": "Inscrito",
      "opted_out": "Baja voluntaria",
      "salary": "Salario",
      "hourly": "Por horas",
      "casual": "Eventual",
      "contractor": "Contratista",
      "hybrid": "Salario y ajustes",
      "submitted": "Presentado",
      "rejected": "Rechazado",
      "regular": "Ordinarias",
      "overtime": "Horas extra",
      "holiday": "Vacaciones",
      "sick": "Baja por enfermedad",
      "training": "Formación",
      "adjustment": "Ajuste",
      "checking": "Cuenta corriente",
      "savings": "Cuenta de ahorro",
      "fixed_day_of_month": "Día fijo del mes",
      "last_day_of_month": "Último día del mes",
      "last_working_day_of_month": "Último día laborable del mes",
      "days_after_period_end": "Días después del fin del período"
    },
    "billing": {
      "not_enrolled": "No inscrito",
      "enrolled": "Inscrito",
      "active": "Activo",
      "paused": "En pausa",
      "unbilled": "Sin facturar",
      "invoiced": "Facturado",
      "draft": "Borrador",
      "pending": "Pendiente",
      "issued": "Emitida",
      "posted": "Contabilizada",
      "open": "Pendiente",
      "paid": "Pagada",
      "part_paid": "Pagada parcialmente",
      "partially_paid": "Pagada parcialmente",
      "overdue": "Vencida",
      "sent": "Enviada",
      "failed": "Fallida",
      "skipped": "Omitido",
      "scheduled": "Programado",
      "excluded": "Excluido",
      "deferred": "Aplazado",
      "generated": "Generado",
      "included_current": "Incluido en el proceso actual",
      "included_future": "Incluido en un proceso futuro",
      "latest_dues_invoice_paid": "Última factura de cuotas pagada",
      "latest_dues_invoice_open": "Última factura de cuotas pendiente",
      "latest_dues_invoice_overdue": "Última factura de cuotas vencida",
      "projected_not_generated": "Previsto, sin generar"
    },
    "bank": {
      "unmatched": "Sin vincular",
      "partially_matched": "Vinculación parcial",
      "matched": "Vinculado",
      "reconciled": "Conciliado",
      "ignored": "Ignorado"
    },
    "reportStatus": {
      "draft": "Borrador",
      "open": "Abierto",
      "posted": "Contabilizado",
      "paid": "Pagado",
      "partially_paid": "Pagado parcialmente",
      "void": "Anulado",
      "refunded": "Reembolsado",
      "unpaid": "Sin pagar",
      "overdue": "Vencido",
      "reconciled": "Conciliado",
      "pending": "Pendiente",
      "approved": "Aprobado",
      "closed": "Cerrado"
    }
  },
  "match": {
    "supplier": "Proveedor: {name}",
    "member": "Socio: {name}"
  },
  "payroll": {
    "pensionSummary": "Proveedor {provider} • Empleado {employee} • Club {club}",
    "multiplier": "Multiplicador de {value}x",
    "periodRange": "{name} — {start}–{end}",
    "periodRangeWithPay": "{name} — {start}–{end} — Pago {pay}"
  },
  "glMemo": {
    "memberSale": "Venta TPV {sale} — {member}",
    "guestSale": "Venta TPV {sale} — Invitado",
    "sale": "Venta TPV {sale}",
    "golf": "Cargo por reserva de golf"
  },
  "validation": {
    "paymentRange": "El importe debe estar entre 0 y {amount}."
  },
  "billing": {
    "itemCountOne": "{count} elemento",
    "itemCountOther": "{count} elementos",
    "currentStatement": "Estado de cuenta actual ({period})",
    "moveBack": "Volver a este estado de cuenta",
    "nextRun": "Próxima ejecución de facturación",
    "futureRun": "Ejecución futura de facturación",
    "deferredFrom": "Aplazado desde {period}",
    "deferredEarlier": "Aplazado desde una facturación anterior",
    "mappingWarning": "Un cargo no tiene asignación contable de ingresos (clave: {key}). Configure la asignación antes de contabilizar.",
    "warning": "Revise esta advertencia de facturación antes de continuar."
  },
  "final": {
    "rows": "Filas",
    "schedule": "Programar",
    "saveSettings": "Guardar configuración",
    "required": "Obligatorio",
    "yearReadiness": "Preparación de {year}"
  },
  "yearEnd": {
    "closedBy": "Ejercicio cerrado el {date} por {person}",
    "closed": "Ejercicio cerrado el {date}"
  },
  "payrollExceptions": {
    "missing_calendar": {
      "title": "Falta el calendario de nómina",
      "description": "Asigne este empleado activo a un calendario de nómina."
    },
    "missing_rate": {
      "title": "Falta una tarifa activa",
      "description": "Añada una tarifa de nómina activa que cubra este período."
    },
    "profile_readiness": {
      "title": "Perfil pendiente de completar",
      "description": "Revise los datos bancarios, fiscales y del plan de pensiones del empleado."
    },
    "missing_approved_timesheet": {
      "title": "Falta un parte de horas aprobado",
      "description": "Apruebe el parte de horas del empleado o revise la confirmación permitida para esta ejecución antes de continuar."
    },
    "invalid_rate": {
      "title": "Salario fijo no válido",
      "description": "Los perfiles con salario fijo o híbrido necesitan una tarifa salarial para su componente fijo."
    },
    "holiday_unpaid": {
      "title": "Horas de vacaciones excluidas",
      "description": "Las reglas salariales actuales no incluyen vacaciones retribuidas."
    },
    "sick_unpaid": {
      "title": "Horas de baja excluidas",
      "description": "Las reglas salariales actuales no incluyen el pago por baja por enfermedad."
    },
    "missing_mapping": {
      "title": "Falta una asignación contable de nómina",
      "description": "Configure las cuentas de debe y haber de este coste o pasivo en la configuración de nómina."
    },
    "provider_deductions_required": {
      "title": "Se requieren importes reglamentarios",
      "description": "Revise y guarde los importes PAYE y de National Insurance del empleado y de la empresa suministrados por el proveedor para cada empleado antes de aprobar."
    },
    "employer_social_security_review": {
      "title": "Debe revisarse National Insurance de la empresa",
      "description": "Revise la configuración de las cotizaciones de la empresa antes de continuar con la nómina."
    }
  },
  "timesheets": {
    "missing": "Empleados con nómina según horas sin partes presentados para este período: {count}.",
    "awaiting": "Partes de horas presentados pendientes de aprobación para este período: {count}.",
    "overtime": "Las horas extraordinarias se concentran en el período de nómina seleccionado.",
    "approved": "Todos los partes de horas presentados para el período seleccionado están aprobados."
  },
  "periods": {
    "closeEarlier": "Cierre {periods} antes de cerrar {period}.",
    "earlierRequired": "Primero deben cerrarse los períodos contables anteriores.",
    "fiscalMonth": "Ejercicio {year}, mes {month}"
  },
  "defaults": {
    "summary": "Jurisdicción: {jurisdiction}. Asignaciones de ingresos, IVA y nómina y cuentas de control verificadas. Asignaciones de IVA actualizadas: {tax}. Políticas de nómina revisadas: {policies}. Se han conservado las personalizaciones existentes.",
    "uk": "Reino Unido",
    "us": "Estados Unidos",
    "region": "Región de nómina del club"
  },
  "portalCategories": {
    "membership": "Membresía",
    "dining": "Restauración y bar",
    "golf": "Golf",
    "spa": "Spa",
    "racquet": "Deportes de raqueta",
    "fitness": "Fitness",
    "rooms": "Hotel / Habitaciones",
    "events": "Eventos",
    "other": "Otros cargos en cuenta"
  }
};
